// ── LEGO PALETTE ──────────────────────────────────────────────────────────────
const LEGO_COLORS = [
  {name:"Red",                 hex:"#C91A09"},
  {name:"Dark Red",            hex:"#720E0F"},
  {name:"Coral",               hex:"#FF7B7B"},
  {name:"Sand Red",            hex:"#7C5C62"},
  {name:"Reddish Brown",       hex:"#7A3300"},
  {name:"Dark Orange",         hex:"#A95500"},
  {name:"Orange",              hex:"#FE8A18"},
  {name:"Bright Light Orange", hex:"#F5A52A"},
  {name:"Brown",               hex:"#5E2400"},
  {name:"Dark Brown",          hex:"#3E2010"},
  {name:"Nougat",              hex:"#D09168"},
  {name:"Light Nougat",        hex:"#F6C49E"},
  {name:"Pearl Gold",          hex:"#AA7A22"},
  {name:"Tan",                 hex:"#E4CD9E"},
  {name:"Dark Tan",            hex:"#A08A52"},
  {name:"Yellow",              hex:"#F2CD37"},
  {name:"Bright Light Yellow", hex:"#F6E652"},
  {name:"Olive Green",         hex:"#9B9A5A"},
  {name:"Yellowish Green",     hex:"#DFEEA5"},
  {name:"Bright Green",        hex:"#4DBF00"},
  {name:"Green",               hex:"#237841"},
  {name:"Dark Green",          hex:"#184632"},
  {name:"Light Green",         hex:"#C2DAB8"},
  {name:"Sand Green",          hex:"#789082"},
  {name:"Light Aqua",          hex:"#88EEE0"},
  {name:"Dark Turquoise",      hex:"#009080"},
  {name:"Dark Azure",          hex:"#0A8AE0"},
  {name:"Maersk Blue",         hex:"#54A0D8"},
  {name:"Blue",                hex:"#0055BF"},
  {name:"Dark Blue",           hex:"#1E3A4E"},
  {name:"Bright Light Blue",   hex:"#9FC3E0"},
  {name:"Sand Blue",           hex:"#74869C"},
  {name:"Light Bluish Gray",   hex:"#B0BCDA"},
  {name:"Medium Violet",       hex:"#7270CC"},
  {name:"Dark Purple",         hex:"#4E3C68"},
  {name:"Purple",              hex:"#7840B8"},
  {name:"Sand Purple",         hex:"#845E84"},
  {name:"Medium Lavender",     hex:"#AC78BA"},
  {name:"Lavender",            hex:"#E1BEF2"},
  {name:"Magenta",             hex:"#C82878"},
  {name:"Dark Pink",           hex:"#C2607A"},
  {name:"Medium Dark Pink",    hex:"#F785B1"},
  {name:"Pink",                hex:"#FC97AC"},
  {name:"Light Pink",          hex:"#F2B4C4"},
  {name:"White",               hex:"#FFFFFF"},
  {name:"Light Gray",          hex:"#A0A49A"},
  {name:"Flat Silver",         hex:"#898788"},
  {name:"Dark Bluish Gray",    hex:"#6C6E68"},
  {name:"Pearl Dark Gray",     hex:"#575857"},
  {name:"Black",               hex:"#0C161E"},
];

// Skin tone palette (Rule 4 — always prefer these for skin)
const SKIN_TONES = ["#F6C49E","#D09168","#958A73","#7B2A00","#352100"];
// These get swapped to skin tones if nearby skin is detected
const WRONG_SKIN = ["#A95500","#FE8A18","#F5A52A"];

const RESOLUTIONS = {
  square:    [{label:"32×32",cols:32,rows:32},{label:"48×48",cols:48,rows:48},{label:"64×64",cols:64,rows:64},{label:"96×96",cols:96,rows:96},{label:"128×128",cols:128,rows:128}],
  portrait:  [{label:"32×48",cols:32,rows:48},{label:"32×64",cols:32,rows:64},{label:"48×64",cols:48,rows:64},{label:"48×96",cols:48,rows:96},{label:"64×96",cols:64,rows:96},{label:"64×128",cols:64,rows:128},{label:"96×128",cols:96,rows:128}],
  landscape: [{label:"48×32",cols:48,rows:32},{label:"64×32",cols:64,rows:32},{label:"64×48",cols:64,rows:48},{label:"96×48",cols:96,rows:48},{label:"96×64",cols:96,rows:64},{label:"128×64",cols:128,rows:64},{label:"128×96",cols:128,rows:96}],
};

const FILTERS = [
  {name:"Vivid",        brightness:10,  contrast:25,  saturation:55,  hue:0},
  {name:"Faded",        brightness:8,   contrast:-25, saturation:-45, hue:0},
  {name:"High Contrast",brightness:0,   contrast:65,  saturation:10,  hue:0},
  {name:"Warm",         brightness:8,   contrast:10,  saturation:20,  hue:-18},
  {name:"Cool",         brightness:0,   contrast:10,  saturation:15,  hue:22},
  {name:"Moody",        brightness:-18, contrast:35,  saturation:-25, hue:0},
  {name:"Retro",        brightness:-5,  contrast:-12, saturation:-35, hue:-12},
  {name:"Pop Art",      brightness:12,  contrast:45,  saturation:90,  hue:0},
  {name:"Black & White",brightness:0,   contrast:25,  saturation:-100,hue:0},
  {name:"Dramatic",     brightness:-22, contrast:75,  saturation:25,  hue:0},
];

// ── STATE ─────────────────────────────────────────────────────────────────────
let imageSrc = null;
let currentShape = "square";
let currentRes = RESOLUTIONS.square[0];
let disabledColors = new Set();
let rendered = false;
let adj = {brightness:0,contrast:0,saturation:0,hue:0,detail:0,red:0,green:0,blue:0,colors:50};
let adjColorsDefault = 50; // gets set to actual colour count after first render
let gridData = [];        // raw auto-generated grid (source of truth for playbook)
let playbookGrid = [];    // playbook-processed grid (what gets drawn)
let cellSize = 8;
let gridCols = 0, gridRows = 0;
let activeTool = null;
let paintColor = LEGO_COLORS[0].hex;
let paintColorName = LEGO_COLORS[0].name;
let isDrawing = false;
let undoStack = [];
let redoStack = [];
const MAX_UNDO = 50;
let zoomLevel = 0;
let isPanning = false, panStartX = 0, panStartY = 0, panScrollX = 0, panScrollY = 0;
let mobPanActive = false, mobPanLastX = 0, mobPanLastY = 0;
const ZOOM_STEPS = [0.25,0.33,0.5,0.67,0.75,1,1.25,1.5,2,2.5,3,4,5,6,8];
const ZOOM_DEFAULT = 5;
let customPaletteColors = new Set();
let modalTempColors = new Set();

// Playbook slider state
let pb = {smooth:0, simplify:0, colors:50};
let pbDebounceTimer = null;

// Interpolation mode
let interpMode = 'nearest'; // 'nearest' | 'avg'

// Baseplate mode
let baseplateMode = 'regular'; // 'regular' | 'framed'
const FRAME_OPTIONAL_SIZES = new Set(['32x32','48x48']); // only these get the toggle

// ── NUDGE + RESET HELPERS ─────────────────────────────────────────────────────
function nudge(id, delta, callback) {
  const el=document.getElementById(id);
  const min=parseFloat(el.min),max=parseFloat(el.max);
  el.value=Math.min(max,Math.max(min,parseFloat(el.value)+delta));
  el.dispatchEvent(new Event('input'));
}
function resetSlider(id, defaultVal, callback) {
  const el=document.getElementById(id);
  el.value=defaultVal;
  el.dispatchEvent(new Event('input'));
}

// ── COLOUR UTILS ──────────────────────────────────────────────────────────────
function hexToRgb(hex) {
  const h=hex.replace("#","");
  return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)];
}
function rgbToLab(r,g,b) {
  let r1=r/255,g1=g/255,b1=b/255;
  r1=r1>0.04045?((r1+0.055)/1.055)**2.4:r1/12.92;
  g1=g1>0.04045?((g1+0.055)/1.055)**2.4:g1/12.92;
  b1=b1>0.04045?((b1+0.055)/1.055)**2.4:b1/12.92;
  let x=(r1*0.4124+g1*0.3576+b1*0.1805)/0.95047;
  let y=(r1*0.2126+g1*0.7152+b1*0.0722)/1.00000;
  let z=(r1*0.0193+g1*0.1192+b1*0.9505)/1.08883;
  const f=v=>v>0.008856?v**(1/3):7.787*v+16/116;
  return[116*f(y)-16,500*(f(x)-f(y)),200*(f(y)-f(z))];
}
function labDist(hex1,hex2) {
  const [r1,g1,b1]=hexToRgb(hex1),[r2,g2,b2]=hexToRgb(hex2);
  const [L1,A1,B1]=rgbToLab(r1,g1,b1),[L2,A2,B2]=rgbToLab(r2,g2,b2);
  return (L1-L2)**2+(A1-A2)**2+(B1-B2)**2;
}
function getLuminance(hex) {
  const [r,g,b]=hexToRgb(hex);
  return (0.299*r+0.587*g+0.114*b)/255;
}
function getClosestColor(r,g,b,palette) {
  const [L1,A1,B1]=rgbToLab(r,g,b);
  let closest=palette[0],minDist=Infinity;
  palette.forEach(hex=>{
    const [r2,g2,b2]=hexToRgb(hex);
    const [L2,A2,B2]=rgbToLab(r2,g2,b2);
    const d=(L1-L2)**2+(A1-A2)**2+(B1-B2)**2;
    if(d<minDist){minDist=d;closest=hex;}
  });
  return closest;
}

// ── IMAGE ADJUSTMENT ──────────────────────────────────────────────────────────
function applyAdjustments(data,brightness,contrast,saturation,hue,red,green,blue) {
  red=red||0; green=green||0; blue=blue||0;
  const b=brightness/100*255,c=(contrast/100)+1,cO=128*(1-c),s=(saturation/100)+1;
  const hR=hue*Math.PI/180,cosH=Math.cos(hR),sinH=Math.sin(hR);
  // RGB shifts: -100 to +100 maps to -255 to +255
  const rShift=red/100*255, gShift=green/100*255, bShift=blue/100*255;
  for(let i=0;i<data.length;i+=4){
    let r=data[i],g=data[i+1],bl=data[i+2];
    r+=b;g+=b;bl+=b;
    r=r*c+cO;g=g*c+cO;bl=bl*c+cO;
    const lum=0.299*r+0.587*g+0.114*bl;
    r=lum+s*(r-lum);g=lum+s*(g-lum);bl=lum+s*(bl-lum);
    const nr=r*(0.213+cosH*0.787-sinH*0.213)+g*(0.213-cosH*0.213-sinH*0.143)+bl*(0.213-cosH*0.213+sinH*0.928);
    const ng=r*(0.715-cosH*0.715+sinH*0.140)+g*(0.715+cosH*0.285+sinH*0.140)+bl*(0.715-cosH*0.715-sinH*0.283);
    const nb=r*(0.072-cosH*0.072+sinH*0.928)+g*(0.072-cosH*0.072-sinH*0.283)+bl*(0.072+cosH*0.928+sinH*0.283);
    data[i]  =Math.min(255,Math.max(0,nr+rShift));
    data[i+1]=Math.min(255,Math.max(0,ng+gShift));
    data[i+2]=Math.min(255,Math.max(0,nb+bShift));
  }
}

// ── COLOUR NAME LOOKUP ───────────────────────────────────────────────────────
// Falls back to nearest-colour match so old hex values still resolve to names.
function hexToColorName(hex) {
  const exact = LEGO_COLORS.find(c => c.hex.toUpperCase() === hex.toUpperCase());
  if(exact) return exact.name;
  const [r,g,b] = hexToRgb(hex);
  let best = null, bestDist = Infinity;
  for(const c of LEGO_COLORS) {
    const [cr,cg,cb] = hexToRgb(c.hex);
    const d = (r-cr)**2 + (g-cg)**2 + (b-cb)**2;
    if(d < bestDist) { bestDist = d; best = c; }
  }
  return best ? best.name : hex;
}

// ── DRAW CELL ─────────────────────────────────────────────────────────────────
function drawCell(ctx, x, y, color, cs) {
  cs = cs || cellSize;
  const px = x * cs, py = y * cs;
  const [cr, cg, cb] = hexToRgb(color);
  const lum = (0.299*cr + 0.587*cg + 0.114*cb) / 255;
  // Flat tile — smooth with subtle bevel and circular indent
  ctx.fillStyle = color; ctx.fillRect(px, py, cs, cs);
  const bv = Math.max(1, Math.round(cs * 0.08));
  ctx.fillStyle = lum > 0.5 ? 'rgba(255,255,255,0.20)' : 'rgba(255,255,255,0.10)';
  ctx.fillRect(px, py, cs, bv); ctx.fillRect(px, py, bv, cs);
  ctx.fillStyle = 'rgba(0,0,0,0.15)';
  ctx.fillRect(px, py+cs-bv, cs, bv); ctx.fillRect(px+cs-bv, py, bv, cs);
  if(cs >= 6) {
    const sr = cs * 0.30, cx2 = px+cs/2, cy2 = py+cs/2;
    ctx.beginPath(); ctx.arc(cx2, cy2, sr, 0, Math.PI*2);
    ctx.strokeStyle = lum > 0.5 ? 'rgba(0,0,0,0.14)' : 'rgba(0,0,0,0.20)';
    ctx.lineWidth = Math.max(0.5, cs * 0.06); ctx.stroke();
    ctx.beginPath(); ctx.arc(cx2+sr*0.15, cy2+sr*0.15, sr*0.55, 0, Math.PI*2);
    ctx.strokeStyle = lum > 0.5 ? 'rgba(255,255,255,0.30)' : 'rgba(255,255,255,0.12)';
    ctx.lineWidth = Math.max(0.5, cs * 0.04); ctx.stroke();
  }
}


function redrawGrid() {
  const canvas=document.getElementById("mosaic-canvas");
  // Manual edits live in playbookGrid; if empty fall back to gridData
  const display=playbookGrid.length?playbookGrid:gridData;
  drawGridToCanvas(display,gridCols,gridRows,canvas);
  updateStats();
}

// ── UPLOAD ────────────────────────────────────────────────────────────────────
function handleUpload(e) {
  const file=e.target.files[0];
  if(!file) return;
  // Reset input so same file can be re-selected after blank canvas
  e.target.value='';
  const reader=new FileReader();
  reader.onload=ev=>{
    imageSrc=ev.target.result;
    rendered=false;
    adjColorsDefault=50;
    resetAdjSilent();
    clearAdvFilterSilent();
    closeMaskPanel();
    setTool(null);
    undoStack=[]; redoStack=[];
    updateUndoBtn(); updateRedoBtn();
    playbookGrid=[]; gridData=[];
    const lbl=document.getElementById("upload-label");
    lbl.innerHTML=`<img src="${imageSrc}" alt="source" style="max-width:100%;max-height:160px;object-fit:contain;border-radius:3px;display:block;"/>`;
    
    doRender();
  };
  reader.readAsDataURL(file);
}

// ── BLANK CANVAS ──────────────────────────────────────────────────────────────
function useBlankCanvas() {
  // Save undo FIRST — before overwriting imageSrc — so undo can restore the photo
  if(rendered && playbookGrid.length) saveUndo();

  const {cols, rows} = currentRes;
  const tmp = document.createElement("canvas");
  tmp.width = cols; tmp.height = rows;
  const ctx = tmp.getContext("2d");
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, cols, rows);
  imageSrc = tmp.toDataURL("image/png");

  rendered = false;
  adjColorsDefault = 50;
  resetAdjSilent();
  clearAdvFilterSilent();
  closeMaskPanel();
  setTool(null);
  playbookGrid=[]; gridData=[];
  const lbl = document.getElementById("upload-label");
  lbl.innerHTML = `<div style="width:100%;height:80px;background:#fff;border-radius:3px;display:flex;align-items:center;justify-content:center;"><span style="font-size:10px;color:#999;letter-spacing:0.5px;text-transform:uppercase;">Blank canvas</span></div>`;
  
  doRender();
}

// ── RESOLUTION ────────────────────────────────────────────────────────────────
function switchShape(shape,btn) {
  if(preparedDesignUrl) resetPrepareState();
  currentShape=shape;
  document.querySelectorAll(".res-tab").forEach(b=>b.classList.remove("active"));
  btn.classList.add("active");
  buildResGrid();
}
let resInitialised = false; // tracks first load

// ── TILE SELECTOR ────────────────────────────────────────────────────────────
function buildResGrid() {
  const grid=document.getElementById("res-grid");
  grid.innerHTML="";
  const opts=RESOLUTIONS[currentShape];

  // Pre-select first option only on very first load (square default)
  const preselect = !resInitialised && currentShape==="square";
  if(preselect) { currentRes=opts[0]; resInitialised=true; }

  opts.forEach((opt,i)=>{
    const btn=document.createElement("button");
    btn.className="res-btn"+(preselect&&i===0?" active":"");
    btn.textContent=opt.label;
    btn.onclick=()=>{
      // Save undo state before size change if already rendered
      if(rendered) saveUndo();
      currentRes=opt;
      document.querySelectorAll(".res-btn").forEach(b=>b.classList.remove("active"));
      btn.classList.add("active");
      updateBaseplateUI();
      if(preparedDesignUrl) resetPrepareState();
      if(rendered)doRender();
    };
    grid.appendChild(btn);
  });
  updateBaseplateUI();
}

// ── BUILD INSTRUCTIONS ────────────────────────────────────────────────────────

// Page layout plan per inner size (excluding frame)
function getInstructionPlan(innerCols, innerRows) {
  const key = `${innerCols}x${innerRows}`;

  // Only 32x32 and 48x48 are single page — everything else gets cover + pages
  const singlePage = new Set(["32x32","48x48"]);
  if(singlePage.has(key)) return {multiPage:false, sections:[{c0:0,r0:0,cols:innerCols,rows:innerRows,label:""}]};

  // All other sizes: cover + grid pages
  // Split strategy: use the fewest pages while keeping each section ≤ 64 wide and ≤ 64 tall
  const splits = {
    // Portrait
    "32x48":  [{c0:0,r0:0,cols:32,rows:24,label:"Top"},{c0:0,r0:24,cols:32,rows:24,label:"Bottom"}],
    "32x64":  [{c0:0,r0:0,cols:32,rows:32,label:"Top"},{c0:0,r0:32,cols:32,rows:32,label:"Bottom"}],
    "48x64":  [{c0:0,r0:0,cols:48,rows:32,label:"Top"},{c0:0,r0:32,cols:48,rows:32,label:"Bottom"}],
    "48x96":  [{c0:0,r0:0,cols:48,rows:48,label:"Top"},{c0:0,r0:48,cols:48,rows:48,label:"Bottom"}],
    "64x96":  [{c0:0,r0:0,cols:64,rows:32,label:"Top"},{c0:0,r0:32,cols:64,rows:32,label:"Middle"},
               {c0:0,r0:64,cols:64,rows:32,label:"Bottom"}],
    "64x128": [{c0:0,r0:0,cols:64,rows:32,label:"Top"},{c0:0,r0:32,cols:64,rows:32,label:"Upper Middle"},
               {c0:0,r0:64,cols:64,rows:32,label:"Lower Middle"},{c0:0,r0:96,cols:64,rows:32,label:"Bottom"}],
    "96x128": [{c0:0,r0:0,cols:48,rows:64,label:"Top Left"},{c0:48,r0:0,cols:48,rows:64,label:"Top Right"},
               {c0:0,r0:64,cols:48,rows:64,label:"Bottom Left"},{c0:48,r0:64,cols:48,rows:64,label:"Bottom Right"}],
    // Landscape
    "48x32":  [{c0:0,r0:0,cols:24,rows:32,label:"Left"},{c0:24,r0:0,cols:24,rows:32,label:"Right"}],
    "64x32":  [{c0:0,r0:0,cols:32,rows:32,label:"Left"},{c0:32,r0:0,cols:32,rows:32,label:"Right"}],
    "64x48":  [{c0:0,r0:0,cols:32,rows:48,label:"Left"},{c0:32,r0:0,cols:32,rows:48,label:"Right"}],
    "96x48":  [{c0:0,r0:0,cols:48,rows:48,label:"Left"},{c0:48,r0:0,cols:48,rows:48,label:"Right"}],
    "96x64":  [{c0:0,r0:0,cols:48,rows:32,label:"Top Left"},{c0:48,r0:0,cols:48,rows:32,label:"Top Right"},
               {c0:0,r0:32,cols:48,rows:32,label:"Bottom Left"},{c0:48,r0:32,cols:48,rows:32,label:"Bottom Right"}],
    "128x64": [{c0:0,r0:0,cols:32,rows:64,label:"Left"},{c0:32,r0:0,cols:32,rows:64,label:"Centre Left"},
               {c0:64,r0:0,cols:32,rows:64,label:"Centre Right"},{c0:96,r0:0,cols:32,rows:64,label:"Right"}],
    "128x96": [{c0:0,r0:0,cols:64,rows:48,label:"Top Left"},{c0:64,r0:0,cols:64,rows:48,label:"Top Right"},
               {c0:0,r0:48,cols:64,rows:48,label:"Bottom Left"},{c0:64,r0:48,cols:64,rows:48,label:"Bottom Right"}],
    // Square
    "64x64":  [{c0:0,r0:0,cols:32,rows:32,label:"Top Left"},{c0:32,r0:0,cols:32,rows:32,label:"Top Right"},
               {c0:0,r0:32,cols:32,rows:32,label:"Bottom Left"},{c0:32,r0:32,cols:32,rows:32,label:"Bottom Right"}],
    "96x96":  [{c0:0,r0:0,cols:48,rows:48,label:"Top Left"},{c0:48,r0:0,cols:48,rows:48,label:"Top Right"},
               {c0:0,r0:48,cols:48,rows:48,label:"Bottom Left"},{c0:48,r0:48,cols:48,rows:48,label:"Bottom Right"}],
    "128x128":[{c0:0,r0:0,cols:64,rows:64,label:"Top Left"},{c0:64,r0:0,cols:64,rows:64,label:"Top Right"},
               {c0:0,r0:64,cols:64,rows:64,label:"Bottom Left"},{c0:64,r0:64,cols:64,rows:64,label:"Bottom Right"}],
  };
  const sections = splits[key] || [{c0:0,r0:0,cols:innerCols,rows:innerRows,label:"Full"}];
  return {multiPage:true, sections};
}

// Calculate maximum cell size (px) to fill A4 content area as much as possible
// Available grid area depends on page size
// Small page (32x32, 48x48): 210mm wide × 250mm tall → usable ~186mm × 200mm
// Standard A4 (larger sizes): 210mm wide × 297mm tall → usable ~186mm × 240mm
// 1mm ≈ 3.78px at 96dpi
function bestCellSize(cols, rows, isSmall) {
  var availWmm = 186; // usable width in mm (after 12mm padding each side)
  var availHmm = isSmall ? 195 : 230; // usable height for grid (after header + key + margins)
  var byWidth  = availWmm / cols;
  var byHeight = availHmm / rows;
  var mmPerCell = Math.min(byWidth, byHeight);
  // Allow larger cells for small grids on small pages
  var maxMm = isSmall ? 12 : 8;
  var clamped = Math.max(3, Math.min(maxMm, mmPerCell));
  return Math.round(clamped * 3.78); // convert to px
}

function generateInstructions() {
  if(!rendered) return;
  const display = playbookGrid.length ? playbookGrid : gridData;
  const isFramed = baseplateMode==='framed';
  const innerCols = isFramed ? gridCols-4 : gridCols;
  const innerRows = isFramed ? gridRows-4 : gridRows;
  const r0off = isFramed ? 2 : 0;
  const c0off = isFramed ? 2 : 0;

  // Extract inner grid (no frame)
  const inner = [];
  for(let y=0;y<innerRows;y++){
    inner[y]=[];
    for(let x=0;x<innerCols;x++) inner[y][x]=display[y+r0off][x+c0off];
  }

  // Build colour map sorted by frequency (1 = most used)
  const freq = {};
  inner.forEach(row=>row.forEach(c=>{freq[c]=(freq[c]||0)+1;}));
  const colourOrder = Object.entries(freq).sort((a,b)=>b[1]-a[1]).map(([hex])=>hex);
  const colNum = {}; // hex → number (1-based)
  colourOrder.forEach((hex,i)=>colNum[hex]=i+1);

  const plan = getInstructionPlan(innerCols, innerRows);

  // Build HTML
  let html = `<!DOCTYPE html><html><head><meta charset="UTF-8"/>
<title>Mosaic Build Instructions</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Arial', sans-serif; background:#fff; color:#111; }
  .page { width:210mm; min-height:297mm; padding:12mm; page-break-after:always; display:flex; flex-direction:column; }
  .page:last-child { page-break-after:auto; }

  /* ── COVER PAGE STYLES ── */
  .cover-header { display:flex; justify-content:space-between; align-items:flex-start; padding-bottom:5mm; border-bottom:2px solid #111; margin-bottom:6mm; }
  .cover-title-block {}
  .cover-eyebrow { font-size:9px; letter-spacing:3px; text-transform:uppercase; color:#888; margin-bottom:3px; }
  .cover-title { font-size:26px; font-weight:700; letter-spacing:-0.5px; line-height:1.1; }
  .cover-subtitle { font-size:11px; color:#555; margin-top:4px; }
  .cover-logo { display:flex; flex-direction:column; align-items:flex-end; gap:6px; }
  .cover-page-num { font-size:9px; color:#aaa; text-align:right; }

  .frame-notice { padding:8px 10px; border:1.5px solid #888; border-radius:4px; font-size:9px; line-height:1.6; margin-bottom:7mm; }
  .frame-notice strong { font-size:10px; }

  .cover-body { display:flex; gap:8mm; flex:1; }
  .cover-left { flex:1; min-width:0; }
  .cover-right { width:65mm; flex-shrink:0; }

  .section-label { font-size:8px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:#888; margin-bottom:3mm; }

  /* Colour key — big swatches on cover */
  .cover-key-grid { display:flex; flex-wrap:wrap; gap:4px; }
  .cover-key-item { display:flex; align-items:center; gap:5px; font-size:8.5px; width:calc(50% - 2px); }
  .cover-key-swatch { width:20px; height:20px; border:0.5px solid rgba(0,0,0,0.2); border-radius:2px; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:8px; font-weight:700; }
  .cover-key-name { color:#222; flex:1; }
  .cover-key-count { color:#888; font-size:7.5px; white-space:nowrap; }

  /* Section map */
  .section-map { border:1px solid #ccc; border-radius:3px; overflow:hidden; }
  .section-map-head { font-size:8px; font-weight:700; letter-spacing:1px; text-transform:uppercase; background:#f5f5f5; padding:5px 7px; border-bottom:1px solid #ddd; color:#555; }
  .section-map-grid { display:grid; gap:1px; background:#ddd; }
  .section-map-cell { background:#fff; padding:10px 6px; text-align:center; font-size:8px; line-height:1.5; }
  .section-map-cell .pg { font-size:10px; font-weight:700; display:block; }
  .section-map-note { margin-top:3mm; font-size:8px; color:#888; line-height:1.6; }

  /* Stats row */
  .cover-stats { display:flex; gap:6mm; margin-bottom:6mm; padding:4mm 0; border-top:1px solid #eee; border-bottom:1px solid #eee; }
  .cover-stat { text-align:center; }
  .cover-stat-val { font-size:18px; font-weight:700; line-height:1; }
  .cover-stat-label { font-size:8px; color:#888; text-transform:uppercase; letter-spacing:1px; margin-top:2px; }

  /* ── GRID PAGE STYLES ── */
  .page-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:4mm; padding-bottom:3mm; border-bottom:1px solid #ccc; }
  .page-title { font-size:14px; font-weight:700; }
  .page-subtitle { font-size:9px; color:#666; margin-top:2px; }
  .grid-wrap { flex:1; display:flex; align-items:flex-start; justify-content:center; }
  table.grid { border-collapse:collapse; }
  table.grid td { border:0.3px solid rgba(0,0,0,0.2); text-align:center; vertical-align:middle; font-weight:bold; line-height:1; padding:0; }

  /* Inline key on grid pages */
  .colour-key { margin-top:3mm; padding-top:3mm; border-top:1px solid #eee; }
  .colour-key-title { font-size:8px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; color:#888; margin-bottom:2mm; }
  .colour-key-grid { display:flex; flex-wrap:wrap; gap:3px; }
  .colour-key-item { display:flex; align-items:center; gap:3px; font-size:7.5px; padding:2px 4px 2px 2px; border:0.5px solid #e0e0e0; border-radius:2px; }
  .key-swatch { width:13px; height:13px; border:0.5px solid rgba(0,0,0,0.25); border-radius:1px; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:6px; font-weight:bold; }
  .key-name { color:#333; }
  .key-count { color:#999; margin-left:2px; }

  @media print {
    body { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .page { padding:10mm; }
  }
</style>
</head><body>`;

  // Helper: render a section grid
  function renderGrid(inner, c0, r0, sectionCols, sectionRows) {
    const isSmallGrid = !plan.multiPage;
    const cs = bestCellSize(sectionCols, sectionRows, isSmallGrid);
    const fontSize = Math.max(5, Math.min(10, Math.round(cs * 0.45)));
    const rowNumW = 14;
    let t = `<table class="grid" style="font-size:${fontSize}px;">`;
    t += `<thead><tr><td style="width:${rowNumW}px;height:12px;background:#fafafa;border:none;"></td>`;
    for(let x=0;x<sectionCols;x++) t+=`<td style="width:${cs}px;height:12px;background:#fafafa;font-size:6px;color:#aaa;text-align:center;padding:0;">${c0+x+1}</td>`;
    t+=`</tr></thead><tbody>`;
    for(let y=0;y<sectionRows;y++){
      t+=`<tr><td style="width:${rowNumW}px;height:${cs}px;background:#fafafa;font-size:6px;color:#aaa;text-align:center;padding:0;">${r0+y+1}</td>`;
      for(let x=0;x<sectionCols;x++){
        const hex=inner[r0+y][c0+x];
        const num=colNum[hex];
        const [r,g,b]=hexToRgb(hex);
        const lum=(0.299*r+0.587*g+0.114*b)/255;
        const txtColor=lum>0.45?'#000':'#fff';
        t+=`<td style="width:${cs}px;height:${cs}px;background:${hex};color:${txtColor};">${num}</td>`;
      }
      t+=`</tr>`;
    }
    t+=`</tbody></table>`;
    return t;
  }

  // Helper: colour key HTML
  function renderKey(hexList) {
    let k=`<div class="colour-key"><div class="colour-key-title">Colour Key</div><div class="colour-key-grid">`;
    hexList.forEach(hex=>{
      const n=colNum[hex];
      const name=hexToColorName(hex);
      const count=freq[hex];
      const [r,g,b]=hexToRgb(hex);
      const lum=(0.299*r+0.587*g+0.114*b)/255;
      const txtColor=lum>0.45?'#000':'#fff';
      k+=`<div class="colour-key-item"><div class="key-swatch" style="background:${hex};color:${txtColor};">${n}</div><span class="key-name">${n}. ${name}</span><span class="key-count">${count} bricks</span></div>`;
    });
    k+=`</div></div>`;
    return k;
  }

  if(!plan.multiPage) {
    // ── SINGLE PAGE ──────────────────────────────────────────────────────────
    const sz = `${innerCols}×${innerRows}`;
    html += `<div class="page">
      <div class="page-header">
        <div>
          <div class="page-title">Mosaic Build Instructions</div>
          <div class="page-subtitle">${sz} bricks · ${colourOrder.length} colours · ${innerCols*innerRows} bricks total${isFramed?' · Fit the framed baseplate first':''}</div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;"><img src="data:image/png;base64,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" alt="Stereo Hoare" style="height:50px;width:auto;object-fit:contain;"/><div style="font-size:9px;color:#888;">Page 1 of 1</div></div>
      </div>
      ${isFramed?`<div class="frame-notice">⚠️ This design uses a <strong>Framed Baseplate</strong>. Fit the framed baseplate completely before placing any bricks from this grid. The frame is 2 bricks thick and solid black.</div>`:''}
      <div class="grid-wrap">${renderGrid(inner,0,0,innerCols,innerRows)}</div>
      ${renderKey(colourOrder)}
    </div>`;

  } else {
    // ── COVER PAGE ───────────────────────────────────────────────────────────
    const totalPages = plan.sections.length + 1;

    // Work out section map grid dimensions
    const uniqueCols = [...new Set(plan.sections.map(s=>s.c0))].length;
    const uniqueRows = [...new Set(plan.sections.map(s=>s.r0))].length;

    let sectionMapCells = '';
    plan.sections.forEach((s,i)=>{
      sectionMapCells += `<div class="section-map-cell"><span>Page ${i+2}</span>${s.label}</div>`;
    });

    html += `<div class="page" style="background:#fff;padding:12mm;">

      <div style="display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:5mm;border-bottom:2.5px solid #111;margin-bottom:6mm;">
        <div>
          <div style="font-size:8px;letter-spacing:3.5px;text-transform:uppercase;color:#bbb;margin-bottom:4px;font-family:Arial,sans-serif;">Custom Mosaic Designer</div>
          <div style="font-size:34px;font-weight:800;line-height:1.0;letter-spacing:-1px;font-family:Arial,sans-serif;">Mosaic Build<br>Instructions</div>
          <div style="font-size:10px;color:#666;margin-top:6px;font-family:Arial,sans-serif;">${innerCols}&times;${innerRows} bricks &nbsp;&middot;&nbsp; ${colourOrder.length} colours &nbsp;&middot;&nbsp; ${(innerCols*innerRows).toLocaleString()} total bricks</div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px;">
          <img src="data:image/png;base64,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" alt="Stereo Hoare" style="height:42px;width:auto;object-fit:contain;display:block;"/>
          <div style="font-size:8px;color:#bbb;font-family:Arial,sans-serif;">Page 1 of ${totalPages} &mdash; Cover</div>
        </div>
      </div>

      ${isFramed ? '<div style="margin-bottom:8mm;padding:9px 12px;border:1px solid #aaa;border-radius:3px;font-size:9px;line-height:1.7;font-family:Arial,sans-serif;"><strong style="font-size:10px;">&#9888; Framed Baseplate</strong><br>Fit the framed baseplate completely before placing any bricks. The frame is 2 bricks thick and solid black.</div>' : ''}

      <div style="display:flex;gap:0;margin-bottom:7mm;padding:5mm 0;border-top:1px solid #ececec;border-bottom:1px solid #ececec;">
        <div style="flex:1;text-align:center;border-right:1px solid #ececec;">
          <div style="font-size:21px;font-weight:700;line-height:1;font-family:Arial,sans-serif;">${(innerCols*innerRows).toLocaleString()}</div>
          <div style="font-size:7.5px;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-top:2px;font-family:Arial,sans-serif;">Total Bricks</div>
        </div>
        <div style="flex:1;text-align:center;border-right:1px solid #ececec;">
          <div style="font-size:21px;font-weight:700;line-height:1;font-family:Arial,sans-serif;">${colourOrder.length}</div>
          <div style="font-size:7.5px;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-top:2px;font-family:Arial,sans-serif;">Colours</div>
        </div>
        <div style="flex:1;text-align:center;border-right:1px solid #ececec;">
          <div style="font-size:21px;font-weight:700;line-height:1;font-family:Arial,sans-serif;">${innerCols}&times;${innerRows}</div>
          <div style="font-size:7.5px;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-top:2px;font-family:Arial,sans-serif;">Grid Size</div>
        </div>
        <div style="flex:1;text-align:center;">
          <div style="font-size:21px;font-weight:700;line-height:1;font-family:Arial,sans-serif;">${totalPages-1}</div>
          <div style="font-size:7.5px;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-top:2px;font-family:Arial,sans-serif;">Grid Pages</div>
        </div>
      </div>

      <div style="display:flex;gap:8mm;flex:1;">
        <div style="flex:1;min-width:0;">
          <div style="font-size:7.5px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#bbb;margin-bottom:3mm;font-family:Arial,sans-serif;">Colour Key</div>
          <div style="display:flex;flex-wrap:wrap;gap:4px;">
            ${colourOrder.map(hex=>{
              const n=colNum[hex];
              const name=hexToColorName(hex);
              const count=freq[hex];
              const [r,g,b]=hexToRgb(hex);
              const lum=(0.299*r+0.587*g+0.114*b)/255;
              const txt=lum>0.45?"#000":"#fff";
              return `<div style="display:flex;align-items:center;gap:5px;width:calc(50% - 2px);margin-bottom:1px;font-family:Arial,sans-serif;font-size:8.5px;">
                <div style="width:20px;height:20px;background:${hex};border:0.5px solid rgba(0,0,0,0.12);border-radius:2px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:8px;font-weight:700;color:${txt};">${n}</div>
                <span style="flex:1;color:#222;">${n}. ${name}</span>
                <span style="color:#bbb;font-size:7.5px;white-space:nowrap;">${count.toLocaleString()}</span>
              </div>`;
            }).join("")}
          </div>
        </div>

        <div style="width:60mm;flex-shrink:0;">
          <div style="font-size:7.5px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#bbb;margin-bottom:3mm;font-family:Arial,sans-serif;">Page Layout</div>
          <div style="border:1px solid #ddd;border-radius:3px;overflow:hidden;">
            <div style="font-size:7.5px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#999;background:#f8f8f8;padding:5px 8px;border-bottom:1px solid #e8e8e8;font-family:Arial,sans-serif;">Section Map</div>
            <div style="display:grid;grid-template-columns:repeat(${uniqueCols},1fr);gap:1px;background:#e8e8e8;">
              ${plan.sections.map((s,i)=>`<div style="background:#fff;padding:10px 4px;text-align:center;font-family:Arial,sans-serif;">
                <span style="display:block;font-size:11px;font-weight:700;">${i+2}</span>
                <span style="font-size:7.5px;color:#999;">${s.label}</span>
              </div>`).join("")}
            </div>
          </div>
          <div style="margin-top:3mm;font-size:8px;color:#bbb;line-height:1.6;font-family:Arial,sans-serif;">Work through pages in order. Row &amp; column numbers continue across sections.</div>
        </div>
      </div>
    </div>`;

    // ── SECTION PAGES ────────────────────────────────────────────────────────
    plan.sections.forEach((sec,i)=>{
      // Only include colours used in this section
      const secColors = new Set();
      for(let y=sec.r0;y<sec.r0+sec.rows;y++) for(let x=sec.c0;x<sec.c0+sec.cols;x++) secColors.add(inner[y][x]);
      const secColorList = colourOrder.filter(h=>secColors.has(h));

      html += `<div class="page">
        <div class="page-header">
          <div>
            <div class="page-title">Section ${i+1} of ${plan.sections.length} — ${sec.label}</div>
            <div class="page-subtitle">Columns ${sec.c0+1}–${sec.c0+sec.cols} · Rows ${sec.r0+1}–${sec.r0+sec.rows} · ${sec.cols}×${sec.rows} bricks</div>
          </div>
          <div style="font-size:9px;color:#888;">Page ${i+2} of ${totalPages}</div>
        </div>
        <div class="grid-wrap">${renderGrid(inner,sec.c0,sec.r0,sec.cols,sec.rows)}</div>
        ${renderKey(secColorList)}
      </div>`;
    });
  }

  html += `</body></html>`;

  // Open as blob URL — avoids popup blockers
  const blob = new Blob([html], {type:'text/html'});
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if(!win) {
    // Fallback: download as HTML file
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mosaic-instructions.html';
    a.click();
  }
  setTimeout(()=>URL.revokeObjectURL(url), 60000);
}

// ── SHOPIFY + CLOUDINARY INTEGRATION ─────────────────────────────────────────

// ⚙️ CONFIGURATION — fill these in before going live
const SHOPIFY_CONFIG = {
  cloudinaryCloudName: 'ddisxym9x',
  cloudinaryUploadPreset: 'V2 custom mosaic',
  shopifyProductId: 15516930802041,
  shopifyDomain: window.location.hostname,
};

// Variant ID lookup — COLSxROWS_baseplate
const VARIANT_MAP = {
  "32x32_regular": 57335662641529,
  "32x32_framed":  57335662674297,
  "48x48_regular": 57335662707065,
  "48x48_framed":  57335662739833,
  "64x64_regular": 57335662772601,
  "64x64_framed":  57335662805369,
  "96x96_regular": 57335662838137,
  "96x96_framed":  57335662870905,
  "128x128_regular": 57335704519033,
  "128x128_framed":  57335704551801,
  "32x64_regular": 57335662903673,
  "32x64_framed":  57335662936441,
  "48x96_regular": 57335662969209,
  "48x96_framed":  57335663001977,
  "64x96_regular": 57335663034745,
  "64x96_framed":  57335663067513,
  "64x128_regular": 57335704584569,
  "64x128_framed":  57335704617337,
  "96x128_regular": 57335704650105,
  "96x128_framed":  57335704682873,
  "32x48_regular": 57391690383737,
  "32x48_framed":  57391690416505,
  "48x64_regular": 57391690449273,
  "48x64_framed":  57391690482041,
  "48x32_regular": 57391690514809,
  "48x32_framed":  57391690547577,
  "64x48_regular": 57391690580345,
  "64x48_framed":  57391690613113,
  "64x32_regular": 57335663100281,
  "64x32_framed":  57335663133049,
  "96x48_regular": 57335663165817,
  "96x48_framed":  57335663198585,
  "96x64_regular": 57335663231353,
  "96x64_framed":  57335663264121,
  "128x64_regular": 57335704715641,
  "128x64_framed":  57335704748409,
  "128x96_regular": 57335704781177,
  "128x96_framed":  57335704813945,
};

// Price lookup — keyed same as VARIANT_MAP: COLSxROWS_baseplate
const PRICE_MAP = {
  "32x32_regular":"£49.99",  "32x32_framed":"£59.99",
  "48x48_regular":"£79.99",  "48x48_framed":"£89.99",
  "64x64_regular":"£179.99", "64x64_framed":"£179.99",
  "96x96_regular":"£349.99", "96x96_framed":"£349.99",
  "128x128_regular":"£499.99","128x128_framed":"£499.99",
  "32x64_regular":"£89.99",  "32x64_framed":"£89.99",
  "48x96_regular":"£179.99", "48x96_framed":"£179.99",
  "64x96_regular":"£249.99", "64x96_framed":"£249.99",
  "64x128_regular":"£349.99","64x128_framed":"£349.99",
  "96x128_regular":"£399.99","96x128_framed":"£399.99",
  "32x48_regular":"£64.99",  "32x48_framed":"£64.99",
  "48x64_regular":"£119.99", "48x64_framed":"£119.99",
  "48x32_regular":"£64.99",  "48x32_framed":"£64.99",
  "64x48_regular":"£119.99", "64x48_framed":"£119.99",
  "64x32_regular":"£89.99",  "64x32_framed":"£89.99",
  "96x48_regular":"£159.99", "96x48_framed":"£159.99",
  "96x64_regular":"£199.99", "96x64_framed":"£199.99",
  "128x64_regular":"£349.99","128x64_framed":"£349.99",
  "128x96_regular":"£399.99","128x96_framed":"£399.99",
};

function updatePrice() {
  const isFramed = baseplateMode === 'framed';
  const innerCols = isFramed ? gridCols-4 : gridCols;
  const innerRows = isFramed ? gridRows-4 : gridRows;
  const key = innerCols + 'x' + innerRows + '_' + baseplateMode;
  // Use Liquid-injected prices (correct currency) if available, fall back to hardcoded GBP
  const priceMap = (window.MOSAIC_PRICES && Object.keys(window.MOSAIC_PRICES).length > 0)
    ? window.MOSAIC_PRICES : PRICE_MAP;
  const price = priceMap[key] || '—';
  const el = document.getElementById('stat-price');
  if (el) el.textContent = price;
  const mob = document.getElementById('mob-price-val');
  if (mob) mob.textContent = price;
}

// Get the correct variant ID based on current size + baseplate
function getCurrentVariantId() {
  const isFramed = baseplateMode === 'framed';
  const innerCols = isFramed ? gridCols - 4 : gridCols;
  const innerRows = isFramed ? gridRows - 4 : gridRows;
  const key = innerCols + 'x' + innerRows + '_' + baseplateMode;
  return VARIANT_MAP[key] || null;
}

// Render a clean PNG of the inner design only (crops frame border if framed)
function getDesignCanvas() {
  const canvas = document.getElementById('mosaic-canvas');
  if(baseplateMode === 'framed') {
    const innerCols = gridCols - 4;
    const innerRows = gridRows - 4;
    const cs = cellSize;
    const cropped = document.createElement('canvas');
    cropped.width = innerCols * cs;
    cropped.height = innerRows * cs;
    const ctx = cropped.getContext('2d');
    ctx.drawImage(canvas, 2*cs, 2*cs, innerCols*cs, innerRows*cs, 0, 0, innerCols*cs, innerRows*cs);
    return cropped;
  }
  return canvas;
}

// Upload canvas PNG to Cloudinary, return secure URL
async function uploadToCloudinary(canvas) {
  // Use toDataURL + fetch blob for better mobile compatibility
  // canvas.toBlob() is unreliable on some mobile browsers
  const dataURL = canvas.toDataURL('image/png');
  const res = await fetch(dataURL);
  const blob = await res.blob();
  const formData = new FormData();
  formData.append('file', blob, 'mosaic.png');
  formData.append('upload_preset', SHOPIFY_CONFIG.cloudinaryUploadPreset);
  formData.append('folder', 'mosaic-designs-v2');
  const uploadRes = await fetch(
    `https://api.cloudinary.com/v1_1/${SHOPIFY_CONFIG.cloudinaryCloudName}/image/upload`,
    { method: 'POST', body: formData }
  );
  const data = await uploadRes.json();
  if (data.secure_url) return data.secure_url;
  throw new Error(data.error?.message || 'Cloudinary upload failed');
}

// Upload a raw HTML string to Cloudinary as a file, return secure URL
async function uploadHTMLToCloudinary(htmlString, filename) {
  const blob = new Blob([htmlString], {type: 'text/html'});
  const formData = new FormData();
  formData.append('file', blob, filename);
  formData.append('upload_preset', SHOPIFY_CONFIG.cloudinaryUploadPreset);
  formData.append('folder', 'mosaic-designs-v2');
  formData.append('resource_type', 'raw');

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${SHOPIFY_CONFIG.cloudinaryCloudName}/raw/upload`,
    { method: 'POST', body: formData }
  );
  const data = await res.json();
  if(data.secure_url) return data.secure_url;
  throw new Error(data.error?.message || 'Instructions upload failed');
}

// State set by prepareMosaic
let preparedDesignUrl = null;
let preparedInstrUrl = null;
let preparedSourceUrl = null;
let preparedVariantId = null;
let preparedSizeLabel = null;
let preparedShape = null;
let preparedIsFramed = null;

// Main: Prepare Mosaic — upload PNG + instructions + source to Cloudinary
async function prepareMosaic() {
  if(!rendered) return;
  const variantId = getCurrentVariantId();
  if(!variantId) { alert('Could not find a matching product variant. Please check your size and baseplate selection.'); return; }

  // Handle both desktop and mobile buttons
  const btn     = document.getElementById('prepare-btn');
  const mobBtn  = document.getElementById('mob-prepare-btn');
  const status  = document.getElementById('prepare-status');
  const mobStat = document.getElementById('mob-prepare-status');
  const cartBtn    = document.getElementById('cart-btn');
  const mobCartBtn = document.getElementById('mob-cart-btn');

  // Progress bar helpers
  function showStatus(show) {
    if(status) status.style.display = show ? 'block' : 'none';
    if(mobStat) {
      if(show) { mobStat.classList.remove('mob-prepare-status-hidden'); mobStat.style.display = 'block'; }
      else { mobStat.classList.add('mob-prepare-status-hidden'); mobStat.style.display = 'none'; }
    }
  }

  function setProgress(pct, text) {
    // Desktop
    const bar = document.getElementById('prepare-progress-bar');
    const txt = document.getElementById('prepare-progress-text');
    const pctEl = document.getElementById('prepare-progress-pct');
    if(bar) {
      bar.style.width = pct + '%';
      // Shift colour from gold to green as progress increases
      if(pct < 100) bar.style.background = 'var(--gold)';
    }
    if(txt) txt.textContent = text;
    if(pctEl) pctEl.textContent = pct + '%';
    // Mobile - separate unique IDs
    const mbar = document.getElementById('mob-prog-bar');
    const mtxt = document.getElementById('mob-prog-text');
    const mpct = document.getElementById('mob-prog-pct');
    if(mbar) {
      mbar.style.width = pct + '%';
      if(pct < 100) mbar.style.background = 'var(--gold)';
    }
    if(mtxt) mtxt.textContent = text;
    if(mpct) mpct.textContent = pct + '%';
  }

  function setUploading() {
    if(btn) btn.style.display = 'none';
    if(mobBtn) { mobBtn.disabled=true; mobBtn.textContent='⏳ Uploading...'; mobBtn.style.opacity='0.6'; }
    showStatus(true);
    setProgress(5, 'Generating mosaic...');
  }

  function setStatus(text) {
    const txt = document.getElementById('prepare-progress-text');
    const mtxt = document.getElementById('mob-prepare-progress-text');
    if(txt) txt.textContent = text;
    if(mtxt) mtxt.textContent = text;
  }

  function setSuccess() {
    setProgress(100, '✓ Ready!');
    const bar = document.getElementById('prepare-progress-bar');
    const mbar = document.getElementById('mob-prog-bar');
    if(bar) bar.style.background = 'var(--gold)';
    if(mbar) mbar.style.background = 'var(--gold)';
    setTimeout(() => {
      showStatus(false);
      if(btn) { btn.style.display='block'; btn.textContent='✓ Ready!'; btn.disabled=true; btn.style.background='var(--bg3)'; btn.style.color='var(--gold)'; btn.style.border='2px solid var(--gold)'; btn.style.cursor='not-allowed'; btn.style.opacity='1'; btn.style.pointerEvents='none'; btn.onclick=null; }
      if(mobBtn) { mobBtn.disabled=false; mobBtn.textContent='✓ Ready!'; mobBtn.style.opacity='1'; mobBtn.style.background='var(--bg3)'; mobBtn.style.color='var(--gold)'; mobBtn.style.border='2px solid var(--gold)'; }
      if(cartBtn) { cartBtn.disabled=false; cartBtn.style.background='var(--gold)'; cartBtn.style.color='#f5f0e8'; cartBtn.style.borderColor='var(--gold)'; cartBtn.style.cursor='pointer'; cartBtn.textContent='🛒 Add to Cart'; }
      if(mobCartBtn) { mobCartBtn.disabled=false; mobCartBtn.style.background='var(--gold)'; mobCartBtn.style.color='#f5f0e8'; mobCartBtn.style.borderColor='var(--gold)'; mobCartBtn.style.cursor='pointer'; }
    }, 800);
  }

  function setFailed() {
    setProgress(0, '✗ Upload failed — retry');
    const bar = document.getElementById('prepare-progress-bar');
    const mbar = document.getElementById('mob-prog-bar');
    if(bar) bar.style.background = '#c0392b';
    if(mbar) mbar.style.background = '#c0392b';
    setTimeout(() => {
      showStatus(false);
      if(btn) { btn.style.display='block'; btn.disabled=false; btn.textContent='↺ Retry upload'; }
      if(mobBtn) { mobBtn.disabled=false; mobBtn.textContent='↺ Retry'; mobBtn.style.opacity='1'; mobBtn.style.background='var(--gold)'; mobBtn.style.color='#f5f0e8'; }
    }, 2000);
  }

  setUploading();

  try {
    const isFramed = baseplateMode === 'framed';
    const innerCols = isFramed ? gridCols - 4 : gridCols;
    const innerRows = isFramed ? gridRows - 4 : gridRows;
    const sizeLabel = innerCols + ' \u00d7 ' + innerRows;
    const shape = currentShape;

    // 1. Upload design PNG
    setProgress(10, 'Uploading design...');
    const designCanvas = getDesignCanvas();
    const designUrl = await uploadToCloudinary(designCanvas);

    // 2. Generate and upload instructions HTML
    setProgress(45, 'Generating instructions...');
    const instrHTML = generateInstructionsHTML();
    setProgress(55, 'Uploading instructions...');
    const instrUrl = await uploadHTMLToCloudinary(instrHTML, 'instructions-' + innerCols + 'x' + innerRows + '-' + Date.now() + '.html');

    // 3. Upload source image
    setProgress(80, 'Uploading source image...');
    let sourceUrl = '';
    if(imageSrc) {
      try {
        const srcBlob = await fetch(imageSrc).then(r => r.blob());
        const srcForm = new FormData();
        srcForm.append('file', srcBlob, 'source.png');
        srcForm.append('upload_preset', SHOPIFY_CONFIG.cloudinaryUploadPreset);
        srcForm.append('folder', 'mosaic-designs-v2');
        const srcRes = await fetch('https://api.cloudinary.com/v1_1/' + SHOPIFY_CONFIG.cloudinaryCloudName + '/image/upload', {method:'POST',body:srcForm});
        const srcData = await srcRes.json();
        sourceUrl = srcData.secure_url || '';
      } catch(e) { sourceUrl = ''; }
    }
    setProgress(95, 'Finishing up...');

    preparedDesignUrl = designUrl;
    preparedInstrUrl = instrUrl;
    preparedSourceUrl = sourceUrl;
    preparedVariantId = variantId;
    preparedSizeLabel = sizeLabel;
    preparedShape = shape;
    preparedIsFramed = isFramed;

    setSuccess();

  } catch(err) {
    console.error('Upload error:', err);
    setFailed();
  } finally {
    // Safety: always ensure desktop button is visible
    const safeBtn = document.getElementById('prepare-btn');
    if(safeBtn && safeBtn.style.display === 'none') {
      setTimeout(() => { safeBtn.style.display = ''; }, 2500);
    }
  }
}

// Add to Shopify cart — matching V1 line item property format
async function addToCart() {
  if(!preparedVariantId || !preparedDesignUrl) { alert('Please click "Prepare Mosaic" first.'); return; }

  const cartBtn = document.getElementById('cart-btn');
  cartBtn.disabled = true;
  cartBtn.textContent = '\u23f3 Adding to cart...';

  const properties = {
    '_Uploaded image': preparedSourceUrl || preparedDesignUrl,
    '_Shape': preparedShape || currentShape,
    ['Your custom ' + preparedSizeLabel + ' mosaic']: preparedDesignUrl,
    ['_Assembly instructions for your custom ' + preparedSizeLabel + ' mosaic']: preparedInstrUrl,
    'Baseplate': preparedIsFramed ? 'Framed' : 'Regular',
    '_design_image': preparedDesignUrl,
  };

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: preparedVariantId, quantity: 1, properties }] }),
    });
    if(res.ok) {
      window.location.href = '/cart';
    } else {
      const err = await res.json();
      throw new Error(err.description || 'Could not add to cart');
    }
  } catch(err) {
    console.error('Cart error:', err);
    cartBtn.textContent = '\u2717 Failed \u2014 retry';
    cartBtn.disabled = false;
    alert('Could not add to cart: ' + err.message);
  }
}
function generateInstructionsHTML() {
  if(!rendered) return null;
  const display = playbookGrid.length ? playbookGrid : gridData;
  const isFramed = baseplateMode==='framed';
  const innerCols = isFramed ? gridCols-4 : gridCols;
  const innerRows = isFramed ? gridRows-4 : gridRows;
  const r0off = isFramed ? 2 : 0;
  const c0off = isFramed ? 2 : 0;

  const inner = [];
  for(let y=0;y<innerRows;y++){
    inner[y]=[];
    for(let x=0;x<innerCols;x++) inner[y][x]=display[y+r0off][x+c0off];
  }

  const freq = {};
  inner.forEach(row=>row.forEach(c=>{freq[c]=(freq[c]||0)+1;}));
  const colourOrder = Object.entries(freq).sort((a,b)=>b[1]-a[1]).map(([hex])=>hex);
  const colNum = {};
  colourOrder.forEach((hex,i)=>colNum[hex]=i+1);

  const plan = getInstructionPlan(innerCols, innerRows);
  return buildInstructionsHTML(inner, innerCols, innerRows, colourOrder, colNum, freq, plan, isFramed);
}

// Separated HTML builder so it can be called without opening a window
function buildInstructionsHTML(inner, innerCols, innerRows, colourOrder, colNum, freq, plan, isFramed) {
  // Determine page size up front so renderGrid can use it
  var isSmallPage = !plan.multiPage;
  var logoHtml = '<img src="data:image/png;base64,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" alt="Stereo Hoare" style="height:42px;width:auto;object-fit:contain;display:block;"/>';

  function renderGrid(inner, c0, r0, sectionCols, sectionRows) {
    var cs = bestCellSize(sectionCols, sectionRows, isSmallPage);
    var fontSize = Math.max(5, Math.min(10, Math.round(cs * 0.45)));
    var rowNumW = 14;
    var t = '<table class="grid" style="font-size:' + fontSize + 'px;">';
    t += '<thead><tr><td style="width:' + rowNumW + 'px;height:12px;background:#fafafa;border:none;"></td>';
    for(var x=0;x<sectionCols;x++) t += '<td style="width:' + cs + 'px;height:12px;background:#fafafa;font-size:6px;color:#aaa;text-align:center;padding:0;">' + (c0+x+1) + '</td>';
    t += '</tr></thead><tbody>';
    for(var y=0;y<sectionRows;y++){
      t += '<tr><td style="width:' + rowNumW + 'px;height:' + cs + 'px;background:#fafafa;font-size:6px;color:#aaa;text-align:center;padding:0;">' + (r0+y+1) + '</td>';
      for(var x2=0;x2<sectionCols;x2++){
        var hex=inner[r0+y][c0+x2];
        var num=colNum[hex];
        var rgb=hexToRgb(hex);
        var lum=(0.299*rgb[0]+0.587*rgb[1]+0.114*rgb[2])/255;
        var txtColor=lum>0.45?'#000':'#fff';
        t += '<td style="width:' + cs + 'px;height:' + cs + 'px;background:' + hex + ';color:' + txtColor + ';">' + num + '</td>';
      }
      t += '</tr>';
    }
    t += '</tbody></table>';
    return t;
  }

  function renderKey(hexList) {
    var k = '<div class="colour-key"><div class="colour-key-title">Colour Key</div><div class="colour-key-grid">';
    hexList.forEach(function(hex){
      var n=colNum[hex];
      var name=hexToColorName(hex);
      var count=freq[hex];
      var rgb=hexToRgb(hex);
      var lum=(0.299*rgb[0]+0.587*rgb[1]+0.114*rgb[2])/255;
      var txtColor=lum>0.45?'#000':'#fff';
      k += '<div class="colour-key-item"><div class="key-swatch" style="background:' + hex + ';color:' + txtColor + ';">' + n + '</div>';
      k += '<span class="key-name">' + n + '. ' + name + '</span><span class="key-count">' + count.toLocaleString() + '</span></div>';
    });
    k += '</div></div>';
    return k;
  }

  var pageW = isSmallPage ? '210mm' : '210mm';
  var pageH = isSmallPage ? '250mm' : '297mm';

  var css = '* { margin:0; padding:0; box-sizing:border-box; }';
  css += 'body { font-family: Arial, sans-serif; background:#fff; color:#111; }';
  css += '.page { width:' + pageW + '; min-height:' + pageH + '; padding:12mm; page-break-after:always; display:flex; flex-direction:column; }';
  css += '@page { size: ' + pageW + ' ' + pageH + '; margin: 0; }';
  css += '.page:last-child { page-break-after:auto; }';
  css += '.page-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:4mm; padding-bottom:3mm; border-bottom:1px solid #ccc; }';
  css += '.page-title { font-size:14px; font-weight:700; }';
  css += '.page-subtitle { font-size:9px; color:#666; margin-top:2px; }';
  css += '.grid-wrap { flex:1; display:flex; align-items:flex-start; justify-content:center; }';
  css += 'table.grid { border-collapse:collapse; }';
  css += 'table.grid td { border:0.3px solid rgba(0,0,0,0.2); text-align:center; vertical-align:middle; font-weight:bold; line-height:1; padding:0; }';
  css += '.colour-key { margin-top:3mm; padding-top:3mm; border-top:1px solid #eee; }';
  css += '.colour-key-title { font-size:8px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; color:#888; margin-bottom:2mm; }';
  css += '.colour-key-grid { display:flex; flex-wrap:wrap; gap:3px; }';
  css += '.colour-key-item { display:flex; align-items:center; gap:3px; font-size:7.5px; padding:2px 4px 2px 2px; border:0.5px solid #e0e0e0; border-radius:2px; }';
  css += '.key-swatch { width:13px; height:13px; border:0.5px solid rgba(0,0,0,0.25); border-radius:1px; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:6px; font-weight:bold; }';
  css += '.key-name { color:#333; } .key-count { color:#999; margin-left:2px; }';
  css += '.frame-notice { padding:8px 10px; border:1.5px solid #888; border-radius:4px; font-size:9px; line-height:1.6; margin-bottom:7mm; }';
  css += '.cover-stats { display:flex; gap:0; margin-bottom:7mm; padding:5mm 0; border-top:1px solid #ececec; border-bottom:1px solid #ececec; }';
  css += '.cover-stat { flex:1; text-align:center; border-right:1px solid #ececec; }';
  css += '.cover-stat:last-child { border-right:none; }';
  css += '.cover-stat-val { font-size:21px; font-weight:700; line-height:1; }';
  css += '.cover-stat-label { font-size:7.5px; color:#aaa; text-transform:uppercase; letter-spacing:1.5px; margin-top:2px; }';
  css += '.section-map-grid { display:grid; gap:1px; background:#e0e0e0; }';
  css += '.section-map-cell { background:#fff; padding:10px 4px; text-align:center; font-size:8px; }';
  css += '@media print { body { -webkit-print-color-adjust:exact; print-color-adjust:exact; } .page { padding:10mm; } }';

  var html = '<!DOCTYPE html><html><head><meta charset="UTF-8"/><title>Mosaic Build Instructions</title><style>' + css + '</style></head><body>';

  var totalPages = plan.multiPage ? plan.sections.length + 1 : 1;
  var frameNotice = isFramed ? '<div class="frame-notice"><strong>&#9888; Framed Baseplate:</strong> Fit the framed baseplate completely before placing any bricks. The frame is 2 bricks thick and solid black.</div>' : '';

  if(!plan.multiPage) {
    html += '<div class="page">';
    html += '<div class="page-header">';
    html += '<div><div class="page-title">Mosaic Build Instructions</div>';
    html += '<div class="page-subtitle">' + innerCols + '&#xd7;' + innerRows + ' &middot; ' + colourOrder.length + ' colours &middot; ' + (innerCols*innerRows).toLocaleString() + ' bricks' + (isFramed?' &middot; Fit framed baseplate first':'') + '</div></div>';
    html += '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px;">' + logoHtml + '<div style="font-size:8px;color:#aaa;">Page 1 of 1</div></div>';
    html += '</div>';
    html += frameNotice;
    html += '<div class="grid-wrap">' + renderGrid(inner,0,0,innerCols,innerRows) + '</div>';
    html += renderKey(colourOrder);
    html += '</div>';
  } else {
    var uniqueCols = [...new Set(plan.sections.map(function(s){return s.c0;}))].length;
    // Cover page
    html += '<div class="page" style="background:#fff;">';
    html += '<div style="display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:5mm;border-bottom:2.5px solid #111;margin-bottom:6mm;">';
    html += '<div><div style="font-size:8px;letter-spacing:3px;text-transform:uppercase;color:#bbb;margin-bottom:4px;">Custom Mosaic Designer</div>';
    html += '<div style="font-size:30px;font-weight:800;line-height:1.05;letter-spacing:-1px;">Mosaic Build<br>Instructions</div>';
    html += '<div style="font-size:10px;color:#666;margin-top:6px;">' + innerCols + '&#xd7;' + innerRows + ' &middot; ' + colourOrder.length + ' colours &middot; ' + (innerCols*innerRows).toLocaleString() + ' bricks</div></div>';
    html += '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px;">' + logoHtml + '<div style="font-size:8px;color:#aaa;">Page 1 of ' + totalPages + ' &#8212; Cover</div></div>';
    html += '</div>';
    html += frameNotice;
    // Stats row
    html += '<div class="cover-stats">';
    html += '<div class="cover-stat"><div class="cover-stat-val">' + (innerCols*innerRows).toLocaleString() + '</div><div class="cover-stat-label">Total Bricks</div></div>';
    html += '<div class="cover-stat"><div class="cover-stat-val">' + colourOrder.length + '</div><div class="cover-stat-label">Colours</div></div>';
    html += '<div class="cover-stat"><div class="cover-stat-val">' + innerCols + '&#xd7;' + innerRows + '</div><div class="cover-stat-label">Grid Size</div></div>';
    html += '<div class="cover-stat"><div class="cover-stat-val">' + (totalPages-1) + '</div><div class="cover-stat-label">Grid Pages</div></div>';
    html += '</div>';
    // Design preview image — only for larger designs, tiny JPEG thumbnail
    var designImgHtml = '';
    var isSmallSize = (innerCols <= 48 && innerRows <= 48);
    if(!isSmallSize) {
      try {
        var dc = getDesignCanvas();
        var maxPx = 300;
        var ratio = Math.min(maxPx / dc.width, maxPx / dc.height, 1);
        var tw = Math.round(dc.width * ratio);
        var th = Math.round(dc.height * ratio);
        var thumb = document.createElement('canvas');
        thumb.width = tw; thumb.height = th;
        var tctx = thumb.getContext('2d');
        tctx.imageSmoothingEnabled = false;
        tctx.drawImage(dc, 0, 0, tw, th);
        var dataUrl = thumb.toDataURL('image/jpeg', 0.6);
        designImgHtml = '<div style="text-align:center;margin-bottom:5mm;">' +
          '<p style="font-size:7px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#aaa;margin:0 0 2mm;">Your Design</p>' +
          '<img src="' + dataUrl + '" style="max-width:160mm;max-height:90mm;width:auto;height:auto;border:0.5px solid #ddd;border-radius:2px;image-rendering:pixelated;" />' +
          '</div>';
      } catch(e) { designImgHtml = ''; }
    }
    if(designImgHtml) html += designImgHtml;

    // Body: key + section map
    html += '<div style="display:flex;gap:8mm;flex:1;">';
    // Colour key
    html += '<div style="flex:1;min-width:0;">';
    html += '<div style="font-size:7.5px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#bbb;margin-bottom:3mm;">Colour Key</div>';
    html += '<div style="display:flex;flex-wrap:wrap;gap:4px;">';
    colourOrder.forEach(function(hex){
      var n=colNum[hex];
      var name=hexToColorName(hex);
      var count=freq[hex];
      var rgb=hexToRgb(hex);
      var lum=(0.299*rgb[0]+0.587*rgb[1]+0.114*rgb[2])/255;
      var txt=lum>0.45?'#000':'#fff';
      html += '<div style="display:flex;align-items:center;gap:5px;width:calc(50% - 2px);font-size:8.5px;">';
      html += '<div style="width:20px;height:20px;background:' + hex + ';border:0.5px solid rgba(0,0,0,0.12);border-radius:2px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:8px;font-weight:700;color:' + txt + ';">' + n + '</div>';
      html += '<span style="flex:1;color:#222;">' + n + '. ' + name + '</span>';
      html += '<span style="color:#bbb;font-size:7.5px;">' + count.toLocaleString() + '</span></div>';
    });
    html += '</div></div>';
    // Section map
    html += '<div style="width:60mm;flex-shrink:0;">';
    html += '<div style="font-size:7.5px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#bbb;margin-bottom:3mm;">Page Layout</div>';
    html += '<div style="border:1px solid #ddd;border-radius:3px;overflow:hidden;">';
    html += '<div style="font-size:7.5px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#999;background:#f8f8f8;padding:5px 8px;border-bottom:1px solid #e8e8e8;">Section Map</div>';
    html += '<div class="section-map-grid" style="grid-template-columns:repeat(' + uniqueCols + ',1fr);">';
    plan.sections.forEach(function(s,i){
      html += '<div class="section-map-cell"><span style="display:block;font-size:11px;font-weight:700;">' + (i+2) + '</span><span style="font-size:7.5px;color:#999;">' + s.label + '</span></div>';
    });
    html += '</div></div>';
    html += '<div style="margin-top:3mm;font-size:8px;color:#aaa;line-height:1.6;">Work through pages in order. Row &amp; column numbers continue across sections.</div>';
    html += '</div></div></div>';
    // Section pages
    plan.sections.forEach(function(sec,i){
      var secColors = new Set();
      for(var y=sec.r0;y<sec.r0+sec.rows;y++) for(var x=sec.c0;x<sec.c0+sec.cols;x++) secColors.add(inner[y][x]);
      var secColorList = colourOrder.filter(function(h){return secColors.has(h);});
      html += '<div class="page">';
      html += '<div class="page-header">';
      html += '<div><div class="page-title">Section ' + (i+1) + ' of ' + plan.sections.length + ' &#8212; ' + sec.label + '</div>';
      html += '<div class="page-subtitle">Cols ' + (sec.c0+1) + '&#8211;' + (sec.c0+sec.cols) + ' &middot; Rows ' + (sec.r0+1) + '&#8211;' + (sec.r0+sec.rows) + ' &middot; ' + sec.cols + '&#xd7;' + sec.rows + ' bricks</div></div>';
      html += '<div style="font-size:8px;color:#aaa;">Page ' + (i+2) + ' of ' + totalPages + '</div>';
      html += '</div>';
      html += '<div class="grid-wrap">' + renderGrid(inner,sec.c0,sec.r0,sec.cols,sec.rows) + '</div>';
      html += renderKey(secColorList);
      html += '</div>';
    });
  }

  html += '</body></html>';
  return html;
}

// Mobile accordion toggle

// ══════════════════════════════════════════════
// MOBILE SYSTEM
// ══════════════════════════════════════════════
const isMobile = () => window.innerWidth <= 768;
let mobCurrent = 'upload'; // which section is open

function openMobColorPicker() {
  const grid = document.getElementById('mob-color-picker-grid');
  if(!grid) return;
  grid.innerHTML = '';
  LEGO_COLORS.forEach(c => {
    const isDisabled = disabledColors.has(c.hex);
    const isActive = c.hex === paintColor;
    const btn = document.createElement('button');
    btn.title = c.name;
    btn.style.cssText = [
      'width:40px','height:40px','border-radius:6px',
      'background:'+c.hex,
      'border:'+(isActive?'3px solid var(--gold)':'2px solid rgba(0,0,0,0.15)'),
      'cursor:pointer','flex-shrink:0',
      'opacity:'+(isDisabled?'0.35':'1'),
      '-webkit-tap-highlight-color:transparent'
    ].join(';');
    btn.onclick = () => {
      if(disabledColors.has(c.hex)) { disabledColors.delete(c.hex); buildPaletteUI(); }
      setPaintColor(c.hex);
      closeMobColorPicker();
    };
    grid.appendChild(btn);
  });
  document.getElementById('mob-color-picker-overlay').style.display='block';
  document.getElementById('mob-color-picker-sheet').style.display='block';
}

function closeMobColorPicker() {
  document.getElementById('mob-color-picker-overlay').style.display='none';
  document.getElementById('mob-color-picker-sheet').style.display='none';
}

function initMobile() {
  if (!isMobile()) return;
  mobInitDone = true;
  // display is handled by the @media CSS — no inline style needed

  // Move upload area into Upload panel
  const uploadSlot = document.getElementById('mob-upload-slot');
  const sticky = document.getElementById('left-sticky');
  if (sticky && uploadSlot && !uploadSlot.hasChildNodes()) uploadSlot.appendChild(sticky);

  // Move desktop sections into mobile slots by title
  const sectionMap = { 'mob-size-slot':'02', 'mob-adjust-slot':'03', 'mob-palette-slot':'04' };
  Object.entries(sectionMap).forEach(([slotId, num]) => {
    const slot = document.getElementById(slotId);
    if (!slot || slot.hasChildNodes()) return;
    let target = null;
    document.querySelectorAll('#left-scroll .mobile-section').forEach(s => {
      const t = s.querySelector('.section-title');
      if (t && t.textContent.trim().startsWith(num)) target = s;
    });
    if (!target) return;
    const hdr = target.querySelector('.mobile-section-header');
    const body = target.querySelector('.mobile-section-body');
    if (hdr) hdr.style.display = 'none';
    if (body) { body.style.display = 'block'; body.classList.add('open'); }
    slot.appendChild(target);
  });

  // Build inline colour dots for Tools panel
  buildMobToolColors();

  // Open Upload section on load
  const uploadBtn = document.getElementById('msb-upload');
  if (uploadBtn) mobToggleSection('upload', uploadBtn);
  // Sync active colour swatch now that layout is settled
  updateMobActiveSwatch();
}

function buildMobToolColors() {
  const wrap = document.getElementById('mob-tool-colors');
  if (!wrap || wrap.hasChildNodes()) return;
  LEGO_COLORS.forEach(c => {
    const dot = document.createElement('div');
    dot.className = 'mob-color-dot' + (c.hex === paintColor ? ' active' : '');
    dot.style.background = c.hex;
    dot.title = c.name;
    dot.dataset.hex = c.hex;
    dot.onclick = () => mobSelectToolColor(c.hex, c.name);
    wrap.appendChild(dot);
  });
}

function mobSelectToolColor(hex, name) {
  paintColor = hex;
  paintColorName = name;
  // Sync desktop swatch
  const swatch = document.getElementById('paint-color-swatch');
  if (swatch) {
    swatch.style.background = hex;
    const [r,g,b] = hexToRgb(hex);
    swatch.style.border = ((0.299*r+0.587*g+0.114*b)/255) > 0.6 ? '2px solid var(--border2)' : '2px solid var(--gold)';
  }
  const nameEl = document.getElementById('paint-color-name');
  if (nameEl) nameEl.textContent = name;
  updateMobActiveSwatch();
}

function updateMobActiveSwatch() {
  const swatch = document.getElementById('mob-active-swatch');
  const nameEl = document.getElementById('mob-active-name');
  if(swatch) swatch.style.background = paintColor;
  if(nameEl) nameEl.textContent = paintColorName || 'Unknown';
  document.querySelectorAll('.mob-color-dot').forEach(d => {
    d.classList.toggle('active', d.dataset.hex === paintColor);
    d.classList.toggle('disabled-color', disabledColors && disabledColors.has(d.dataset.hex));
  });
}

function mobToggleSection(name, btn) {
  const wrap = document.getElementById('mob-panel-wrap');
  // Never close panel by tapping same section - only switch between sections
  const isSame = (mobCurrent === name) && wrap.classList.contains('open');
  if (isSame) return; // do nothing if already on this section

  // Switch to new section
  document.querySelectorAll('.mob-sec-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.mob-panel').forEach(p => p.classList.remove('active'));
  const panel = document.getElementById('mob-panel-' + name);
  if (panel) panel.classList.add('active');
  wrap.classList.add('open');
  btn.classList.add('active');
  mobCurrent = name;

  // Scroll panel to top when switching sections
  setTimeout(() => { wrap.scrollTop = 0; }, 10);
}

function mobToggleChips() {
  const body = document.getElementById('mob-chips-body');
  const chev = document.getElementById('mob-chip-chev');
  const open = body.classList.toggle('open');
  chev.textContent = open ? '▴' : '▾';
}

function mobSyncTools() {
  ['brush','bucket','picker','swap','smartsel','mask'].forEach(t => {
    const btn = document.getElementById('mob-tool-' + t);
    if(btn) btn.classList.toggle('active', activeTool === t);
  });
  // Close the edit palette subpanel when any other tool is selected
  const sub = document.getElementById('mob-editpalette-subpanel');
  const paletteBtn = document.getElementById('mob-tool-editpalette');
  if(sub && activeTool !== null) {
    sub.style.display = 'none';
    if(paletteBtn) paletteBtn.classList.remove('active');
  }
}

function toggleMobPan() {
  const isPan = activeTool === 'pan';
  setTool(isPan ? null : 'pan');
  const btn = document.getElementById('mob-pan-btn');
  if(btn) {
    btn.style.background = !isPan ? 'var(--gold)' : 'transparent';
    btn.style.color = !isPan ? '#f5f0e8' : 'var(--muted)';
    btn.style.borderColor = !isPan ? 'var(--gold)' : 'var(--border2)';
  }
  const canvas = document.getElementById('mosaic-canvas');
  if(canvas) canvas.style.cursor = !isPan ? 'grab' : '';
}

function mobToggleEditPalette() {
  const sub = document.getElementById('mob-editpalette-subpanel');
  const btn = document.getElementById('mob-tool-editpalette');
  if(!sub) return;
  const isOpen = sub.style.display !== 'none';
  sub.style.display = isOpen ? 'none' : 'block';
  if(btn) btn.classList.toggle('active', !isOpen);
  // Deselect any active tool when opening palette
  if(!isOpen && activeTool !== null) {
    setTool(null);
    mobSyncTools();
  }
  // Move palette slot content in if not already there
  if(!isOpen) {
    const slot = document.getElementById('mob-palette-slot');
    if(slot && !slot.hasChildNodes()) {
      const src = document.getElementById('left-palette');
      if(src) slot.appendChild(src.cloneNode(true));
    }
  }
}

function updateMobileStats() {
  if (!isMobile() || !rendered) return;
  const isFramed = baseplateMode === 'framed';
  const innerCols = isFramed ? gridCols - 4 : gridCols;
  const innerRows = isFramed ? gridRows - 4 : gridRows;
  const brickEl = document.getElementById('brick-count');

  document.getElementById('mob-dim').textContent = innerCols + ' × ' + innerRows + ' bricks';
  document.getElementById('mob-base').textContent = isFramed ? 'Framed' : 'Regular';
  document.getElementById('mob-bricks').textContent = brickEl ? brickEl.textContent : '—';

  // Price
  const srcPrice = document.getElementById('stat-price');
  if (srcPrice) document.getElementById('mob-price-val').textContent = srcPrice.textContent;

  // Chips
  const srcChips = document.getElementById('color-chips');
  const mobChips = document.getElementById('mob-chips-wrap');
  if (srcChips && mobChips) mobChips.innerHTML = srcChips.innerHTML;
}

function syncMobButtons() {
  if (!isMobile()) return;

  // Download — desktop only, skip on mobile

  // Prepare
  const prepSrc = document.getElementById('prepare-btn');
  const prepMob = document.getElementById('mob-prepare-btn');
  if (prepSrc && prepMob) {
    prepMob.disabled = prepSrc.disabled;
    prepMob.textContent = prepSrc.textContent;
    prepMob.style.background  = prepSrc.style.background  || 'var(--gold)';
    prepMob.style.color       = prepSrc.style.color       || '#f5f0e8';
    prepMob.style.cursor      = prepSrc.disabled ? 'not-allowed' : 'pointer';
  }

  // Cart
  const cartSrc = document.getElementById('cart-btn');
  const cartMob = document.getElementById('mob-cart-btn');
  if (cartSrc && cartMob) {
    cartMob.disabled = cartSrc.disabled;
    cartMob.textContent = cartSrc.textContent;
    cartMob.style.background  = cartSrc.style.background  || 'var(--bg3)';
    cartMob.style.color       = cartSrc.style.color       || 'var(--muted2)';
    cartMob.style.borderColor = cartSrc.style.borderColor || 'var(--border2)';
    cartMob.style.cursor      = cartSrc.disabled ? 'not-allowed' : 'pointer';
  }

  // Status text
  const ss = document.getElementById('prepare-status');
  const ms = document.getElementById('mob-prepare-status');
  if (ss && ms) {
    ms.style.display = ss.style.display;
    ms.textContent   = ss.textContent;
    ms.style.color   = ss.style.color;
  }
}

function toggleMobileSection(header) {
  // desktop accordion fallback
  const chevron = header.querySelector('.mobile-section-chevron');
  const body = header.nextElementSibling;
  if (!body) return;
  const isOpen = body.classList.contains('open');
  body.classList.toggle('open', !isOpen);
  if (chevron) chevron.classList.toggle('open', !isOpen);
}

// Track whether mobile has been initialised
let mobInitDone = false;
window.addEventListener('resize', () => {
  // Only re-init if switching between mobile/desktop
  // Don't re-init on iOS scroll (address bar resize) — just update header height
  const nowMobile = isMobile();
  if (nowMobile && !mobInitDone) { initMobile(); }
});

function toggleSizeGuide() {
  const panel=document.getElementById("size-guide-panel");
  const chevron=document.getElementById("size-guide-chevron");
  const btn=document.getElementById("size-guide-btn");
  const open=panel.style.display==="none";
  panel.style.display=open?"block":"none";
  chevron.textContent=open?"▴":"▾";
  btn.style.borderColor=open?"var(--gold-dim)":"var(--border2)";
  btn.style.color=open?"var(--gold)":"var(--muted)";
}

function isFrameOptional() {
  const key = `${currentRes.cols}x${currentRes.rows}`;
  return FRAME_OPTIONAL_SIZES.has(key);
}

function setBaseplate(mode) {
  if(preparedDesignUrl) resetPrepareState();
  if(mode==='regular' && !isFrameOptional()) return;
  if(!rendered) { baseplateMode=mode; updateBaseplateUI(); return; }
  saveUndo(); // snapshot before baseplate change

  const prev = baseplateMode;
  baseplateMode = mode;
  updateBaseplateUI();

  if(prev === mode) return;

  saveUndo();

  if(mode === 'framed' && prev === 'regular') {
    // Add frame around current playbookGrid
    const {cols, rows} = currentRes;
    const inner = playbookGrid.length ? playbookGrid : gridData;
    const framed = applyFrame(inner, cols, rows);
    playbookGrid = framed.grid;
    gridCols = framed.cols;
    gridRows = framed.rows;
    // Resize canvas
    const canvas = document.getElementById("mosaic-canvas");
    canvas.width = gridCols * cellSize;
    canvas.height = gridRows * cellSize;
    const sc = document.getElementById("selection-canvas");
    sc.width = canvas.width; sc.height = canvas.height;
  } else if(mode === 'regular' && prev === 'framed') {
    // Strip the 2-brick border — extract just the inner cells
    const inner = [];
    for(let y=2; y<gridRows-2; y++) {
      inner.push(playbookGrid[y].slice(2, gridCols-2));
    }
    const {cols, rows} = currentRes;
    playbookGrid = inner;
    gridCols = cols;
    gridRows = rows;
    const canvas = document.getElementById("mosaic-canvas");
    canvas.width = gridCols * cellSize;
    canvas.height = gridRows * cellSize;
    const sc = document.getElementById("selection-canvas");
    sc.width = canvas.width; sc.height = canvas.height;
  }

  drawGridToCanvas(playbookGrid, gridCols, gridRows, document.getElementById("mosaic-canvas"));
  updateStats();
}

function updateBaseplateUI() {
  const optional = isFrameOptional();
  const regBtn = document.getElementById("bp-regular");
  const fraBtn = document.getElementById("bp-framed");
  const hint = document.getElementById("bp-hint");
  if(!regBtn||!fraBtn) return;

  if(!optional) {
    // Frame required — lock Regular off, force Framed active
    baseplateMode = 'framed';
    regBtn.classList.remove("active");
    regBtn.classList.add("disabled");
    fraBtn.classList.add("active");
    fraBtn.classList.remove("disabled");
    hint.textContent="Frame required for this size — framed baseplate only.";
  } else {
    // User can choose
    regBtn.classList.remove("disabled");
    fraBtn.classList.remove("disabled");
    regBtn.classList.toggle("active", baseplateMode==='regular');
    fraBtn.classList.toggle("active", baseplateMode==='framed');
    hint.textContent = baseplateMode==='framed'
      ? "Framed baseplate. Total size: "+(currentRes.cols+4)+"×"+(currentRes.rows+4)+" bricks."
      : "Regular baseplate — no border added.";
  }
}

// Apply 2-brick black frame to a grid — returns a new larger grid
// Frame uses a slightly darker shade than LEGO Black so it reads as distinct
function applyFrame(grid, cols, rows) {
  const FRAME_COLOR = "#050A0F"; // darker than LEGO Black (#1B2A34)
  const newCols = cols + 4;
  const newRows = rows + 4;
  const framed = [];
  for(let y=0; y<newRows; y++) {
    framed[y] = [];
    for(let x=0; x<newCols; x++) {
      const isFrame = x<2 || y<2 || x>=newCols-2 || y>=newRows-2;
      framed[y][x] = isFrame ? FRAME_COLOR : grid[y-2][x-2];
    }
  }
  return {grid:framed, cols:newCols, rows:newRows};
}
let snapBeforeDrag = null;
function startAdjDrag() {
  // Capture full state BEFORE drag starts (only first mousedown)
  if(!snapBeforeDrag) snapBeforeDrag = captureState();
}
function endAdjDrag() {
  // Save the pre-drag snapshot if adj actually changed
  if(snapBeforeDrag) {
    const adjChanged = JSON.stringify(snapBeforeDrag.adj) !== JSON.stringify(adj);
    if(adjChanged) {
      undoStack.push(snapBeforeDrag);
      if(undoStack.length>MAX_UNDO) undoStack.shift();
      redoStack=[];
      updateUndoBtn();
      updateRedoBtn();
      if(preparedDesignUrl) resetPrepareState();
    }
    snapBeforeDrag = null;
  }
}

function updateAdj(fromFilter) {
  if(preparedDesignUrl) resetPrepareState();
  // Note: slider undo is handled by startAdjDrag/endAdjDrag on mousedown/mouseup
  adj.brightness=parseInt(document.getElementById("sl-brightness").value);
  adj.contrast=parseInt(document.getElementById("sl-contrast").value);
  adj.saturation=parseInt(document.getElementById("sl-saturation").value);
  adj.hue=parseInt(document.getElementById("sl-hue").value);
  adj.detail=parseInt(document.getElementById("sl-detail").value);
  adj.red=parseInt(document.getElementById("sl-red").value);
  adj.green=parseInt(document.getElementById("sl-green").value);
  adj.blue=parseInt(document.getElementById("sl-blue").value);
  adj.colors=parseInt(document.getElementById("sl-colors").value);
  const fmt=v=>(v>0?"+"+v:""+v);
  document.getElementById("lbl-brightness").textContent=fmt(adj.brightness);
  document.getElementById("lbl-contrast").textContent=fmt(adj.contrast);
  document.getElementById("lbl-saturation").textContent=fmt(adj.saturation);
  document.getElementById("lbl-hue").textContent=adj.hue+"°";
  document.getElementById("lbl-detail").textContent=adj.detail;
  document.getElementById("lbl-red").textContent=fmt(adj.red);
  document.getElementById("lbl-green").textContent=fmt(adj.green);
  document.getElementById("lbl-blue").textContent=fmt(adj.blue);
  document.getElementById("lbl-colors").textContent=adj.colors;
  if(!fromFilter) document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
  if(rendered) doRender();
}
function resetAdj() {
  ["sl-brightness","sl-contrast","sl-saturation","sl-hue","sl-detail","sl-red","sl-green","sl-blue"].forEach(id=>document.getElementById(id).value=0);
  document.getElementById("sl-colors").value=adjColorsDefault;
  document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
  updateAdj(true);
}

// Silent version — sets DOM without triggering re-render (used on upload)
function resetAdjSilent() {
  if(activeQuickFilter==="Black & White") setLightBluishGrayEnabled(true);
  activeQuickFilter=null;
  ["sl-brightness","sl-contrast","sl-saturation","sl-hue","sl-detail","sl-red","sl-green","sl-blue"].forEach(id=>document.getElementById(id).value=0);
  document.getElementById("sl-colors").value=50;
  document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
  adj={brightness:0,contrast:0,saturation:0,hue:0,detail:0,red:0,green:0,blue:0,colors:50};
  ["lbl-brightness","lbl-contrast","lbl-saturation","lbl-detail","lbl-red","lbl-green","lbl-blue"].forEach(id=>document.getElementById(id).textContent="0");
  document.getElementById("lbl-hue").textContent="0°";
  document.getElementById("lbl-colors").textContent="—";
}

// ── ADVANCED FILTERS ──────────────────────────────────────────────────────────
let activeAdvFilter = null;

const ADVANCED_FILTERS = [
  {
    id:"cartoon",
    name:"Cartoon",
    desc:"High contrast + 8 colours + flat regions",
    apply(grid, cols, rows, palette) {
      // Boost contrast by pushing each colour toward extremes
      const out = grid.map(r=>[...r]);
      let lumSum=0, cnt=0;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){lumSum+=getLuminance(grid[y][x]);cnt++;}
      const avg=lumSum/cnt;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(grid[y][x]);
        const [r,g,b]=hexToRgb(grid[y][x]);
        if(lum>avg){
          const c=palette.filter(p=>getLuminance(p)>lum+0.08);
          if(c.length>0) out[y][x]=getClosestColor(r,g,b,c);
        } else {
          const c=palette.filter(p=>getLuminance(p)<lum-0.08);
          if(c.length>0) out[y][x]=getClosestColor(r,g,b,c);
        }
      }
      // Reduce to 8 colours
      return quantizePlaybook(out, cols, rows, 8);
    }
  },
  {
    id:"stencil",
    name:"Pencil",
    desc:"Black line drawing on white — traces object boundaries",
    apply(grid, cols, rows, palette) {
      const black=getClosestColor(0,0,0,["#1B2A34","#575857","#6C6E68"]);
      const white=getClosestColor(255,255,255,["#FFFFFF","#AFB5C7","#898788"]);

      // Use a low luminance threshold to catch more meaningful edges
      // including fine details like hair, clothing folds, facial features
      const THRESHOLD=0.08;
      const edgeMask=new Uint8Array(cols*rows);

      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(grid[y][x]);
        // Check 4 direct neighbours for contrast
        const isEdge=[[1,0],[-1,0],[0,1],[0,-1]].some(([dx,dy])=>{
          const nx=x+dx,ny=y+dy;
          if(nx<0||ny<0||nx>=cols||ny>=rows) return false;
          return Math.abs(getLuminance(grid[ny][nx])-lum)>THRESHOLD;
        });
        if(isEdge) edgeMask[x+y*cols]=1;
      }

      // Thin pass: remove cells where ALL neighbours are also edges
      // (solid edge blobs) — keeps only the outer ring of edge regions
      const out=grid.map(r=>[...r]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        if(!edgeMask[x+y*cols]){ out[y][x]=white; continue; }
        // Count non-edge neighbours
        const nonEdgeNeighbours=[[1,0],[-1,0],[0,1],[0,-1]].filter(([dx,dy])=>{
          const nx=x+dx,ny=y+dy;
          if(nx<0||ny<0||nx>=cols||ny>=rows) return true; // border counts as non-edge
          return !edgeMask[nx+ny*cols];
        }).length;
        // Keep as black if it has at least one non-edge neighbour (= it's on the boundary)
        out[y][x]=nonEdgeNeighbours>0?black:white;
      }
      return out;
    }
  },
  {
    id:"blockcolour",
    name:"Block Colours",
    desc:"Colours ÷ 4 (rounded up), minimum 4",
    apply(grid, cols, rows, palette) {
      const total=new Set(grid.flat()).size;
      const target=Math.max(4, Math.ceil(total/4));
      return quantizePlaybook(grid, cols, rows, target);
    }
  },
  {
    id:"warhol",
    name:"Warhol",
    desc:"2×2 quad recoloured with 4 bold palettes",
    apply(grid, cols, rows, palette) {
      const halfC=Math.floor(cols/2), halfR=Math.floor(rows/2);
      // 4 palette presets — each is a colour-family filter
      const palettes=[
        // Warm: reds oranges yellows
        palette.filter(h=>{const[r,g,b]=hexToRgb(h);return r>g&&r>b;}),
        // Cool: blues greens purples
        palette.filter(h=>{const[r,g,b]=hexToRgb(h);return b>r||g>r;}),
        // Earth: browns tans olives
        palette.filter(h=>{const[r,g,b]=hexToRgb(h);const lum=getLuminance(h);return lum<0.5&&r>=g&&g>=b*0.7;}),
        // High contrast: just blacks whites greys
        palette.filter(h=>{const[r,g,b]=hexToRgb(h);return Math.max(r,g,b)-Math.min(r,g,b)<40;}),
      ].map(p=>p.length>=3?p:palette); // fallback to full palette if filtered too small

      const out=grid.map(r=>[...r]);
      const quadrant=(x,y)=>(x<halfC?0:1)+(y<halfR?0:2);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const q=quadrant(x,y);
        const pal=palettes[q];
        const [r,g,b]=hexToRgb(grid[y][x]);
        out[y][x]=getClosestColor(r,g,b,pal);
      }
      return out;
    }
  },
  {
    id:"heatmap",
    name:"Heatmap",
    desc:"Luminance remapped to thermal colours",
    apply(grid, cols, rows, palette) {
      // Thermal palette: dark=deep blue, mid=orange/yellow, bright=white
      // Map luminance 0→1 to a colour family
      const out=grid.map(r=>[...r]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(grid[y][x]);
        let targetR,targetG,targetB;
        if(lum<0.25){
          // Dark → deep blue/navy
          targetR=0; targetG=0; targetB=180;
        } else if(lum<0.5){
          // Mid-low → teal/cyan
          targetR=0; targetG=160; targetB=180;
        } else if(lum<0.75){
          // Mid-high → orange/yellow
          targetR=220; targetG=130; targetB=0;
        } else {
          // Bright → white/cream
          targetR=255; targetG=230; targetB=180;
        }
        out[y][x]=getClosestColor(targetR,targetG,targetB,palette);
      }
      return out;
    }
  },
  {
    id:"outlined",
    name:"Outlined",
    desc:"Contrasting outlines — adapts to background and subject colours",
    apply(grid, cols, rows, palette) {
      // Step 1: detect background colour via edge-connected flood fill
      const edgeCount={};
      for(let x=0;x<cols;x++){
        [grid[0][x],grid[rows-1][x]].forEach(c=>{edgeCount[c]=(edgeCount[c]||0)+1;});
      }
      for(let y=1;y<rows-1;y++){
        [grid[y][0],grid[y][cols-1]].forEach(c=>{edgeCount[c]=(edgeCount[c]||0)+1;});
      }
      const bgColor=Object.entries(edgeCount).sort((a,b)=>b[1]-a[1])[0]?.[0]||grid[0][0];
      const bgLum=getLuminance(bgColor);

      // Step 2: detect edges between regions
      const edgeMask=new Uint8Array(cols*rows);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const cur=grid[y][x];
        const isEdge=[[1,0],[-1,0],[0,1],[0,-1]].some(([dx,dy])=>{
          const nx=x+dx,ny=y+dy;
          if(nx<0||ny<0||nx>=cols||ny>=rows) return false;
          return grid[ny][nx]!==cur;
        });
        if(isEdge) edgeMask[x+y*cols]=1;
      }

      const out=grid.map(r=>[...r]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        if(!edgeMask[x+y*cols]) continue;
        const cellLum=getLuminance(grid[y][x]);
        const neighbourLums=[];
        [[1,0],[-1,0],[0,1],[0,-1]].forEach(([dx,dy])=>{
          const nx=x+dx,ny=y+dy;
          if(nx>=0&&ny>=0&&nx<cols&&ny<rows) neighbourLums.push(getLuminance(grid[ny][nx]));
        });
        const avgNeighbourLum=neighbourLums.length?neighbourLums.reduce((a,b)=>a+b)/neighbourLums.length:cellLum;
        const localAvgLum=(cellLum+avgNeighbourLum)/2;
        let targetR,targetG,targetB;
        if(localAvgLum>0.55){targetR=0;targetG=0;targetB=0;}
        else if(localAvgLum<0.35){targetR=255;targetG=255;targetB=255;}
        else{if(bgLum>0.5){targetR=0;targetG=0;targetB=0;}else{targetR=255;targetG=255;targetB=255;}}
        out[y][x]=getClosestColor(targetR,targetG,targetB,palette);
      }
      return out;
    }
  },
  {
    id:"inverted",
    name:"Inverted",
    desc:"Flips every colour to its luminance opposite",
    apply(grid, cols, rows, palette) {
      const out=grid.map(r=>[...r]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const [r,g,b]=hexToRgb(grid[y][x]);
        // Invert each channel
        const ir=255-r, ig=255-g, ib=255-b;
        out[y][x]=getClosestColor(ir,ig,ib,palette);
      }
      return out;
    }
  },
  {
    id:"sketch",
    name:"Sketch",
    desc:"Greyscale only — black, greys and white",
    apply(grid, cols, rows, palette) {
      // Fixed greyscale palette — exactly these 6 LEGO neutral colours, no exceptions
      const GREY_HEXES = [
        "#FFFFFF", // White
        "#9BA19D", // Light Gray
        "#898788", // Flat Silver
        "#6C6E68", // Dark Bluish Gray
        "#575857", // Pearl Dark Gray
        "#1B2A34", // Black
        // Explicitly excludes: Light Bluish Gray (#AFB5C7), Light Aqua (#ADC3C0)
        // and all other non-neutral colours
      ];
      const workingPalette = GREY_HEXES;

      const out=grid.map(r=>[...r]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(grid[y][x]);
        const v=Math.round(lum*255);
        out[y][x]=getClosestColor(v,v,v,workingPalette);
      }
      return out;
    }
  }
];

// ── DESIGN TIPS FLOATING CARD ─────────────────────────────────────────────────
// Each tip specifies where the card should float
// anchor: 'left-panel' | 'toolbar' | 'stats' | 'canvas-top' | 'canvas-mid'
const DESIGN_TIPS = [
  {
    cat:"Getting Started", catClass:"tips-cat-getting-started",
    anchor:"left-panel-top",
    title:"Choose the right image",
    body:"High contrast images work best — bold shapes, clear subjects, and a distinct background. Close-up portraits, simple logos, and iconic imagery tend to look great. Busy group shots can get muddy at low resolutions.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="40" height="40" rx="4" fill="#1a1a1a" stroke="#333" stroke-width="1"/><circle cx="22" cy="17" r="7" fill="#FFD700" opacity="0.9"/><ellipse cx="22" cy="34" rx="11" ry="6" fill="#FFD700" opacity="0.5"/><circle cx="22" cy="17" r="4" fill="#1a1a1a"/></svg>`
  },
  {
    cat:"Getting Started", catClass:"tips-cat-getting-started",
    anchor:"left-panel-top",
    title:"Picking your resolution",
    body:"32×32 is great for a first try — fast to generate, easy to edit. Go 48×48 or 64×64 for more detail, especially for faces.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="18" height="18" rx="2" fill="#FFD700" opacity="0.9"/><text x="11" y="15" text-anchor="middle" fill="#000" font-size="7" font-family="monospace" font-weight="bold">32</text><rect x="24" y="2" width="18" height="18" rx="2" fill="#333" stroke="#555" stroke-width="1"/><text x="33" y="15" text-anchor="middle" fill="#888" font-size="7" font-family="monospace">48</text><rect x="2" y="24" width="18" height="18" rx="2" fill="#333" stroke="#555" stroke-width="1"/><text x="11" y="37" text-anchor="middle" fill="#888" font-size="7" font-family="monospace">64</text><rect x="24" y="24" width="18" height="18" rx="2" fill="#333" stroke="#555" stroke-width="1"/><text x="33" y="37" text-anchor="middle" fill="#888" font-size="7" font-family="monospace">96</text></svg>`
  },
  {
    cat:"Image Tips", catClass:"tips-cat-image-tips",
    anchor:"left-panel-mid",
    title:"Quick filters set the mood",
    body:"Try Vivid or High Contrast before generating — they punch up colour separation so bricks map to more distinct shades. Apply a filter first, then fine-tune with the individual sliders underneath.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="tg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#ff6b6b"/><stop offset="50%" stop-color="#FFD700"/><stop offset="100%" stop-color="#4ecdc4"/></linearGradient></defs><rect x="2" y="2" width="40" height="40" rx="4" fill="url(#tg)" opacity="0.8"/><rect x="8" y="18" width="28" height="3" rx="1.5" fill="white" opacity="0.9"/><rect x="8" y="25" width="20" height="3" rx="1.5" fill="white" opacity="0.6"/><circle cx="32" cy="26.5" r="3" fill="white" opacity="0.9"/></svg>`
  },
  {
    cat:"Image Tips", catClass:"tips-cat-image-tips",
    anchor:"left-panel-mid",
    title:"The Colours slider",
    body:"The Colours slider auto-sets to your design's colour count on upload. Drag left to reduce — fewer colours means a bolder, cleaner result. 8–12 colours is often the sweet spot. Under 6 looks very graphic and intentional.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="6" height="6" rx="1" fill="#e74c3c"/><rect x="13" y="4" width="6" height="6" rx="1" fill="#3498db"/><rect x="22" y="4" width="6" height="6" rx="1" fill="#2ecc71"/><rect x="31" y="4" width="6" height="6" rx="1" fill="#f39c12"/><rect x="4" y="13" width="6" height="6" rx="1" fill="#9b59b6"/><rect x="13" y="13" width="6" height="6" rx="1" fill="#1abc9c"/><rect x="22" y="13" width="6" height="6" rx="1" fill="#e67e22"/><rect x="31" y="13" width="6" height="6" rx="1" fill="#e74c3c" opacity="0.3"/><line x1="4" y1="30" x2="40" y2="30" stroke="#444" stroke-width="2"/><circle cx="20" cy="30" r="4" fill="#FFD700"/><text x="22" y="42" text-anchor="middle" fill="#888" font-size="8" font-family="monospace">7</text></svg>`
  },
  {
    cat:"Image Tips", catClass:"tips-cat-image-tips",
    anchor:"canvas-mid",
    title:"Getting faces right",
    body:"Faces need at least 48×48 to read clearly. Best skin tones to use: Nougat, Light Nougat, Sand Red, Brown, Dark Brown, and Tan — keep these enabled in the palette. Boost contrast slightly and lower colours to 10–14 so the face stays clean. Colours that often appear on skin tones but we recommend avoiding: Orange and Coral.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><circle cx="22" cy="18" r="12" fill="#C8914A"/><circle cx="17" cy="15" r="2" fill="#1a1a1a"/><circle cx="27" cy="15" r="2" fill="#1a1a1a"/><path d="M16 23 Q22 28 28 23" stroke="#1a1a1a" stroke-width="1.5" fill="none" stroke-linecap="round"/><rect x="8" y="4" width="6" height="6" rx="1" fill="#C8914A" opacity="0.9"/><rect x="16" y="4" width="6" height="6" rx="1" fill="#D4956A" opacity="0.9"/><rect x="24" y="4" width="6" height="6" rx="1" fill="#B87040" opacity="0.9"/></svg>`
  },
  {
    cat:"Image Tips", catClass:"tips-cat-image-tips",
    anchor:"canvas-mid",
    title:"Text in your image",
    body:"Text becomes much clearer at 48×48 and above. We recommend using the largest, boldest version of any text from your image — the more detail in the source, the better it translates. Make sure the background behind the text is very contrasting. For the best results, we often recommend using the paintbrush tool to hand-draw the text yourself brick by brick — it gives you full control over every letter.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="8" width="40" height="28" rx="3" fill="#1a1a1a" stroke="#333" stroke-width="1"/><rect x="6" y="14" width="12" height="4" rx="1" fill="#FFD700" opacity="0.9"/><rect x="6" y="20" width="18" height="4" rx="1" fill="#FFD700" opacity="0.9"/><rect x="6" y="26" width="8" height="4" rx="1" fill="#FFD700" opacity="0.5"/><line x1="30" y1="8" x2="30" y2="36" stroke="#e74c3c" stroke-width="1.5" stroke-dasharray="2,2"/><text x="36" y="25" text-anchor="middle" fill="#e74c3c" font-size="14" font-family="monospace">✕</text></svg>`
  },
  {
    cat:"Image Tips", catClass:"tips-cat-image-tips",
    anchor:"canvas-mid",
    title:"Manual editing gets the best results",
    body:"The auto-generate is a great starting point but the real magic happens with manual edits. Use the paintbrush to fix individual bricks and the bucket tool to fill large areas instantly. Most great mosaics have had at least some manual work done — don't be afraid to go in and correct colours, tidy edges, or repaint areas that don't look right.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="40" height="40" rx="4" fill="#1a1a1a" stroke="#333" stroke-width="1"/><rect x="6" y="6" width="8" height="8" rx="1" fill="#e74c3c"/><rect x="14" y="6" width="8" height="8" rx="1" fill="#e74c3c"/><rect x="6" y="14" width="8" height="8" rx="1" fill="#FFD700"/><rect x="14" y="14" width="8" height="8" rx="1" fill="#FFD700"/><rect x="22" y="6" width="8" height="8" rx="1" fill="#3498db"/><rect x="30" y="6" width="8" height="8" rx="1" fill="#3498db"/><rect x="22" y="14" width="8" height="8" rx="1" fill="#3498db"/><rect x="30" y="14" width="8" height="8" rx="1" fill="#3498db"/><line x1="10" y1="28" x2="38" y2="28" stroke="#FFD700" stroke-width="2" stroke-linecap="round"/><circle cx="10" cy="28" r="4" fill="#FFD700"/><path d="M34 24 L38 28 L34 32" stroke="#FFD700" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>`
  },
  {
    cat:"Toolkit", catClass:"tips-cat-toolkit",
    anchor:"toolbar",
    title:"Smart Select for backgrounds",
    body:"Click ✦, then click anywhere on the background. It selects all connected bricks of similar colour. Dial up tolerance if it's missing bits. Hit Fill outside to isolate your subject. Ctrl+click adds more regions to the selection.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="40" height="40" rx="4" fill="#1B2A34" opacity="0.6"/><rect x="2" y="2" width="40" height="40" rx="4" fill="#FFD700" opacity="0.25"/><circle cx="22" cy="22" r="10" fill="#1B2A34"/><circle cx="22" cy="22" r="6" fill="#3498db"/><text x="22" y="26" text-anchor="middle" fill="white" font-size="10" font-family="monospace">✦</text></svg>`
  },
  {
    cat:"Toolkit", catClass:"tips-cat-toolkit",
    anchor:"toolbar",
    title:"Colour swapper saves time",
    body:"See a colour that's wrong everywhere? Hit ⇄, click any brick of that colour — it highlights every one. Pick the replacement and Apply. Great for fixing a wrong skin tone or muddy background colour across the whole design.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" fill="#e74c3c"/><rect x="24" y="4" width="16" height="16" rx="2" fill="#e74c3c" opacity="0.3"/><rect x="4" y="24" width="16" height="16" rx="2" fill="#e74c3c"/><rect x="24" y="24" width="16" height="16" rx="2" fill="#e74c3c" opacity="0.3"/><path d="M18 14 L26 14 M23 11 L26 14 L23 17" stroke="#FFD700" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M26 30 L18 30 M21 27 L18 30 L21 33" stroke="#FFD700" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`
  },
  {
    cat:"Finishing", catClass:"tips-cat-finishing",
    anchor:"stats",
    title:"Framed vs Regular baseplate",
    body:"The framed baseplate creates a solid black border around the entire design, 2 bricks thick — it makes the mosaic look polished and finished. For 32×32 and 48×48 you can choose Regular or Framed. All larger sizes require the framed baseplate. Frame bricks are never counted in your brick total.",
    svg:`<svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="40" height="40" rx="3" fill="#050A0F"/><rect x="7" y="7" width="30" height="30" rx="2" fill="#3498db" opacity="0.7"/><rect x="11" y="11" width="22" height="22" rx="1" fill="#FFD700" opacity="0.5"/><circle cx="22" cy="22" r="5" fill="#FFD700"/></svg>`
  }
];

let currentTipIndex = 0;
let tipsOpen = true;

function positionTip(anchor) {
  const card = document.getElementById("tips-float");
  const leftPanel = document.querySelector(".left-panel");
  const toolbar = document.getElementById("toolbar");
  const statsBar = document.getElementById("stats-bar");
  const leftW = leftPanel ? leftPanel.getBoundingClientRect().right : 300;
  const toolbarH = toolbar ? toolbar.getBoundingClientRect().bottom : 80;
  const statsTop = statsBar ? statsBar.getBoundingClientRect().top : window.innerHeight - 100;
  const W = card.offsetWidth || 300;

  // Default: right side of canvas, upper area
  let top, left, right;

  if(anchor === "left-panel-top") {
    // Floats to the right of the left panel, near the top
    left = leftW + 16;
    top = toolbarH + 20;
  } else if(anchor === "left-panel-mid") {
    // Mid-height of screen, just right of left panel
    left = leftW + 16;
    top = window.innerHeight * 0.35;
  } else if(anchor === "toolbar") {
    // Below the toolbar, centred in the canvas area
    left = leftW + (window.innerWidth - leftW) / 2 - W / 2;
    top = toolbarH + 16;
  } else if(anchor === "canvas-mid") {
    // Floating in the canvas — right edge, vertically centred
    left = window.innerWidth - W - 20;
    top = window.innerHeight * 0.3;
  } else if(anchor === "stats") {
    // Just above the stats bar
    left = window.innerWidth - W - 20;
    top = statsTop - (card.offsetHeight || 200) - 16;
  } else {
    left = window.innerWidth - W - 20;
    top = toolbarH + 20;
  }

  // Clamp so it never goes off screen
  top = Math.max(toolbarH + 10, Math.min(top, window.innerHeight - (card.offsetHeight||200) - 60));
  left = Math.max(leftW + 8, Math.min(left, window.innerWidth - W - 8));

  card.style.top = top + "px";
  card.style.left = left + "px";
  card.style.right = "auto";
  card.style.bottom = "auto";
}

function buildTips() {
  showTip(0);
}

function showTip(idx) {
  currentTipIndex = idx;
  const tip = DESIGN_TIPS[idx];

  const catEl = document.getElementById("tips-category");
  catEl.textContent = tip.cat;
  catEl.className = tip.catClass;
  document.getElementById("tips-title").textContent = tip.title;
  document.getElementById("tips-body").textContent = tip.body;
  document.getElementById("tips-illustration").innerHTML = tip.svg;
  document.getElementById("tips-counter").textContent = `${idx+1} / ${DESIGN_TIPS.length}`;

  // Build dots
  const dotsEl = document.getElementById("tips-dots");
  dotsEl.innerHTML = "";
  DESIGN_TIPS.forEach((_,i)=>{
    const d = document.createElement("div");
    d.className = "tip-dot" + (i===idx?" active":"");
    d.onclick = ()=>showTip(i);
    dotsEl.appendChild(d);
  });

  // Position after a brief delay so card dimensions are known
  setTimeout(()=>positionTip(tip.anchor), 20);
}

function nextTip() { showTip((currentTipIndex+1) % DESIGN_TIPS.length); }
function prevTip() { showTip((currentTipIndex-1+DESIGN_TIPS.length) % DESIGN_TIPS.length); }

function closeTips() {
  tipsOpen = false;
  document.getElementById("tips-float").style.display = "none";
  document.getElementById("tips-reopen-btn").style.display = "block";
}

function openTips() {
  tipsOpen = true;
  document.getElementById("tips-float").style.display = "block";
  document.getElementById("tips-reopen-btn").style.display = "none";
  showTip(0); // Always start at tip 1 (choosing image)
}

// Reposition on resize
window.addEventListener("resize", ()=>{
  if(tipsOpen) positionTip(DESIGN_TIPS[currentTipIndex].anchor);
});

function buildAdvancedFilters() {
  const grid=document.getElementById("advanced-filter-grid");
  grid.innerHTML="";
  ADVANCED_FILTERS.forEach(f=>{
    const btn=document.createElement("button");
    btn.className="adv-filter-btn";
    btn.id="adv-"+f.id;
    btn.innerHTML=`<div style="font-weight:500;">${f.name}</div>`;
    btn.onclick=()=>applyAdvFilter(f,btn);
    grid.appendChild(btn);
  });
}

// Light Bluish Gray hex — disabled for sketch/pencil filters
const LIGHT_BLUISH_GRAY = "#AFB5C7";
const LIGHT_AQUA = "#ADC3C0";
const GREY_FILTER_IDS = new Set(["sketch","stencil"]);

function setLightBluishGrayEnabled(enabled) {
  [LIGHT_BLUISH_GRAY, LIGHT_AQUA].forEach(hex => {
    if(enabled) disabledColors.delete(hex);
    else disabledColors.add(hex);
    document.querySelectorAll(".swatch").forEach(s=>{
      if(s.style.background===hex||s.title==="Light Bluish Gray"||s.title==="Light Aqua"){
        s.classList.toggle("off",!enabled);
      }
    });
  });
}

function resetQuickFilters() {
  if(activeQuickFilter==="Black & White") setLightBluishGrayEnabled(true);
  activeQuickFilter=null;
  ["sl-brightness","sl-contrast","sl-saturation","sl-hue"].forEach(id=>{
    document.getElementById(id).value=0;
  });
  document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
  updateAdj(true);
}

function setAdvFilterIndicator(name) {
  const label = document.getElementById("adv-filter-label");
  const clear = document.getElementById("adv-filter-clear");
  const box = document.getElementById("adv-filter-active");
  if(name) {
    label.textContent = name + " active";
    label.style.color = "var(--gold)";
    box.style.background = "var(--bg2)";
    box.style.borderColor = "var(--gold-dim)";
    clear.style.display = "inline";
  } else {
    label.textContent = "None selected";
    label.style.color = "var(--muted)";
    box.style.background = "var(--bg3)";
    box.style.borderColor = "var(--border2)";
    clear.style.display = "none";
  }
}

// Store the grid state before any advanced filter was applied
let preFilterGrid = [];

function applyAdvFilter(f, btn) {
  if(!rendered) return;

  // Toggle off if already active
  if(activeAdvFilter===f.id){
    clearAdvFilter();
    return;
  }

  // If switching from another filter, restore the pre-filter grid first
  if(activeAdvFilter && preFilterGrid.length) {
    playbookGrid=preFilterGrid.map(r=>[...r]);
    if(GREY_FILTER_IDS.has(activeAdvFilter)) setLightBluishGrayEnabled(true);
  } else {
    saveUndo();
    const source=playbookGrid.length?playbookGrid:gridData;
    preFilterGrid=source.map(r=>[...r]);
  }

  activeAdvFilter=f.id;
  document.querySelectorAll(".adv-filter-btn").forEach(b=>b.classList.remove("active"));
  btn.classList.add("active");

  if(GREY_FILTER_IDS.has(f.id)) setLightBluishGrayEnabled(false);

  const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));

  // Apply filter to a copy — then restore frame cells afterward
  const filtered=f.apply(preFilterGrid.map(r=>[...r]),gridCols,gridRows,palette);
  restoreFrameCells(filtered);
  playbookGrid=filtered;

  redrawGrid();
  buildPaletteUI(); // keep palette swatches in sync
  setAdvFilterIndicator(f.name);
}

// Restores frame cells in a grid to the correct frame colour
// so advanced filters can never overwrite the border
function restoreFrameCells(grid) {
  if(baseplateMode!=='framed') return;
  const FRAME_COLOR="#050A0F";
  for(let y=0;y<gridRows;y++) for(let x=0;x<gridCols;x++){
    if(isFrameCell(x,y)) grid[y][x]=FRAME_COLOR;
  }
}

function clearAdvFilter() {
  if(!activeAdvFilter) return;
  // Re-enable LBG if a grey filter was active
  if(GREY_FILTER_IDS.has(activeAdvFilter)) setLightBluishGrayEnabled(true);
  // Restore the grid to how it was before the filter
  if(preFilterGrid.length){
    saveUndo();
    playbookGrid=preFilterGrid.map(r=>[...r]);
    preFilterGrid=[];
    redrawGrid();
  }
  activeAdvFilter=null;
  document.querySelectorAll(".adv-filter-btn").forEach(b=>b.classList.remove("active"));
  setAdvFilterIndicator(null);
}

function clearAdvFilterSilent() {
  if(activeAdvFilter && GREY_FILTER_IDS.has(activeAdvFilter)) setLightBluishGrayEnabled(true);
  activeAdvFilter=null;
  preFilterGrid=[];
  const btns=document.querySelectorAll(".adv-filter-btn");
  if(btns) btns.forEach(b=>b.classList.remove("active"));
  setTimeout(()=>setAdvFilterIndicator(null), 0); // defer until DOM ready
}
let activeQuickFilter = null;

function applyFilter(f,btn) {
  if(preparedDesignUrl) resetPrepareState();
  saveUndo(); // snapshot BEFORE changing filter state
  // Toggle off if already active
  if(activeQuickFilter===f.name) {
    activeQuickFilter=null;
    if(f.name==="Black & White") setLightBluishGrayEnabled(true);
    document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
    // Reset the filter sliders back to zero
    ["sl-brightness","sl-contrast","sl-saturation","sl-hue"].forEach(id=>document.getElementById(id).value=0);
    updateAdj(true);
    return;
  }
  // Re-enable Light Aqua if switching away from B&W
  if(activeQuickFilter==="Black & White" && f.name!=="Black & White") {
    setLightBluishGrayEnabled(true);
  }
  document.getElementById("sl-brightness").value=f.brightness;
  document.getElementById("sl-contrast").value=f.contrast;
  document.getElementById("sl-saturation").value=f.saturation;
  document.getElementById("sl-hue").value=f.hue;
  document.querySelectorAll(".filter-btn").forEach(b=>b.classList.remove("active"));
  btn.classList.add("active");
  activeQuickFilter=f.name;
  if(f.name==="Black & White") setLightBluishGrayEnabled(false);
  updateAdj(true);
}
function buildFilters() {
  const grid=document.getElementById("filter-grid");
  grid.innerHTML="";
  FILTERS.forEach(f=>{const btn=document.createElement("button");btn.className="filter-btn";btn.textContent=f.name;btn.onclick=()=>applyFilter(f,btn);grid.appendChild(btn);});
}

// ── PALETTE ───────────────────────────────────────────────────────────────────
function buildPaletteUI() {
  const container=document.getElementById("palette-swatches");
  container.innerHTML="";
  LEGO_COLORS.forEach(c=>{
    const div=document.createElement("div");
    div.className="swatch"+(disabledColors.has(c.hex)?" off":"");
    div.style.background=c.hex; div.title=c.name;
    div.onclick=()=>{
      if(disabledColors.has(c.hex)) disabledColors.delete(c.hex);
      else disabledColors.add(c.hex);
      div.classList.toggle("off");
      paletteChanged();
    };
    container.appendChild(div);
  });
}

function paletteChanged() {
  if(preparedDesignUrl) resetPrepareState();
  if(!rendered) return;
  if(activeAdvFilter) {
    const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
    if(!palette.length) return;
    const img=new Image();
    img.onload=()=>{
      const {cols,rows}=currentRes;
      const newBase=sampleImage(img,cols,rows,adj,palette);
      gridData=newBase;

      // If framed, wrap newBase in frame before storing as preFilterGrid
      if(baseplateMode==='framed'){
        const framed=applyFrame(newBase,cols,rows);
        preFilterGrid=framed.grid.map(r=>[...r]);
      } else {
        preFilterGrid=newBase.map(r=>[...r]);
      }

      const af=ADVANCED_FILTERS.find(f=>f.id===activeAdvFilter);
      if(af){
        const filtered=af.apply(preFilterGrid.map(r=>[...r]),gridCols,gridRows,palette);
        restoreFrameCells(filtered);
        playbookGrid=filtered;
        drawGridToCanvas(playbookGrid,gridCols,gridRows,document.getElementById("mosaic-canvas"));
        updateStats();
        buildPaletteUI(); // sync swatch states
      }
    };
    img.src=imageSrc;
  } else {
    doRender();
  }
}

function setAllColors(on) {
  if(on) {
    disabledColors.clear();
  } else {
    LEGO_COLORS.forEach(c=>disabledColors.add(c.hex));
    // Always keep White enabled — need at least one colour
    const white = LEGO_COLORS.find(c=>c.name==='White');
    if(white) disabledColors.delete(white.hex);
  }
  buildPaletteUI();
  paletteChanged();
}

// ── BASE PIXELATION ───────────────────────────────────────────────────────────
function sampleImage(img, cols, rows, adjParams, palette) {
  // Step 1: draw image at full resolution to a temp canvas for pixel access
  const tmp = document.createElement("canvas");
  tmp.width = img.naturalWidth || img.width;
  tmp.height = img.naturalHeight || img.height;
  const tctx = tmp.getContext("2d");
  tctx.drawImage(img, 0, 0);

  const detail = adjParams ? (adjParams.detail || 0) : 0;
  const dither = adjParams ? (adjParams.dither || 0) : 0;

  // Step 2: apply sharpening (unsharp mask) if detail > 0
  if (detail > 0) {
    applyUnsharpMask(tctx, tmp.width, tmp.height, detail);
  }

  const srcW = tmp.width, srcH = tmp.height;
  const cellW = srcW / cols, cellH = srcH / rows;
  const grid = [];

  if (interpMode === 'avg') {
    // Average pooling: sample all pixels in each cell's area
    const fullData = tctx.getImageData(0, 0, srcW, srcH).data;

    // Apply image adjustments to the full pixel data first
    if (adjParams) {
      const adjusted = new Uint8ClampedArray(fullData);
      applyAdjustments(adjusted, adjParams.brightness, adjParams.contrast, adjParams.saturation, adjParams.hue, adjParams.red, adjParams.green, adjParams.blue);
      // Build grid using averaged adjusted pixels
      for (let row = 0; row < rows; row++) {
        grid[row] = [];
        for (let col = 0; col < cols; col++) {
          const x0 = Math.floor(col * cellW), x1 = Math.min(Math.ceil((col+1)*cellW), srcW);
          const y0 = Math.floor(row * cellH), y1 = Math.min(Math.ceil((row+1)*cellH), srcH);
          let rSum=0, gSum=0, bSum=0, count=0;
          for (let py=y0; py<y1; py++) for (let px=x0; px<x1; px++) {
            const i=(py*srcW+px)*4;
            rSum+=adjusted[i]; gSum+=adjusted[i+1]; bSum+=adjusted[i+2]; count++;
          }
          if (count===0) { grid[row][col]=palette[0]; continue; }
          grid[row][col] = getClosestColor(rSum/count, gSum/count, bSum/count, palette);
        }
      }
    } else {
      for (let row=0; row<rows; row++) {
        grid[row]=[];
        for (let col=0; col<cols; col++) {
          const x0=Math.floor(col*cellW), x1=Math.min(Math.ceil((col+1)*cellW),srcW);
          const y0=Math.floor(row*cellH), y1=Math.min(Math.ceil((row+1)*cellH),srcH);
          let rSum=0,gSum=0,bSum=0,count=0;
          for(let py=y0;py<y1;py++) for(let px=x0;px<x1;px++){
            const i=(py*srcW+px)*4;
            rSum+=fullData[i];gSum+=fullData[i+1];bSum+=fullData[i+2];count++;
          }
          if(count===0){grid[row][col]=palette[0];continue;}
          grid[row][col]=getClosestColor(rSum/count,gSum/count,bSum/count,palette);
        }
      }
    }
  } else {
    // Nearest pixel: sample centre of each cell (original behaviour)
    const small = document.createElement("canvas");
    small.width = cols; small.height = rows;
    const sctx = small.getContext("2d");
    sctx.drawImage(tmp, 0, 0, cols, rows);
    const imgData = sctx.getImageData(0, 0, cols, rows);
    const raw = imgData.data;
    if (adjParams) applyAdjustments(raw, adjParams.brightness, adjParams.contrast, adjParams.saturation, adjParams.hue, adjParams.red, adjParams.green, adjParams.blue);
    for (let y=0; y<rows; y++) {
      grid[y]=[];
      for (let x=0; x<cols; x++) {
        const i=(y*cols+x)*4;
        grid[y][x]=getClosestColor(raw[i],raw[i+1],raw[i+2],palette);
      }
    }
  }

  // Step 3: Apply dithering if > 0
  if (dither > 0) {
    return applyDithering(grid, cols, rows, palette, dither / 100);
  }

  return grid;
}

// ── UNSHARP MASK (detail/sharpening) ─────────────────────────────────────────
function applyUnsharpMask(ctx, w, h, amount) {
  // Get original pixels
  const orig = ctx.getImageData(0, 0, w, h);
  const data = orig.data;

  // Create a blurred version using a simple box blur
  const blurred = new Uint8ClampedArray(data.length);
  const radius = Math.max(1, Math.round(amount / 25)); // 1–4px blur radius
  for (let y=0; y<h; y++) {
    for (let x=0; x<w; x++) {
      let rS=0,gS=0,bS=0,count=0;
      for (let dy=-radius; dy<=radius; dy++) {
        for (let dx=-radius; dx<=radius; dx++) {
          const nx=x+dx, ny=y+dy;
          if (nx>=0&&ny>=0&&nx<w&&ny<h) {
            const i=(ny*w+nx)*4;
            rS+=data[i]; gS+=data[i+1]; bS+=data[i+2]; count++;
          }
        }
      }
      const i=(y*w+x)*4;
      blurred[i]=rS/count; blurred[i+1]=gS/count; blurred[i+2]=bS/count; blurred[i+3]=255;
    }
  }

  // Unsharp mask: original + (original - blurred) * strength
  const strength = amount / 100 * 2.5; // 0–2.5x
  const result = ctx.createImageData(w, h);
  for (let i=0; i<data.length; i+=4) {
    result.data[i]   = Math.min(255,Math.max(0, data[i]   + (data[i]   - blurred[i])   * strength));
    result.data[i+1] = Math.min(255,Math.max(0, data[i+1] + (data[i+1] - blurred[i+1]) * strength));
    result.data[i+2] = Math.min(255,Math.max(0, data[i+2] + (data[i+2] - blurred[i+2]) * strength));
    result.data[i+3] = 255;
  }
  ctx.putImageData(result, 0, 0);
}

// ── FLOYD-STEINBERG DITHERING ─────────────────────────────────────────────────
function applyDithering(grid, cols, rows, palette, strength) {
  // Work with floating-point RGB error values
  const errR = Array.from({length:rows}, ()=>new Float32Array(cols));
  const errG = Array.from({length:rows}, ()=>new Float32Array(cols));
  const errB = Array.from({length:rows}, ()=>new Float32Array(cols));
  const result = grid.map(r=>[...r]);

  for (let y=0; y<rows; y++) {
    for (let x=0; x<cols; x++) {
      const orig = grid[y][x];
      const [or,og,ob] = hexToRgb(orig);
      // Add accumulated error
      const ar = Math.min(255,Math.max(0, or + errR[y][x]*strength));
      const ag = Math.min(255,Math.max(0, og + errG[y][x]*strength));
      const ab = Math.min(255,Math.max(0, ob + errB[y][x]*strength));

      const chosen = getClosestColor(ar, ag, ab, palette);
      result[y][x] = chosen;

      const [cr,cg,cb] = hexToRgb(chosen);
      const qeR = ar-cr, qeG = ag-cg, qeB = ab-cb;

      // Distribute error to neighbours (Floyd-Steinberg weights)
      if (x+1<cols)         { errR[y][x+1]+=qeR*7/16; errG[y][x+1]+=qeG*7/16; errB[y][x+1]+=qeB*7/16; }
      if (y+1<rows) {
        if (x>0)            { errR[y+1][x-1]+=qeR*3/16; errG[y+1][x-1]+=qeG*3/16; errB[y+1][x-1]+=qeB*3/16; }
                              errR[y+1][x]  +=qeR*5/16; errG[y+1][x]  +=qeG*5/16; errB[y+1][x]  +=qeB*5/16;
        if (x+1<cols)       { errR[y+1][x+1]+=qeR*1/16; errG[y+1][x+1]+=qeG*1/16; errB[y+1][x+1]+=qeB*1/16; }
      }
    }
  }
  return result;
}

// ── INTERPOLATION TOGGLE ──────────────────────────────────────────────────────
function setInterp(mode, btn) {
  if(mode === interpMode) return; // no change
  saveUndo(); // snapshot BEFORE changing interp mode
  interpMode = mode;
  document.querySelectorAll(".interp-btn").forEach(b=>b.classList.remove("active"));
  btn.classList.add("active");
  if (rendered) doRender();
}

// ── RENDER ────────────────────────────────────────────────────────────────────
function doRender() {
  if(!imageSrc) return;
  const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
  if(palette.length===0){alert("Please enable at least one colour.");return;}
  const {cols,rows}=currentRes;
  const canvas=document.getElementById("mosaic-canvas");
  document.getElementById("placeholder").style.display="none";
  canvas.style.display="none";
  document.getElementById("rendering-msg").style.display="block";
  
  setTool(null);
  playbookGrid=[];  // clear any stale grid before re-render
  setTimeout(()=>{
    cellSize=Math.max(4,Math.floor(1024/Math.max(cols,rows)));
    const img=new Image();
    img.onload=()=>{
      // Store raw auto-generated grid as source of truth
      gridData=sampleImage(img,cols,rows,adj,palette);
      // Apply colours cap
      const colCap=adj.colors;
      let displayGrid = colCap < new Set(gridData.flat()).size
        ? quantizePlaybook(gridData,cols,rows,colCap)
        : gridData.map(r=>[...r]);

      // Apply frame if framed mode
      let renderCols=cols, renderRows=rows;
      if(baseplateMode==='framed') {
        const framed=applyFrame(displayGrid,cols,rows);
        displayGrid=framed.grid;
        renderCols=framed.cols;
        renderRows=framed.rows;
      }

      // Clear playbookGrid so fresh render takes over
      playbookGrid=displayGrid;
      gridCols=renderCols; gridRows=renderRows;

      const W=renderCols*cellSize, H=renderRows*cellSize;
      canvas.width=W; canvas.height=H;

      drawGridToCanvas(playbookGrid,renderCols,renderRows,canvas);
      document.getElementById("rendering-msg").style.display="none";
      canvas.style.display="block";
      document.getElementById("canvas-viewport").style.display="flex";
      rendered=true;
      document.getElementById("prepare-btn").disabled=false;
      document.getElementById("toolbar").classList.add("show");
      // Enable mobile buttons directly
      const mobPrep = document.getElementById("mob-prepare-btn");
      if(mobPrep) mobPrep.disabled=false;
      // Only clear undo on first render — subsequent re-renders preserve undo history
      if(!rendered) { undoStack=[]; redoStack=[]; }
      updateUndoBtn(); updateRedoBtn(); updateStats(); initZoom();
      updateMobActiveSwatch();
      setTimeout(()=>{ syncMobButtons(); updateMobileStats(); }, 60);
      // After first render, sync colours slider to actual colour count
      const actualCount=new Set(gridData.flat()).size;
      if(adjColorsDefault===50) adjColorsDefault=actualCount;
      const slider=document.getElementById("sl-colors");
      // Only auto-set slider if user hasn't moved it away from default
      if(parseInt(slider.value)>=50) {
        const cap=Math.min(actualCount,50);
        slider.max=Math.max(actualCount,50);
        slider.value=cap;
        adj.colors=cap;
        adjColorsDefault=cap;
        document.getElementById("lbl-colors").textContent=cap;
      }

      // If an advanced filter is active, re-apply it to the newly rendered grid
      if(activeAdvFilter) {
        preFilterGrid=playbookGrid.map(r=>[...r]);
        const af=ADVANCED_FILTERS.find(f=>f.id===activeAdvFilter);
        if(af){
          const filtered=af.apply(preFilterGrid.map(r=>[...r]),gridCols,gridRows,palette);
          restoreFrameCells(filtered);
          playbookGrid=filtered;
          drawGridToCanvas(playbookGrid,gridCols,gridRows,canvas);
          updateStats();
          buildPaletteUI();
        }
      }
    };
    img.src=imageSrc;
  },50);
}

// Draw a full grid to canvas
function drawGridToCanvas(grid,cols,rows,canvas) {
  const ctx=canvas.getContext("2d");
  for(let y=0;y<rows;y++) for(let x=0;x<cols;x++) drawCell(ctx,x,y,grid[y][x]);
}

// ── STATS ─────────────────────────────────────────────────────────────────────
// Size lookup: brick dimensions → cm (framed measurements)
const SIZE_CM = {
  "32x32":"28.6 × 28.6","48x48":"41.4 × 41.4","64x64":"57.2 × 57.2","96x96":"85.8 × 85.8","128x128":"114.4 × 114.4",
  "32x48":"28.6 × 41.4","32x64":"28.6 × 57.2","48x64":"41.4 × 57.2",
  "48x96":"41.4 × 85.8","64x96":"57.2 × 85.8","64x128":"57.2 × 114.4","96x128":"85.8 × 114.4",
  "48x32":"41.4 × 28.6","64x32":"57.2 × 28.6","64x48":"57.2 × 41.4",
  "96x48":"85.8 × 41.4","96x64":"85.8 × 57.2","128x64":"114.4 × 57.2","128x96":"114.4 × 85.8",
};
const SIZE_CM_UNFRAMED = {
  "32x32":"25.6 × 25.6","48x48":"38.4 × 38.4",
};

function updateStats() {
  const displayGrid = playbookGrid.length ? playbookGrid : gridData;
  const isFramed = baseplateMode === 'framed';

  // Count only inner bricks (exclude frame border)
  const colorMap = {};
  const y0 = isFramed?2:0, y1 = isFramed?gridRows-2:gridRows;
  const x0 = isFramed?2:0, x1 = isFramed?gridCols-2:gridCols;
  for(let y=y0; y<y1; y++) for(let x=x0; x<x1; x++) {
    const c = displayGrid[y][x];
    colorMap[c] = (colorMap[c]||0) + 1;
  }
  const total = Object.values(colorMap).reduce((a,b)=>a+b, 0);

  // Brick count and colours
  document.getElementById("brick-count").textContent = total.toLocaleString();
  document.getElementById("color-count").textContent = Object.keys(colorMap).length;

  // Dimensions — inner design size always
  const innerCols = isFramed ? gridCols-4 : gridCols;
  const innerRows = isFramed ? gridRows-4 : gridRows;
  document.getElementById("stat-dimensions").textContent = `${innerCols} × ${innerRows}`;

  // Baseplate label
  document.getElementById("stat-baseplate").textContent = isFramed ? "Framed" : "Regular";

  // CM size
  const key = `${innerCols}x${innerRows}`;
  const cm = isFramed ? (SIZE_CM[key]||"—") : (SIZE_CM_UNFRAMED[key]||SIZE_CM[key]||"—");
  document.getElementById("stat-cm").textContent = cm ? cm+" cm" : "—";

  // Colour breakdown
  const chips = document.getElementById("color-chips");
  chips.innerHTML = "";
  Object.entries(colorMap).sort((a,b)=>b[1]-a[1]).slice(0,24).forEach(([hex,cnt])=>{
    const name = hexToColorName(hex);
    chips.innerHTML += `<div class="chip"><div class="chip-dot" style="background:${hex}"></div><span class="chip-name">${name}</span><span class="chip-pct">${cnt.toLocaleString()}</span></div>`;
  });

  document.getElementById("stats-bar").classList.add("show");
  updateMobileStats();
  updatePrice();
}

// ─────────────────────────────────────────────────────────────────────────────
// ── DESIGN PLAYBOOK ENGINE ────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────

function applyPlaybookToGrid(base, cols, rows, palette, pbState) {
  let g=base.map(r=>[...r]);

  // 1. SMOOTHING — very gradual. 0–100 maps to tiny threshold increments.
  // At 10: only absorb cells where 95%+ of neighbours disagree (barely anything)
  // At 50: absorb where 80%+ disagree (moderate)
  // At 100: absorb where 65%+ disagree (noticeable but not aggressive)
  if(pbState.smooth > 0) {
    const t = 0.05 + (pbState.smooth / 100) * 0.30; // threshold: 0.05→0.35
    const passes = pbState.smooth < 50 ? 1 : 2;
    const minSz = pbState.smooth < 30 ? 1 : pbState.smooth < 70 ? 2 : 3;
    for(let p=0;p<passes;p++) g=smoothPass(g,cols,rows,t,1);
    g=consolidateRegions(g,cols,rows,minSz);
  }

  // 2. COLOUR SIMPLIFY
  if(pbState.simplify > 0) {
    const totalColors=new Set(g.flat()).size;
    const keepFraction=1-(pbState.simplify/100)*0.75;
    const keepN=Math.max(3,Math.round(totalColors*keepFraction));
    g=quantizePlaybook(g,cols,rows,keepN);
  }

  // 3. MAX COLOURS — hard cap, runs last
  if(pbState.colors < 50) {
    g=quantizePlaybook(g,cols,rows,pbState.colors);
  }

  return g;
}

function quantizePlaybook(grid,cols,rows,maxColors) {
  const counts={};
  for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){const c=grid[y][x];counts[c]=(counts[c]||0)+1;}
  const sorted=Object.keys(counts).sort((a,b)=>counts[b]-counts[a]);
  if(sorted.length<=maxColors) return grid.map(r=>[...r]);
  const keep=new Set(sorted.slice(0,maxColors));
  const keepArr=[...keep];
  const result=grid.map(r=>[...r]);
  for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
    if(!keep.has(result[y][x])){
      const [r,g,b]=hexToRgb(result[y][x]);
      result[y][x]=getClosestColor(r,g,b,keepArr);
    }
  }
  return result;
}

function shiftExposure(grid,cols,rows,palette,amount) {
  const result=grid.map(r=>[...r]);
  const shift=amount/100;
  for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
    const cur=result[y][x];
    const lum=getLuminance(cur);
    const [r,g,b]=hexToRgb(cur);
    let candidates;
    if(shift>0){
      const minLum=lum+(shift*0.4);
      candidates=palette.filter(p=>getLuminance(p)>=minLum);
    } else {
      const maxLum=lum+(shift*0.4);
      candidates=palette.filter(p=>getLuminance(p)<=maxLum);
    }
    if(candidates.length>0) result[y][x]=getClosestColor(r,g,b,candidates);
  }
  return result;
}

function correctSkinTonesPlaybook(grid,cols,rows,palette,threshold) {
  const result=grid.map(r=>[...r]);
  const skinInPalette=SKIN_TONES.filter(s=>palette.includes(s));
  if(skinInPalette.length===0) return result;
  for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
    if(!WRONG_SKIN.includes(result[y][x])) continue;
    let skinN=0,total=0;
    [[-1,0],[1,0],[0,-1],[0,1],[-1,-1],[1,-1],[-1,1],[1,1]].forEach(([dx,dy])=>{
      const nx=x+dx,ny=y+dy;
      if(nx>=0&&ny>=0&&nx<cols&&ny<rows){
        total++;
        if(SKIN_TONES.includes(grid[ny][nx])||WRONG_SKIN.includes(grid[ny][nx])) skinN++;
      }
    });
    if(total>0&&skinN/total>=threshold){
      const [r,g,b]=hexToRgb(result[y][x]);
      result[y][x]=getClosestColor(r,g,b,skinInPalette);
    }
  }
  return result;
}

// ── MASK TOOL ─────────────────────────────────────────────────────────────────
let maskPoints = [];        // array of {x,y} in grid coords
let maskClosed = false;     // polygon closed and ready to apply
let maskFillColor = "#FFFFFF";
let maskFillName = "White";

function maskClick(gx, gy, e) {
  if(isFrameCell(gx, gy)) return; // can't place mask points on frame

  // Double-click closes the polygon
  if(e && e.detail >= 2 && maskPoints.length >= 3) {
    closeMaskPolygon();
    return;
  }

  // Check if clicking near the first point to close (within 2 bricks)
  if(maskPoints.length >= 3) {
    const first = maskPoints[0];
    if(Math.abs(gx-first.x)<=1 && Math.abs(gy-first.y)<=1) {
      closeMaskPolygon();
      return;
    }
  }

  maskPoints.push({x:gx, y:gy});
  drawMaskOverlay();

  // Show panel after 3 points so user knows to close
  if(maskPoints.length === 3) {
    document.getElementById("mask-hint").textContent =
      "Keep clicking to add points. Double-click or click near start to close.";
    showMaskPanel();
  } else if(maskPoints.length < 3) {
    document.getElementById("mask-hint").textContent =
      maskPoints.length === 1
        ? "Click to add more points around your object."
        : "Keep clicking. Need at least 3 points.";
    showMaskPanel();
  }
}

function closeMaskPolygon() {
  if(maskPoints.length < 3) return;
  maskClosed = true;
  drawMaskOverlay();
  document.getElementById("mask-hint").textContent =
    "Polygon closed. Choose fill inside or outside.";
}

function drawMaskOverlay() {
  const sc = document.getElementById("selection-canvas");
  const ctx = sc.getContext("2d");
  ctx.clearRect(0, 0, sc.width, sc.height);
  if(maskPoints.length === 0) return;

  const cs = cellSize;

  // If closed, fill the polygon with a semi-transparent overlay
  if(maskClosed && maskPoints.length >= 3) {
    ctx.beginPath();
    maskPoints.forEach((p, i) => {
      const px = (p.x + 0.5) * cs, py = (p.y + 0.5) * cs;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    });
    ctx.closePath();
    ctx.fillStyle = "rgba(255,215,0,0.18)";
    ctx.fill();
    ctx.strokeStyle = "#FFD700";
    ctx.lineWidth = 2;
    ctx.setLineDash([]);
    ctx.stroke();
  } else {
    // Draw dashed line connecting points so far
    ctx.beginPath();
    maskPoints.forEach((p, i) => {
      const px = (p.x + 0.5) * cs, py = (p.y + 0.5) * cs;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    });
    ctx.strokeStyle = "#FFD700";
    ctx.lineWidth = 2;
    ctx.setLineDash([4, 3]);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  // Draw dots at each anchor point
  maskPoints.forEach((p, i) => {
    const px = (p.x + 0.5) * cs, py = (p.y + 0.5) * cs;
    ctx.beginPath();
    ctx.arc(px, py, i === 0 ? 5 : 3, 0, Math.PI * 2);
    ctx.fillStyle = i === 0 ? "#FFD700" : "#fff";
    ctx.fill();
    ctx.strokeStyle = "#FFD700";
    ctx.lineWidth = 1.5;
    ctx.stroke();
  });
}

// Point-in-polygon ray casting
function pointInPolygon(px, py, polygon) {
  let inside = false;
  for(let i=0, j=polygon.length-1; i<polygon.length; j=i++) {
    const xi=polygon[i].x, yi=polygon[i].y;
    const xj=polygon[j].x, yj=polygon[j].y;
    const intersect=((yi>py)!==(yj>py)) && (px < (xj-xi)*(py-yi)/(yj-yi)+xi);
    if(intersect) inside=!inside;
  }
  return inside;
}

function showMaskPanel() {
  const panel=document.getElementById("mask-panel");
  panel.style.display="block";
  // Position panel in bottom-right of canvas area
  const canvas=document.getElementById("mosaic-canvas");
  const rect=canvas.getBoundingClientRect();
  panel.style.right="20px";
  panel.style.bottom="80px";
  panel.style.top="auto";
  panel.style.left="auto";
  // Set fill colour swatch
  document.getElementById("mask-color-swatch").style.background=maskFillColor;
  document.getElementById("mask-color-name").textContent=maskFillName;
}

function toggleMaskColorPicker(e) {
  e.stopPropagation();
  const popup=document.getElementById("mask-color-popup");
  if(popup.style.display!=="none"){popup.style.display="none";return;}
  popup.innerHTML="";
  LEGO_COLORS.forEach(c=>{
    const div=document.createElement("div");
    div.className='mask-color-swatch-item';
    div.style.cssText=`background:${c.hex};cursor:pointer;border:2px solid ${c.hex===maskFillColor?"#fff":"transparent"};`;
    div.title=c.name;
    div.onclick=ev=>{
      ev.stopPropagation();
      maskFillColor=c.hex; maskFillName=c.name;
      document.getElementById("mask-color-swatch").style.background=c.hex;
      document.getElementById("mask-color-name").textContent=c.name;
      popup.style.display="none";
    };
    popup.appendChild(div);
  });
  popup.style.display="flex";
}

// ── SMART SELECT TOOL ─────────────────────────────────────────────────────────
let smartSelMask = new Set();   // set of "x,y" strings currently selected
let smartSelOrigin = null;      // the cell that was clicked

function smartSelectClick(gx, gy, ctrlHeld) {
  if(isFrameCell(gx, gy)) return; // can't select frame cells
  if(!ctrlHeld) smartSelMask = new Set();
  smartSelOrigin = {x:gx, y:gy};
  const tol = parseInt(document.getElementById("sl-tolerance").value);
  runSmartSelectAdd(gx, gy, tol);
  showMaskPanel();
}

function runSmartSelectAdd(gx, gy, tol) {
  const display = playbookGrid.length ? playbookGrid : gridData;
  const seedColor = display[gy][gx];
  const [sr,sg,sb] = hexToRgb(seedColor);
  const [sL,sA,sB] = rgbToLab(sr,sg,sb);
  const labThreshold = tol * 6;

  const visited = new Set();
  const stack = [`${gx},${gy}`];

  while(stack.length) {
    const key = stack.pop();
    if(visited.has(key)) continue;
    visited.add(key);
    const [x,y] = key.split(",").map(Number);
    if(x<0||y<0||x>=gridCols||y>=gridRows) continue;
    if(isFrameCell(x,y)) continue; // don't include frame cells in selection
    const c = display[y][x];
    const [r,g,b] = hexToRgb(c);
    const [L,A,B] = rgbToLab(r,g,b);
    const dist = Math.sqrt((L-sL)**2+(A-sA)**2+(B-sB)**2);
    if(dist > labThreshold) continue;
    smartSelMask.add(key);
    stack.push(`${x+1},${y}`,`${x-1},${y}`,`${x},${y+1}`,`${x},${y-1}`);
  }

  updateSmartSelCount();
  drawSmartSelOverlay();
}

function drawSmartSelOverlay() {
  const sc = document.getElementById("selection-canvas");
  const ctx = sc.getContext("2d");
  ctx.clearRect(0,0,sc.width,sc.height);
  updateSmartSelCount();
  if(smartSelMask.size===0) return;

  const cs = cellSize;

  // Fill selected cells
  ctx.fillStyle = "rgba(255,215,0,0.3)";
  smartSelMask.forEach(key=>{
    const [x,y] = key.split(",").map(Number);
    ctx.fillRect(x*cs, y*cs, cs, cs);
  });

  // Draw border around the selection — only on edges facing non-selected cells
  ctx.strokeStyle = "#FFD700";
  ctx.lineWidth = 2;
  smartSelMask.forEach(key=>{
    const [x,y] = key.split(",").map(Number);
    const px=x*cs, py=y*cs;
    // Top edge
    if(!smartSelMask.has(`${x},${y-1}`)){ctx.beginPath();ctx.moveTo(px,py);ctx.lineTo(px+cs,py);ctx.stroke();}
    // Bottom edge
    if(!smartSelMask.has(`${x},${y+1}`)){ctx.beginPath();ctx.moveTo(px,py+cs);ctx.lineTo(px+cs,py+cs);ctx.stroke();}
    // Left edge
    if(!smartSelMask.has(`${x-1},${y}`)){ctx.beginPath();ctx.moveTo(px,py);ctx.lineTo(px,py+cs);ctx.stroke();}
    // Right edge
    if(!smartSelMask.has(`${x+1},${y}`)){ctx.beginPath();ctx.moveTo(px+cs,py);ctx.lineTo(px+cs,py+cs);ctx.stroke();}
  });
}

function toleranceChanged() {
  const tol = parseInt(document.getElementById("sl-tolerance").value);
  document.getElementById("lbl-tolerance").textContent = tol;
  // Re-run from the last clicked origin, replacing current selection
  if(smartSelOrigin && activeTool==="smartsel") {
    smartSelMask = new Set();
    runSmartSelectAdd(smartSelOrigin.x, smartSelOrigin.y, tol);
  }
}

function updateSmartSelCount() {
  const el = document.getElementById("smartsel-count");
  if(!el) return;
  if(smartSelMask.size===0){el.textContent="";return;}
  el.textContent=`${smartSelMask.size} brick${smartSelMask.size!==1?"s":""} selected — Ctrl+click to add more`;
}

function nudgeToleranceAndReselect(delta) {
  const el = document.getElementById("sl-tolerance");
  el.value = Math.min(15, Math.max(1, parseInt(el.value)+delta));
  toleranceChanged();
}

// Override applyMask to handle smart select mode too
function applyMask(mode) {
  if(activeTool==="smartsel") {
    applySmartSelMask(mode);
  } else {
    // Polygon mask apply
    if(maskPoints.length < 3) return;
    if(!maskClosed) closeMaskPolygon();
    saveUndo();
    if(!playbookGrid.length) playbookGrid=gridData.map(r=>[...r]);
    const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
    const fillHex=getClosestColor(...hexToRgb(maskFillColor), palette);
    for(let y=0;y<gridRows;y++) for(let x=0;x<gridCols;x++){
      if(isFrameCell(x,y)) continue; // never touch frame cells
      const inside=pointInPolygon(x+0.5,y+0.5,maskPoints);
      if((mode==='inside'&&inside)||(mode==='outside'&&!inside)) playbookGrid[y][x]=fillHex;
    }
    const sc=document.getElementById("selection-canvas");
    if(sc) sc.getContext("2d").clearRect(0,0,sc.width,sc.height);
    maskPoints=[]; maskClosed=false;
    redrawGrid();
    document.getElementById("mask-panel").style.display="none";
    setTool(null); mobSyncTools();
  }
}

function cancelMask() {
  maskPoints=[];
  maskClosed=false;
  smartSelMask=new Set();
  smartSelOrigin=null;
  const sc=document.getElementById("selection-canvas");
  if(sc) sc.getContext("2d").clearRect(0,0,sc.width,sc.height);
  const panel=document.getElementById("mask-panel");
  if(panel) panel.style.display="none";
  const popup=document.getElementById("mask-color-popup");
  if(popup) popup.style.display="none";
  const countEl=document.getElementById("smartsel-count");
  if(countEl) countEl.textContent="";
}

function applySmartSelMask(mode) {
  if(smartSelMask.size===0) return;
  saveUndo();
  if(!playbookGrid.length) playbookGrid=gridData.map(r=>[...r]);
  const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
  const fillHex=getClosestColor(...hexToRgb(maskFillColor), palette);
  for(let y=0;y<gridRows;y++) for(let x=0;x<gridCols;x++){
    if(isFrameCell(x,y)) continue; // never touch frame cells
    const inSel=smartSelMask.has(`${x},${y}`);
    if((mode==='inside'&&inSel)||(mode==='outside'&&!inSel)) playbookGrid[y][x]=fillHex;
  }
  const sc=document.getElementById("selection-canvas");
  if(sc) sc.getContext("2d").clearRect(0,0,sc.width,sc.height);
  smartSelMask=new Set();
  smartSelOrigin=null;
  redrawGrid();
  document.getElementById("mask-panel").style.display="none";
  setTool(null); mobSyncTools();
}

function closeMaskPanel() {
  const sc=document.getElementById("selection-canvas");
  if(sc){sc.getContext("2d").clearRect(0,0,sc.width,sc.height);sc.style.display="none";}
  maskPoints=[]; maskClosed=false;
  smartSelMask=new Set(); smartSelOrigin=null;
  const countEl=document.getElementById("smartsel-count");
  if(countEl) countEl.textContent="";
  document.getElementById("mask-panel").style.display="none";
  document.getElementById("mask-color-popup").style.display="none";
  activeTool=null;
  document.querySelectorAll(".tool-btn").forEach(b=>b.classList.remove("active"));
  const canvas=document.getElementById("mosaic-canvas");
  canvas.classList.remove("tool-active","tool-picker","tool-region","tool-mask","tool-smartsel");
}

// ── PLAYBOOK ──────────────────────────────────────────────────────────────────
// ── COLOUR SWAPPER TOOL ───────────────────────────────────────────────────────
let swapFromColor = null;
let swapToColor = null;
let swapHighlightCells = new Set();

function openSwapTool() {
  swapFromColor = null;
  swapToColor = null;
  swapHighlightCells = new Set();
  document.getElementById("swap-panel").style.display = "block";
  document.getElementById("swap-from-wrap").style.display = "none";
  document.getElementById("swap-hint").textContent = "Click any brick to select its colour.";
}

function closeSwapTool() {
  swapFromColor = null;
  swapToColor = null;
  swapHighlightCells = new Set();
  clearSwapHighlight();
  const panel = document.getElementById("swap-panel");
  if(panel) panel.style.display = "none";
}

function swapClick(gx, gy) {
  if(isFrameCell(gx, gy)) return;
  const display = playbookGrid.length ? playbookGrid : gridData;
  const clicked = display[gy][gx];
  selectSwapFromColor(clicked);
}

function selectSwapFromColor(hex) {
  swapFromColor = hex;
  swapToColor = null;

  // Count all bricks of this colour (excluding frame)
  const display = playbookGrid.length ? playbookGrid : gridData;
  swapHighlightCells = new Set();
  let count = 0;
  for(let y=0;y<gridRows;y++) for(let x=0;x<gridCols;x++){
    if(isFrameCell(x,y)) continue;
    if(display[y][x]===hex){ swapHighlightCells.add(`${x},${y}`); count++; }
  }

  // Highlight selected bricks
  drawSwapHighlight();

  // Update panel
  const name = hexToColorName(hex);
  document.getElementById("swap-from-dot").style.background = hex;
  document.getElementById("swap-from-name").textContent = name;
  document.getElementById("swap-from-count").textContent = `${count} bricks`;
  document.getElementById("swap-from-wrap").style.display = "flex";
  document.getElementById("swap-hint").textContent = "Now choose a colour to swap to.";

  // Build the swap-to colour picker — all 50 LEGO colours except the current one
  const grid = document.getElementById("swap-to-grid");
  grid.innerHTML = "";
  const isMob = window.innerWidth <= 768;
  // Calculate fixed pixel size based on available width
  // On mobile: fit 10 per row with gaps in available panel width (~300px)
  const swapSize = isMob ? Math.floor((window.innerWidth - 80) / 10) : 22;
  grid.style.cssText = `display:flex;flex-wrap:wrap;gap:3px;width:${isMob?'100%':'188px'};max-height:${isMob?'none':'110px'};overflow-y:${isMob?'visible':'auto'};`;
  LEGO_COLORS.forEach(c=>{
    const dot = document.createElement("div");
    dot.className='swap-color-item';
    dot.style.cssText = `background:${c.hex};cursor:pointer;border:2px solid ${c.hex===swapToColor?"#fff":"transparent"};border-radius:3px;width:${swapSize}px;height:${swapSize}px;min-width:${swapSize}px;min-height:${swapSize}px;max-width:${swapSize}px;max-height:${swapSize}px;flex-shrink:0;flex-grow:0;display:block;box-sizing:border-box;`;
    dot.title = c.name;
    if(c.hex === hex) dot.style.opacity = "0.3";
    else dot.onclick = () => selectSwapToColor(c.hex, dot);
    grid.appendChild(dot);
  });

  const btn = document.getElementById("swap-confirm-btn");
  btn.disabled = true;
  btn.style.opacity = "0.4";
}

function selectSwapToColor(hex, dot) {
  swapToColor = hex;
  // Update all dots' borders
  document.querySelectorAll("#swap-to-grid .swap-color-item").forEach(d=>{
    d.style.borderColor = "transparent";
  });
  dot.style.borderColor = "#fff";
  const btn = document.getElementById("swap-confirm-btn");
  btn.disabled = false;
  btn.style.opacity = "1";
}

function drawSwapHighlight() {
  const sc = document.getElementById("selection-canvas");
  if(!sc) return;
  sc.width = document.getElementById("mosaic-canvas").width;
  sc.height = document.getElementById("mosaic-canvas").height;
  sc.style.display = "block";
  const ctx = sc.getContext("2d");
  ctx.clearRect(0,0,sc.width,sc.height);
  const cs = cellSize;
  swapHighlightCells.forEach(key=>{
    const [x,y] = key.split(",").map(Number);
    ctx.fillStyle = "rgba(255,215,0,0.35)";
    ctx.fillRect(x*cs,y*cs,cs,cs);
    // Border on exposed edges
    ctx.strokeStyle="#FFD700";
    ctx.lineWidth=1.5;
    if(!swapHighlightCells.has(`${x},${y-1}`)){ctx.beginPath();ctx.moveTo(x*cs,y*cs);ctx.lineTo((x+1)*cs,y*cs);ctx.stroke();}
    if(!swapHighlightCells.has(`${x},${y+1}`)){ctx.beginPath();ctx.moveTo(x*cs,(y+1)*cs);ctx.lineTo((x+1)*cs,(y+1)*cs);ctx.stroke();}
    if(!swapHighlightCells.has(`${x-1},${y}`)){ctx.beginPath();ctx.moveTo(x*cs,y*cs);ctx.lineTo(x*cs,(y+1)*cs);ctx.stroke();}
    if(!swapHighlightCells.has(`${x+1},${y}`)){ctx.beginPath();ctx.moveTo((x+1)*cs,y*cs);ctx.lineTo((x+1)*cs,(y+1)*cs);ctx.stroke();}
  });
}

function clearSwapHighlight() {
  const sc = document.getElementById("selection-canvas");
  if(sc){ sc.getContext("2d").clearRect(0,0,sc.width,sc.height); sc.style.display="none"; }
}

function confirmSwap() {
  if(!swapFromColor||!swapToColor) return;
  saveUndo();
  if(!playbookGrid.length) playbookGrid = gridData.map(r=>[...r]);
  swapHighlightCells.forEach(key=>{
    const [x,y] = key.split(",").map(Number);
    playbookGrid[y][x] = swapToColor;
  });
  // Clear highlight immediately before redraw so gold overlay doesn't persist
  swapFromColor = null;
  swapToColor = null;
  swapHighlightCells = new Set();
  clearSwapHighlight();
  redrawGrid();
  // Close panel and deactivate tool
  document.getElementById("swap-panel").style.display = "none";
  setTool(null);
  mobSyncTools();
}

function updatePlaybook() {
  pb.smooth   = parseInt(document.getElementById("sl-pb-smooth").value);
  pb.simplify = parseInt(document.getElementById("sl-pb-simplify").value);
  pb.colors   = parseInt(document.getElementById("sl-pb-colors").value);
  document.getElementById("lbl-pb-smooth").textContent   = pb.smooth;
  document.getElementById("lbl-pb-simplify").textContent = pb.simplify;
  document.getElementById("lbl-pb-colors").textContent   = pb.colors >= 50 ? "All" : pb.colors;
  if(!rendered) return;
  clearTimeout(pbDebounceTimer);
  pbDebounceTimer=setTimeout(()=>{
    const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
    if(rendered) saveUndo();
    playbookGrid=applyPlaybookToGrid(gridData,gridCols,gridRows,palette,pb);
    drawGridToCanvas(playbookGrid,gridCols,gridRows,document.getElementById("mosaic-canvas"));
    updateStats();
  },120);
}

function resetPlaybook() {
  ["sl-pb-smooth","sl-pb-simplify"].forEach(id=>{
    document.getElementById(id).value=0;
  });
  document.getElementById("sl-pb-colors").value=50;
  updatePlaybook();
}

// ─────────────────────────────────────────────────────────────────────────────
// ── SMART DESIGN ENGINE — Smoothing & Consolidation ──────────────────────────
// ─────────────────────────────────────────────────────────────────────────────

// ── CORE PRIMITIVE: Neighbourhood mode smoothing ─────────────────────────────
// For each cell, look at its neighbours in a given radius.
// If the cell is an outlier vs its surroundings, absorb it into the dominant neighbour.
// threshold: what fraction of neighbours must disagree before we swap (0–1).
// radius: how many cells to look out (1=3x3, 2=5x5)
function smoothPass(grid, cols, rows, threshold, radius) {
  const result = grid.map(r => [...r]);
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      const current = grid[y][x];
      const counts = {};
      let total = 0;
      for (let dy = -radius; dy <= radius; dy++) {
        for (let dx = -radius; dx <= radius; dx++) {
          if (dx === 0 && dy === 0) continue;
          const nx = x + dx, ny = y + dy;
          if (nx >= 0 && ny >= 0 && nx < cols && ny < rows) {
            const c = grid[ny][nx];
            counts[c] = (counts[c] || 0) + 1;
            total++;
          }
        }
      }
      if (total === 0) continue;
      const currentCount = counts[current] || 0;
      // If this cell is sufficiently out of step with neighbours, replace it
      if (currentCount / total < (1 - threshold)) {
        const dominant = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
        result[y][x] = dominant;
      }
    }
  }
  return result;
}

// ── CORE PRIMITIVE: Region consolidation ─────────────────────────────────────
// Flood-fill all connected regions. Any region smaller than minSize gets
// absorbed into the most common colour among its border neighbours.
// Preserves all colours — only moves tiny isolated fragments.
function consolidateRegions(grid, cols, rows, minSize) {
  const visited = new Set();
  const result = grid.map(r => [...r]);

  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      const key = `${x},${y}`;
      if (visited.has(key)) continue;
      const color = grid[y][x];

      // Flood fill this region
      const region = [];
      const stack = [[x, y]];
      const seen = new Set();
      while (stack.length) {
        const [cx, cy] = stack.pop();
        const k = `${cx},${cy}`;
        if (seen.has(k)) continue;
        if (cx < 0 || cy < 0 || cx >= cols || cy >= rows) continue;
        if (grid[cy][cx] !== color) continue;
        seen.add(k); visited.add(k);
        region.push([cx, cy]);
        stack.push([cx+1,cy],[cx-1,cy],[cx,cy+1],[cx,cy-1]);
      }

      if (region.length < minSize) {
        // Find most common border neighbour
        const neighbourCounts = {};
        region.forEach(([rx, ry]) => {
          [[-1,0],[1,0],[0,-1],[0,1]].forEach(([dx, dy]) => {
            const nx = rx+dx, ny = ry+dy;
            if (nx>=0&&ny>=0&&nx<cols&&ny<rows && grid[ny][nx] !== color) {
              const nc = grid[ny][nx];
              neighbourCounts[nc] = (neighbourCounts[nc] || 0) + 1;
            }
          });
        });
        const entries = Object.entries(neighbourCounts);
        if (entries.length > 0) {
          const replacement = entries.sort((a, b) => b[1]-a[1])[0][0];
          region.forEach(([rx, ry]) => result[ry][rx] = replacement);
        }
      }
    }
  }
  return result;
}

// ── CORE PRIMITIVE: Background consolidation ─────────────────────────────────
// Detects the dominant edge-touching region and makes it internally consistent.
// Only touches cells that are part of the detected background — not everything.
function consolidateBackground(grid, cols, rows) {
  // Sample edges to find candidate bg colours
  const edgeCount = {};
  for (let x = 0; x < cols; x++) {
    [grid[0][x], grid[rows-1][x]].forEach(c => { edgeCount[c]=(edgeCount[c]||0)+1; });
  }
  for (let y = 1; y < rows-1; y++) {
    [grid[y][0], grid[y][cols-1]].forEach(c => { edgeCount[c]=(edgeCount[c]||0)+1; });
  }
  const sorted = Object.entries(edgeCount).sort((a,b) => b[1]-a[1]);
  if (sorted.length === 0) return grid.map(r=>[...r]);

  // Only treat the single most dominant edge colour as bg candidate
  const bgColor = sorted[0][0];
  const totalEdge = Object.values(edgeCount).reduce((a,b)=>a+b,0);
  // Only flatten if it genuinely dominates edges (>30%)
  if ((sorted[0][1] / totalEdge) < 0.3) return grid.map(r=>[...r]);

  // Flood fill from edges to find the connected bg region
  const bgCells = new Set();
  const stack = [];
  for (let x = 0; x < cols; x++) {
    if (grid[0][x] === bgColor) stack.push([x,0]);
    if (grid[rows-1][x] === bgColor) stack.push([x,rows-1]);
  }
  for (let y = 1; y < rows-1; y++) {
    if (grid[y][0] === bgColor) stack.push([0,y]);
    if (grid[y][cols-1] === bgColor) stack.push([cols-1,y]);
  }
  const visited = new Set();
  while (stack.length) {
    const [x,y] = stack.pop();
    const k = `${x},${y}`;
    if (visited.has(k)) continue;
    if (x<0||y<0||x>=cols||y>=rows) continue;
    visited.add(k);
    if (grid[y][x] === bgColor) {
      bgCells.add(k);
      stack.push([x+1,y],[x-1,y],[x,y+1],[x,y-1]);
    }
  }

  // Now within the bg region, find its most common colour (after smoothing may
  // have introduced a few variants) and unify — but ONLY cells clearly in the bg
  const result = grid.map(r=>[...r]);
  // Count colours within bg region
  const bgCount = {};
  bgCells.forEach(k => {
    const [x,y] = k.split(",").map(Number);
    const c = result[y][x]; bgCount[c]=(bgCount[c]||0)+1;
  });
  const dominant = Object.entries(bgCount).sort((a,b)=>b[1]-a[1])[0][0];
  bgCells.forEach(k => {
    const [x,y] = k.split(",").map(Number);
    result[y][x] = dominant;
  });
  return result;
}

// ── CORE PRIMITIVE: Skin tone correction ─────────────────────────────────────
// Only swaps out-of-family skin colours when surrounded by real skin tones.
function correctSkinTones(grid, cols, rows, palette) {
  const result = grid.map(r=>[...r]);
  const skinInPalette = SKIN_TONES.filter(s => palette.includes(s));
  if (skinInPalette.length === 0) return result;
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      if (!WRONG_SKIN.includes(result[y][x])) continue;
      let skinN = 0, total = 0;
      [[-1,0],[1,0],[0,-1],[0,1],[-1,-1],[1,-1],[-1,1],[1,1]].forEach(([dx,dy])=>{
        const nx=x+dx,ny=y+dy;
        if(nx>=0&&ny>=0&&nx<cols&&ny<rows){
          total++;
          if(SKIN_TONES.includes(grid[ny][nx])||WRONG_SKIN.includes(grid[ny][nx])) skinN++;
        }
      });
      if (total > 0 && skinN/total > 0.35) {
        const [r,g,b]=hexToRgb(result[y][x]);
        result[y][x]=getClosestColor(r,g,b,skinInPalette);
      }
    }
  }
  return result;
}

// ── THE 16 SMART DESIGN VARIANTS (4×4 grid) ───────────────────────────────────
// Row 1: Background treatments
// Row 2: Colour reduction styles
// Row 3: Tone & mood
// Row 4: Combined approaches

const SMART_VERSIONS = [
  // ── ROW 1: BACKGROUND TREATMENTS ────────────────────────────────────────────
  {
    id:1, row:"Background", name:"Flat background",
    desc:"Single solid background colour. Most common first edit.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=consolidateBackground(r,cols,rows);
      r=consolidateRegions(r,cols,rows,1);
      return r;
    }
  },
  {
    id:2, row:"Background", name:"Flat bg + tidy",
    desc:"Flat background with light foreground smoothing.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=consolidateBackground(r,cols,rows);
      r=smoothPass(r,cols,rows,0.2,1);
      r=consolidateRegions(r,cols,rows,2);
      return r;
    }
  },
  {
    id:3, row:"Background", name:"Flat bg + contrast",
    desc:"Flat background with foreground pushed away in brightness.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=consolidateBackground(r,cols,rows);
      // Boost contrast between bg and non-bg cells
      const bgCounts={};
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const c=r[y][x]; bgCounts[c]=(bgCounts[c]||0)+1;
      }
      const bgColor=Object.entries(bgCounts).sort((a,b)=>b[1]-a[1])[0][0];
      const bgLum=getLuminance(bgColor);
      const out=r.map(a=>[...a]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        if(r[y][x]===bgColor) continue;
        const lum=getLuminance(r[y][x]);
        const diff=Math.abs(lum-bgLum);
        if(diff<0.18){
          const [rv,gv,bv]=hexToRgb(r[y][x]);
          const cands=bgLum>0.5?pal.filter(p=>getLuminance(p)<bgLum-0.15):pal.filter(p=>getLuminance(p)>bgLum+0.15);
          if(cands.length>0) out[y][x]=getClosestColor(rv,gv,bv,cands);
        }
      }
      r=consolidateRegions(out,cols,rows,1);
      return r;
    }
  },
  {
    id:4, row:"Background", name:"Flat bg + skin fix",
    desc:"Flat background with skin tones corrected to proper LEGO colours.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=consolidateBackground(r,cols,rows);
      r=correctSkinTones(r,cols,rows,pal);
      r=consolidateRegions(r,cols,rows,1);
      return r;
    }
  },

  // ── ROW 2: COLOUR REDUCTION STYLES ───────────────────────────────────────────
  {
    id:5, row:"Colours", name:"Light clean",
    desc:"Full palette kept. Specks removed, edges tidied.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.2,1);
      r=consolidateRegions(r,cols,rows,2);
      return r;
    }
  },
  {
    id:6, row:"Colours", name:"12 colours",
    desc:"Reduced to 12 most-used colours with light smoothing.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.2,1);
      r=consolidateRegions(r,cols,rows,2);
      r=quantizePlaybook(r,cols,rows,12);
      return r;
    }
  },
  {
    id:7, row:"Colours", name:"8 colours",
    desc:"Reduced to 8 colours — bold but still detailed.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.25,1);
      r=consolidateRegions(r,cols,rows,3);
      r=quantizePlaybook(r,cols,rows,8);
      return r;
    }
  },
  {
    id:8, row:"Colours", name:"5 colours — graphic",
    desc:"Ultra-reduced to 5 colours. Poster/graphic novel look.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.35,1);
      r=consolidateRegions(r,cols,rows,4);
      r=quantizePlaybook(r,cols,rows,5);
      r=consolidateRegions(r,cols,rows,3);
      return r;
    }
  },

  // ── ROW 3: TONE & MOOD ────────────────────────────────────────────────────────
  {
    id:9, row:"Tone", name:"Skin corrected",
    desc:"Minimal change — only fixes skin tones mapped to wrong colours.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=correctSkinTones(r,cols,rows,pal);
      r=consolidateRegions(r,cols,rows,1);
      return r;
    }
  },
  {
    id:10, row:"Tone", name:"High contrast",
    desc:"Pushes lights lighter and darks darker throughout.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.15,1);
      const out=r.map(a=>[...a]);
      let lumSum=0,cnt=0;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){lumSum+=getLuminance(r[y][x]);cnt++;}
      const avg=lumSum/cnt;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(r[y][x]);
        const [rv,gv,bv]=hexToRgb(r[y][x]);
        if(lum>avg){
          const c=pal.filter(p=>getLuminance(p)>lum+0.12);
          if(c.length>0) out[y][x]=getClosestColor(rv,gv,bv,c);
        } else {
          const c=pal.filter(p=>getLuminance(p)<lum-0.12);
          if(c.length>0) out[y][x]=getClosestColor(rv,gv,bv,c);
        }
      }
      return out;
    }
  },
  {
    id:11, row:"Tone", name:"Darkened",
    desc:"All colours shifted darker. Moody, late-night feel.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.15,1);
      const out=r.map(a=>[...a]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(r[y][x]);
        const [rv,gv,bv]=hexToRgb(r[y][x]);
        const c=pal.filter(p=>getLuminance(p)<lum-0.1);
        if(c.length>0) out[y][x]=getClosestColor(rv,gv,bv,c);
      }
      return out;
    }
  },
  {
    id:12, row:"Tone", name:"Lightened",
    desc:"All colours shifted lighter. Bright, pop-art energy.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.15,1);
      const out=r.map(a=>[...a]);
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(r[y][x]);
        const [rv,gv,bv]=hexToRgb(r[y][x]);
        const c=pal.filter(p=>getLuminance(p)>lum+0.1);
        if(c.length>0) out[y][x]=getClosestColor(rv,gv,bv,c);
      }
      return out;
    }
  },

  // ── ROW 4: COMBINED APPROACHES ────────────────────────────────────────────────
  {
    id:13, row:"Combined", name:"Everyday edit",
    desc:"Flat bg + 10 colours + skin fix. The combination used in most manual edits.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.2,1);
      r=consolidateBackground(r,cols,rows);
      r=correctSkinTones(r,cols,rows,pal);
      r=consolidateRegions(r,cols,rows,2);
      r=quantizePlaybook(r,cols,rows,10);
      return r;
    }
  },
  {
    id:14, row:"Combined", name:"Cartoon",
    desc:"Heavy smooth + flat bg + 8 colours. Illustrated, chunky feel.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.35,1);
      r=consolidateRegions(r,cols,rows,4);
      r=smoothPass(r,cols,rows,0.3,1);
      r=consolidateBackground(r,cols,rows);
      r=quantizePlaybook(r,cols,rows,8);
      r=consolidateRegions(r,cols,rows,3);
      return r;
    }
  },
  {
    id:15, row:"Combined", name:"Graphic poster",
    desc:"Max contrast + flat bg + 6 colours. Bold, iconic, minimal.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=smoothPass(r,cols,rows,0.3,1);
      r=consolidateBackground(r,cols,rows);
      // High contrast pass
      const out=r.map(a=>[...a]);
      let lumSum=0,cnt=0;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){lumSum+=getLuminance(r[y][x]);cnt++;}
      const avg=lumSum/cnt;
      for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
        const lum=getLuminance(r[y][x]);
        const [rv,gv,bv]=hexToRgb(r[y][x]);
        if(lum>avg){const c=pal.filter(p=>getLuminance(p)>lum+0.1);if(c.length>0)out[y][x]=getClosestColor(rv,gv,bv,c);}
        else{const c=pal.filter(p=>getLuminance(p)<lum-0.1);if(c.length>0)out[y][x]=getClosestColor(rv,gv,bv,c);}
      }
      r=quantizePlaybook(out,cols,rows,6);
      r=consolidateRegions(r,cols,rows,3);
      return r;
    }
  },
  {
    id:16, row:"Combined", name:"Minimal touch",
    desc:"Single orphan removal only. Closest to the raw auto-generate.",
    generate(g,cols,rows,pal){
      let r=g.map(a=>[...a]);
      r=consolidateRegions(r,cols,rows,1);
      return r;
    }
  }
];

// ── SMART DESIGN UI ───────────────────────────────────────────────────────────
let versionGridDatas = [];

function openSmartDesign() {
  if(!imageSrc||!rendered) return;
  document.getElementById("version-overlay").classList.add("show");
  buildVersionGrid();
}
function closeSmartDesign() {
  document.getElementById("version-overlay").classList.remove("show");
}

function buildVersionGrid() {
  const grid=document.getElementById("version-grid");
  grid.innerHTML="";
  const palette=LEGO_COLORS.map(c=>c.hex).filter(h=>!disabledColors.has(h));
  const {cols,rows}=currentRes;
  const cs=Math.max(2,Math.floor(130/Math.max(cols,rows)));
  versionGridDatas=[];

  const ROW_LABELS = {
    "Background": "Row 1 — Background treatments",
    "Colours":    "Row 2 — Colour reduction",
    "Tone":       "Row 3 — Tone & mood",
    "Combined":   "Row 4 — Combined approaches"
  };
  const seenRows = new Set();

  const img=new Image();
  img.onload=()=>{
    const baseGrid=sampleImage(img,cols,rows,adj,palette);

    SMART_VERSIONS.forEach((ver,idx)=>{
      // Insert row label on first card of each row
      if(!seenRows.has(ver.row)){
        seenRows.add(ver.row);
        const label=document.createElement("div");
        label.className="version-row-label";
        label.textContent=ROW_LABELS[ver.row]||ver.row;
        grid.appendChild(label);
      }

      const card=document.createElement("div");
      card.className="version-card";
      card.innerHTML=`
        <div class="version-card-header">
          <div class="version-card-num">${idx+1} of 16</div>
          <div class="version-card-name">${ver.name}</div>
          <div class="version-card-desc">${ver.desc}</div>
        </div>
        <div class="version-canvas-wrap" id="vwrap-${idx}">
          <div class="version-generating-msg">…</div>
        </div>
        <div class="version-card-footer">
          <button class="version-use-btn" id="vbtn-${idx}" disabled onclick="applyVersion(${idx})">Use this</button>
        </div>`;
      grid.appendChild(card);

      // Stagger generation so UI stays responsive
      setTimeout(()=>{
        const vGrid=ver.generate(baseGrid,cols,rows,palette);
        versionGridDatas[idx]=vGrid;

        const wrap=document.getElementById(`vwrap-${idx}`);
        const mc=document.createElement("canvas");
        mc.width=cols*cs; mc.height=rows*cs;
        mc.style.imageRendering="pixelated";
        const mctx=mc.getContext("2d");
        for(let y=0;y<rows;y++) for(let x=0;x<cols;x++){
          const color=vGrid[y][x];
          const px=x*cs, py=y*cs;
          mctx.fillStyle=color;
          mctx.fillRect(px,py,cs,cs);
          if(cs>=5){
            const [cr,cg,cb]=hexToRgb(color);
            const lum=(0.299*cr+0.587*cg+0.114*cb)/255;
            const sr=Math.max(1,cs*0.25);
            mctx.beginPath();mctx.arc(px+cs/2,py+cs/2,sr,0,Math.PI*2);
            mctx.fillStyle=lum>0.5?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.1)";
            mctx.fill();
          }
        }
        wrap.innerHTML="";
        wrap.appendChild(mc);
        document.getElementById(`vbtn-${idx}`).disabled=false;
      }, idx*80);
    });
  };
  img.src=imageSrc;
}

function applyVersion(idx) {
  const vGrid=versionGridDatas[idx];
  if(!vGrid) return;
  saveUndo();
  playbookGrid=vGrid.map(r=>[...r]);
  redrawGrid();
  closeSmartDesign();
  document.getElementById("left-scroll").scrollTo({top:0,behavior:"smooth"});
}

// ── REGION VARIATIONS TOOL ────────────────────────────────────────────────────
let regionSel = null;       // {x0,y0,x1,y1} in grid coords (normalised)
let regionDrag = null;      // dragging start cell
let regionVariants = [];    // array of 5 partial grids (just the selected region)

// The 5 region variant recipes — purpose-built for real editing decisions
const REGION_VARIANTS = [
  {
    name:"Flatten",
    desc:"One solid colour — the most dominant in the region. Best for backgrounds, skies, walls, solid objects.",
    fn(sub, w, h, palette) {
      // Count colours, find dominant
      const counts={};
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){const c=sub[y][x];counts[c]=(counts[c]||0)+1;}
      const dominant=Object.entries(counts).sort((a,b)=>b[1]-a[1])[0][0];
      return sub.map(r=>r.map(()=>dominant));
    }
  },
  {
    name:"Simplify",
    desc:"Reduces to the 2–3 most important colours. Keeps light/shadow contrast but removes noise. Good for faces and objects.",
    fn(sub, w, h, palette) {
      // Find the top 3 colours by pixel count
      const counts={};
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){const c=sub[y][x];counts[c]=(counts[c]||0)+1;}
      const top3=Object.entries(counts).sort((a,b)=>b[1]-a[1]).slice(0,3).map(([c])=>c);
      // Remap every cell to nearest of top 3
      const result=sub.map(r=>[...r]);
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){
        if(!top3.includes(result[y][x])){
          const [r,g,b]=hexToRgb(result[y][x]);
          result[y][x]=getClosestColor(r,g,b,top3);
        }
      }
      // Light smooth to clean up any scattered remapped cells
      return regionSmooth(result,w,h,0.2,1);
    }
  },
  {
    name:"Clean Edges",
    desc:"Removes scattered specks and noise while keeping all colours. Makes the region read as coherent without simplifying it.",
    fn(sub, w, h, palette) {
      let g=sub.map(r=>[...r]);
      g=regionSmooth(g,w,h,0.3,1);
      g=regionConsolidate(g,w,h,2);
      return g;
    }
  },
  {
    name:"Darken",
    desc:"Shifts each colour to a darker LEGO equivalent. Makes areas recede or adds depth. Good for shadowed areas or overly bright backgrounds.",
    fn(sub, w, h, palette) {
      const result=sub.map(r=>[...r]);
      const darkPalette=palette.slice().sort((a,b)=>getLuminance(a)-getLuminance(b));
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){
        const cur=result[y][x];
        const lum=getLuminance(cur);
        // Find the closest colour that is meaningfully darker
        const candidates=palette.filter(p=>getLuminance(p)<lum-0.08);
        if(candidates.length>0){
          const [r,g,b]=hexToRgb(cur);
          result[y][x]=getClosestColor(r,g,b,candidates);
        }
        // If already very dark, keep as-is
      }
      return result;
    }
  },
  {
    name:"Lighten",
    desc:"Shifts each colour to a lighter LEGO equivalent. Makes areas come forward or brightens dull regions. Good for skin tones and focal subjects.",
    fn(sub, w, h, palette) {
      const result=sub.map(r=>[...r]);
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){
        const cur=result[y][x];
        const lum=getLuminance(cur);
        // Find closest colour that is meaningfully lighter
        const candidates=palette.filter(p=>getLuminance(p)>lum+0.08);
        if(candidates.length>0){
          const [r,g,b]=hexToRgb(cur);
          result[y][x]=getClosestColor(r,g,b,candidates);
        }
        // If already very light, keep as-is
      }
      return result;
    }
  }
];

// Mini smoothPass and consolidate that work on a sub-grid (no outer grid context)
function regionSmooth(sub, w, h, threshold, radius) {
  const result = sub.map(r=>[...r]);
  for(let y=0;y<h;y++) for(let x=0;x<w;x++){
    const current=sub[y][x];
    const counts={};let total=0;
    for(let dy=-radius;dy<=radius;dy++) for(let dx=-radius;dx<=radius;dx++){
      if(dx===0&&dy===0) continue;
      const nx=x+dx,ny=y+dy;
      if(nx>=0&&ny>=0&&nx<w&&ny<h){counts[sub[ny][nx]]=(counts[sub[ny][nx]]||0)+1;total++;}
    }
    if(total===0) continue;
    const currentCount=counts[current]||0;
    if(currentCount/total<(1-threshold)){
      result[y][x]=Object.entries(counts).sort((a,b)=>b[1]-a[1])[0][0];
    }
  }
  return result;
}

function regionConsolidate(sub, w, h, minSize) {
  const visited=new Set();
  const result=sub.map(r=>[...r]);
  for(let y=0;y<h;y++) for(let x=0;x<w;x++){
    const key=`${x},${y}`;
    if(visited.has(key)) continue;
    const color=sub[y][x];
    const region=[];const stack=[[x,y]];const seen=new Set();
    while(stack.length){
      const[cx,cy]=stack.pop();const k=`${cx},${cy}`;
      if(seen.has(k)) continue;
      if(cx<0||cy<0||cx>=w||cy>=h) continue;
      if(sub[cy][cx]!==color) continue;
      seen.add(k);visited.add(k);region.push([cx,cy]);
      stack.push([cx+1,cy],[cx-1,cy],[cx,cy+1],[cx,cy-1]);
    }
    if(region.length<minSize){
      const nc={};
      region.forEach(([rx,ry])=>{
        [[-1,0],[1,0],[0,-1],[0,1]].forEach(([dx,dy])=>{
          const nx=rx+dx,ny=ry+dy;
          if(nx>=0&&ny>=0&&nx<w&&ny<h&&sub[ny][nx]!==color)
            nc[sub[ny][nx]]=(nc[sub[ny][nx]]||0)+1;
        });
      });
      const entries=Object.entries(nc);
      if(entries.length>0){
        const rep=entries.sort((a,b)=>b[1]-a[1])[0][0];
        region.forEach(([rx,ry])=>result[ry][rx]=rep);
      }
    }
  }
  return result;
}

function extractRegion(sel) {
  const {x0,y0,x1,y1}=sel;
  const w=x1-x0, h=y1-y0;
  const source=playbookGrid.length?playbookGrid:gridData;
  const sub=[];
  for(let y=0;y<h;y++){
    sub[y]=[];
    for(let x=0;x<w;x++) sub[y][x]=source[y0+y][x0+x];
  }
  return {sub,w,h};
}

// Draw the rubber-band selection rectangle on the overlay canvas
function drawSelectionRect(x0,y0,x1,y1) {
  const sc=document.getElementById("selection-canvas");
  const ctx=sc.getContext("2d");
  ctx.clearRect(0,0,sc.width,sc.height);
  if(x0===x1||y0===y1) return;
  const px0=x0*cellSize, py0=y0*cellSize;
  const pw=(x1-x0)*cellSize, ph=(y1-y0)*cellSize;
  // Dimmed overlay outside selection
  ctx.fillStyle="rgba(0,0,0,0.45)";
  ctx.fillRect(0,0,sc.width,sc.height);
  // Clear selected area
  ctx.clearRect(px0,py0,pw,ph);
  // Bright selection border
  ctx.strokeStyle="#FFD700";
  ctx.lineWidth=2;
  ctx.strokeRect(px0+1,py0+1,pw-2,ph-2);
  // Corner handles
  const hs=6;
  ctx.fillStyle="#FFD700";
  [[px0,py0],[px0+pw-hs,py0],[px0,py0+ph-hs],[px0+pw-hs,py0+ph-hs]].forEach(([hx,hy])=>{
    ctx.fillRect(hx,hy,hs,hs);
  });
  // Size label
  const w=x1-x0, h=y1-y0;
  ctx.fillStyle="#FFD700";
  ctx.font="bold 10px 'DM Mono',monospace";
  ctx.fillText(`${w}×${h} bricks`,px0+4,py0-4>8?py0-4:py0+14);
}

function clearSelectionRect() {
  const sc=document.getElementById("selection-canvas");
  sc.getContext("2d").clearRect(0,0,sc.width,sc.height);
}

// Normalise coords so x0<x1, y0<y1
function normSel(ax,ay,bx,by) {
  return {
    x0:Math.min(ax,bx), y0:Math.min(ay,by),
    x1:Math.max(ax,bx)+1, y1:Math.max(ay,by)+1
  };
}

// Open the region overlay and generate 5 variants
function openRegionOverlay(sel) {
  regionSel=sel;
  const {sub,w,h}=extractRegion(sel);
  const palette=LEGO_COLORS.map(c=>c.hex).filter(hx=>!disabledColors.has(hx));

  document.getElementById("region-overlay-desc").textContent=
    `${w}×${h} brick region — choose how to treat this area, then apply.`;

  const grid=document.getElementById("region-version-grid");
  grid.innerHTML="";
  regionVariants=[];

  // Scale for preview — aim for ~150px wide
  const previewScale=Math.max(4,Math.min(12,Math.floor(150/Math.max(w,h))));

  REGION_VARIANTS.forEach((vr,idx)=>{
    const card=document.createElement("div");
    card.className="rvar-card";
    card.innerHTML=`
      <div class="rvar-header">
        <div class="rvar-num">Option ${idx+1}</div>
        <div class="rvar-name">${vr.name}</div>
        <div class="rvar-desc">${vr.desc}</div>
      </div>
      <div class="rvar-canvas-wrap" id="rw-${idx}">
        <div class="rvar-gen-msg">…</div>
      </div>
      <div class="rvar-footer">
        <button class="rvar-apply-btn" id="rb-${idx}" disabled onclick="applyRegionVariant(${idx})">Apply</button>
      </div>`;
    grid.appendChild(card);

    setTimeout(()=>{
      const varGrid=vr.fn(sub,w,h,palette);
      regionVariants[idx]=varGrid;

      const mc=document.createElement("canvas");
      mc.width=w*previewScale; mc.height=h*previewScale;
      mc.style.imageRendering="pixelated";
      const mctx=mc.getContext("2d");
      for(let y=0;y<h;y++) for(let x=0;x<w;x++){
        const color=varGrid[y][x];
        const px=x*previewScale, py=y*previewScale;
        mctx.fillStyle=color;
        mctx.fillRect(px,py,previewScale,previewScale);
        if(previewScale>=5){
          const [cr,cg,cb]=hexToRgb(color);
          const lum=(0.299*cr+0.587*cg+0.114*cb)/255;
          const sr=Math.max(1,previewScale*0.25);
          mctx.beginPath();mctx.arc(px+previewScale/2,py+previewScale/2,sr,0,Math.PI*2);
          mctx.fillStyle=lum>0.5?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.1)";
          mctx.fill();
        }
      }
      const wrap=document.getElementById(`rw-${idx}`);
      wrap.innerHTML="";
      wrap.appendChild(mc);
      document.getElementById(`rb-${idx}`).disabled=false;
    }, idx*60);
  });

  document.getElementById("region-overlay").classList.add("show");
}

function closeRegionOverlay() {
  document.getElementById("region-overlay").classList.remove("show");
  clearSelectionRect();
  clearImageSelectionRect();
  regionSel=null; regionDrag=null; imageRegionDrag=null;
}

// ── IMAGE PANEL REGION SELECTION ─────────────────────────────────────────────
// Allows dragging on the original photo to select a region that maps to grid coords

let imageRegionDrag = null; // {x,y} in image pixel coords

// Convert a position on the image-sel-canvas to grid cell coords
function imagePointToCell(clientX, clientY) {
  const imgEl = document.querySelector("#upload-label img");
  if (!imgEl) return null;
  const rect = imgEl.getBoundingClientRect();
  // Position within the rendered image
  const relX = clientX - rect.left;
  const relY = clientY - rect.top;
  if (relX < 0 || relY < 0 || relX > rect.width || relY > rect.height) return null;
  // Map to grid cell — image maps 1:1 to grid
  const gx = Math.floor((relX / rect.width) * gridCols);
  const gy = Math.floor((relY / rect.height) * gridRows);
  if (gx < 0 || gy < 0 || gx >= gridCols || gy >= gridRows) return null;
  return {x: Math.min(gx, gridCols-1), y: Math.min(gy, gridRows-1)};
}

// Draw selection on image overlay canvas
function drawImageSelectionRect(ax, ay, bx, by) {
  const sc = document.getElementById("image-sel-canvas");
  const imgEl = document.querySelector("#upload-label img");
  if (!imgEl) return;
  const imgRect = imgEl.getBoundingClientRect();
  const wrap = document.getElementById("image-select-wrap");
  const wrapRect = wrap.getBoundingClientRect();

  // Size canvas to match image display size
  sc.width = imgRect.width;
  sc.height = imgRect.height;

  const ctx = sc.getContext("2d");
  ctx.clearRect(0, 0, sc.width, sc.height);

  // Convert grid cells back to image pixel coords
  const cellW = imgRect.width / gridCols;
  const cellH = imgRect.height / gridRows;
  const x0 = Math.min(ax,bx) * cellW;
  const y0 = Math.min(ay,by) * cellH;
  const x1 = (Math.max(ax,bx)+1) * cellW;
  const y1 = (Math.max(ay,by)+1) * cellH;

  // Dim everything outside selection
  ctx.fillStyle = "rgba(0,0,0,0.5)";
  ctx.fillRect(0, 0, sc.width, sc.height);
  ctx.clearRect(x0, y0, x1-x0, y1-y0);

  // Gold border
  ctx.strokeStyle = "#FFD700";
  ctx.lineWidth = 2;
  ctx.strokeRect(x0+1, y0+1, x1-x0-2, y1-y0-2);

  // Size label
  const w = Math.abs(bx-ax)+1, h = Math.abs(by-ay)+1;
  ctx.fillStyle = "#FFD700";
  ctx.font = "bold 10px 'DM Mono',monospace";
  const labelY = y0 > 16 ? y0-4 : y1+12;
  ctx.fillText(`${w}×${h} bricks`, x0+3, labelY);
}

function clearImageSelectionRect() {
  const sc = document.getElementById("image-sel-canvas");
  if (sc) sc.getContext("2d").clearRect(0, 0, sc.width, sc.height);
}

// Wire up image overlay canvas events
function initImageSelCanvas() {
  const sc = document.getElementById("image-sel-canvas");

  sc.addEventListener("mousedown", e => {
    if (activeTool !== "region" || !rendered) return;
    e.preventDefault(); e.stopPropagation();
    const cell = imagePointToCell(e.clientX, e.clientY);
    if (!cell) return;
    imageRegionDrag = cell;
  });

  sc.addEventListener("mousemove", e => {
    if (activeTool !== "region" || !imageRegionDrag) return;
    const cell = imagePointToCell(e.clientX, e.clientY);
    if (cell) drawImageSelectionRect(imageRegionDrag.x, imageRegionDrag.y, cell.x, cell.y);
  });

  sc.addEventListener("mouseup", e => {
    if (activeTool !== "region" || !imageRegionDrag) return;
    const cell = imagePointToCell(e.clientX, e.clientY);
    if (cell) {
      const s = normSel(imageRegionDrag.x, imageRegionDrag.y, cell.x, cell.y);
      if (s.x1 - s.x0 >= 1 && s.y1 - s.y0 >= 1) openRegionOverlay(s);
    }
    imageRegionDrag = null;
  });

  sc.addEventListener("mouseleave", e => { imageRegionDrag = null; });

  // Touch support
  sc.addEventListener("touchstart", e => {
    if (activeTool !== "region" || !rendered) return;
    e.preventDefault();
    const t = e.touches[0];
    const cell = imagePointToCell(t.clientX, t.clientY);
    if (cell) imageRegionDrag = cell;
  }, {passive:false});

  sc.addEventListener("touchmove", e => {
    if (activeTool !== "region" || !imageRegionDrag) return;
    e.preventDefault();
    const t = e.touches[0];
    const cell = imagePointToCell(t.clientX, t.clientY);
    if (cell) drawImageSelectionRect(imageRegionDrag.x, imageRegionDrag.y, cell.x, cell.y);
  }, {passive:false});

  sc.addEventListener("touchend", e => {
    if (activeTool !== "region" || !imageRegionDrag) return;
    const t = e.changedTouches[0];
    const cell = imagePointToCell(t.clientX, t.clientY);
    if (cell) {
      const s = normSel(imageRegionDrag.x, imageRegionDrag.y, cell.x, cell.y);
      if (s.x1 - s.x0 >= 1 && s.y1 - s.y0 >= 1) openRegionOverlay(s);
    }
    imageRegionDrag = null;
  });
}

function applyRegionVariant(idx) {
  if(!regionSel||!regionVariants[idx]) return;
  saveUndo();
  if(!playbookGrid.length) playbookGrid=gridData.map(r=>[...r]);
  const {x0,y0,x1,y1}=regionSel;
  const varGrid=regionVariants[idx];
  const canvas=document.getElementById("mosaic-canvas");
  const ctx=canvas.getContext("2d");
  for(let y=0;y<y1-y0;y++) for(let x=0;x<x1-x0;x++){
    playbookGrid[y0+y][x0+x]=varGrid[y][x];
    drawCell(ctx,x0+x,y0+y,varGrid[y][x]);
  }
  updateStats();
  closeRegionOverlay();
}
function setTool(name) {
  // Auto-close any open tool panels before switching
  const prevTool = activeTool;
  if(prevTool === 'swap' && name !== 'swap') closeSwapTool();
  if((prevTool === 'mask' || prevTool === 'smartsel') && name !== 'mask' && name !== 'smartsel') closeMaskPanel();
  // Reset pan button if switching away from pan
  if(prevTool === 'pan' && name !== 'pan') {
    const pb = document.getElementById('mob-pan-btn');
    if(pb) { pb.style.background='transparent'; pb.style.color='var(--muted)'; pb.style.borderColor='var(--border2)'; }
    const mc = document.getElementById('mosaic-canvas');
    if(mc) mc.style.cursor = '';
  }

  activeTool=name;
  document.querySelectorAll(".tool-btn").forEach(b=>b.classList.remove("active"));
  const canvas=document.getElementById("mosaic-canvas");
  const selCanvas=document.getElementById("selection-canvas");
  const imgSelCanvas=document.getElementById("image-sel-canvas");
  const leftSticky=document.getElementById("left-sticky");
  const regionHint=document.getElementById("region-hint");
  canvas.classList.remove("tool-active","tool-picker","tool-region","tool-mask","tool-smartsel");
  imgSelCanvas.style.display="none";
  leftSticky.classList.remove("region-active");
  if(regionHint) regionHint.style.display="none";
  clearImageSelectionRect();

  if(name==="brush"||name==="bucket"){
    document.getElementById("tool-"+name).classList.add("active");
    canvas.classList.add("tool-active");
    selCanvas.style.display="none"; clearSelectionRect();
  } else if(name==="picker"){
    document.getElementById("tool-picker").classList.add("active");
    canvas.classList.add("tool-picker");
    selCanvas.style.display="none"; clearSelectionRect();
  } else if(name==="mask"){
    document.getElementById("tool-mask").classList.add("active");
    canvas.classList.add("tool-mask");
    selCanvas.width=canvas.width; selCanvas.height=canvas.height;
    selCanvas.style.display="block";
    cancelMask();
    document.getElementById("mask-panel-title").textContent="⬡ Mask Tool";
    document.getElementById("mask-hint").textContent="Tap to place points. Tap near start point to close the shape.";
    document.getElementById("smartsel-count").textContent="";
    const cpw = document.getElementById("mob-close-polygon-wrap");
    if(cpw) cpw.style.display="block";
    const tw = document.getElementById("tolerance-wrap");
    if(tw) tw.style.display="none";
    showMaskPanel();
  } else if(name==="smartsel"){
    document.getElementById("tool-smartsel").classList.add("active");
    canvas.classList.add("tool-smartsel");
    selCanvas.width=canvas.width; selCanvas.height=canvas.height;
    selCanvas.style.display="block";
    cancelMask();
    document.getElementById("mask-panel-title").textContent="✦ Smart Select";
    document.getElementById("mask-hint").textContent="Tap a brick to select. Tap again to add more regions.";
    document.getElementById("smartsel-count").textContent="";
    const cpw = document.getElementById("mob-close-polygon-wrap");
    if(cpw) cpw.style.display="none";
    const tw = document.getElementById("tolerance-wrap");
    if(tw) tw.style.display="block";
    showMaskPanel();
  } else if(name==="swap"){
    document.getElementById("tool-swap").classList.add("active");
    canvas.classList.add("tool-swap");
    selCanvas.style.display="none"; clearSelectionRect();
    openSwapTool();
  } else {
    selCanvas.style.display="none"; clearSelectionRect();
    closeSwapTool();
  }
}

function canvasToCell(e) {
  const canvas=document.getElementById("mosaic-canvas");
  const rect=canvas.getBoundingClientRect();
  const cx=e.clientX-rect.left,cy=e.clientY-rect.top;
  const scaleX=gridCols*cellSize/rect.width,scaleY=gridRows*cellSize/rect.height;
  const gx=Math.floor(cx*scaleX/cellSize),gy=Math.floor(cy*scaleY/cellSize);
  if(gx<0||gy<0||gx>=gridCols||gy>=gridRows) return null;
  return {x:gx,y:gy};
}

function captureState(savedImageSrc) {
  const display=playbookGrid.length?playbookGrid:gridData;
  const snap=display.map(row=>[...row]);
  const gridDataSnap=gridData.length?gridData.map(row=>[...row]):[];
  const labelSnap=document.getElementById("upload-label").innerHTML;
  return {
    grid:snap, gridData:gridDataSnap, imgSrc:savedImageSrc||imageSrc, label:labelSnap,
    res:currentRes, shape:currentShape, baseplate:baseplateMode,
    cols:gridCols, rows:gridRows,
    adj:{...adj}, interpMode:interpMode,
    activeQuickFilter:activeQuickFilter, activeAdvFilter:activeAdvFilter,
  };
}

function saveUndo(savedImageSrc) {
  undoStack.push(captureState(savedImageSrc));
  if(undoStack.length>MAX_UNDO) undoStack.shift();
  redoStack=[];
  updateUndoBtn();
  updateRedoBtn();
  if(preparedDesignUrl) resetPrepareState();
}

function restoreUndoUI(entry) {
  // Restore adj sliders and labels
  if(entry.adj) {
    adj = {...entry.adj};
    const fmt = v => (v > 0 ? '+' + v : '' + v);
    const sliderMap = {
      'sl-brightness': [adj.brightness, 'lbl-brightness', fmt(adj.brightness)],
      'sl-contrast':   [adj.contrast,   'lbl-contrast',   fmt(adj.contrast)],
      'sl-saturation': [adj.saturation, 'lbl-saturation', fmt(adj.saturation)],
      'sl-hue':        [adj.hue,        'lbl-hue',        adj.hue + '°'],
      'sl-detail':     [adj.detail,     'lbl-detail',     '' + adj.detail],
      'sl-red':        [adj.red,        'lbl-red',        fmt(adj.red)],
      'sl-green':      [adj.green,      'lbl-green',      fmt(adj.green)],
      'sl-blue':       [adj.blue,       'lbl-blue',       fmt(adj.blue)],
      'sl-colors':     [adj.colors,     'lbl-colors',     '' + adj.colors],
    };
    Object.entries(sliderMap).forEach(([sid, [val, lid, txt]]) => {
      const sl = document.getElementById(sid);
      const lb = document.getElementById(lid);
      if(sl) sl.value = val;
      if(lb) lb.textContent = txt;
    });
  }
  // Restore sampling method
  if(entry.interpMode !== undefined) {
    interpMode = entry.interpMode;
    document.querySelectorAll('.interp-btn').forEach(b => {
      b.classList.toggle('active',
        (interpMode === 'nearest' && b.textContent.toLowerCase().includes('nearest')) ||
        (interpMode === 'avg' && b.textContent.toLowerCase().includes('average'))
      );
    });
  }
  // Restore quick filter highlight (match by name)
  activeQuickFilter = entry.activeQuickFilter || null;
  document.querySelectorAll('.filter-btn').forEach(b => {
    b.classList.toggle('active', activeQuickFilter && b.textContent === activeQuickFilter);
  });
  // Restore advanced filter highlight (match by button id="adv-{id}")
  activeAdvFilter = entry.activeAdvFilter || null;
  document.querySelectorAll('.adv-filter-btn').forEach(b => {
    b.classList.toggle('active', activeAdvFilter && b.id === 'adv-' + activeAdvFilter);
  });
  // Update adv filter label
  const advLabel = document.getElementById('adv-filter-label');
  const advClear = document.getElementById('adv-filter-clear');
  if(advLabel) advLabel.textContent = activeAdvFilter || 'None selected';
  if(advClear) advClear.style.display = activeAdvFilter ? 'inline' : 'none';
}

function resetPrepareState() {
  // Clear prepared data
  const wasPrepared = preparedDesignUrl !== null;
  preparedDesignUrl=null; preparedInstrUrl=null; preparedSourceUrl=null;
  preparedVariantId=null;
  // Reset bars
  const bar = document.getElementById('prepare-progress-bar');
  const mbar = document.getElementById('mob-prog-bar');
  if(bar) { bar.style.width='0%'; bar.style.background='var(--gold)'; }
  if(mbar) { mbar.style.width='0%'; mbar.style.background='var(--gold)'; }
  // Hide status
  const status=document.getElementById('prepare-status');
  const mobStatus=document.getElementById('mob-prepare-status');
  if(status) status.style.display='none';
  if(mobStatus) { mobStatus.classList.add('mob-prepare-status-hidden'); mobStatus.style.display='none'; }
  // Desktop button
  const btn=document.getElementById('prepare-btn');
  const cartBtn=document.getElementById('cart-btn');
  if(btn){ btn.textContent='🔲 Prepare Mosaic'; btn.disabled=false; btn.onclick=prepareMosaic; btn.style.cssText='width:100%;padding:13px;background:var(--gold);color:#f5f0e8;border:none;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600;font-family:inherit;letter-spacing:1px;text-transform:uppercase;transition:all 0.2s;display:block;'; }
  if(cartBtn){ cartBtn.disabled=true; cartBtn.style.background='var(--bg3)'; cartBtn.style.color='var(--muted2)'; cartBtn.style.borderColor='var(--border2)'; cartBtn.style.cursor='not-allowed'; cartBtn.textContent='🛒 Add to Cart'; }
  // Mobile button
  const mobBtn=document.getElementById('mob-prepare-btn');
  const mobCartBtn=document.getElementById('mob-cart-btn');
  if(mobBtn){ mobBtn.textContent='🔲 Prepare Mosaic'; mobBtn.disabled=false; mobBtn.style.cssText='background:var(--gold);color:#f5f0e8;border:none;opacity:1;'; }
  if(mobCartBtn){ mobCartBtn.disabled=true; mobCartBtn.style.background='var(--bg3)'; mobCartBtn.style.color='var(--muted2)'; mobCartBtn.style.borderColor='var(--border2)'; mobCartBtn.style.cursor='not-allowed'; }
}
function doUndo() {
  if(!undoStack.length) return;
  redoStack.push(captureState());
  const entry=undoStack.pop();
  playbookGrid=entry.grid.map(row=>[...row]);
  if(entry.gridData && entry.gridData.length) gridData=entry.gridData.map(row=>[...row]);
  if(entry.imgSrc) imageSrc=entry.imgSrc;
  if(entry.label) document.getElementById("upload-label").innerHTML=entry.label;
  // Restore size/shape/baseplate if stored
  const sizeChanged = entry.res && (entry.cols !== gridCols || entry.rows !== gridRows);
  if(entry.res) { currentRes=entry.res; gridCols=entry.cols; gridRows=entry.rows; }
  if(entry.shape) currentShape=entry.shape;
  if(entry.baseplate) baseplateMode=entry.baseplate;
  // Always update size UI
  if(entry.res) {
    document.querySelectorAll('.res-btn').forEach(b=>{
      b.classList.toggle('active', b.textContent===entry.res.label);
    });
  }
  updateBaseplateUI();
  restoreUndoUI(entry);
  updateUndoBtn();
  updateRedoBtn();
  if(sizeChanged) {
    cellSize=Math.max(4,Math.floor(1024/Math.max(entry.cols,entry.rows)));
    const canvas=document.getElementById('mosaic-canvas');
    canvas.width=entry.cols*cellSize;
    canvas.height=entry.rows*cellSize;
    rendered=true;
    redrawGrid();
    updateStats();
  } else {
    redrawGrid();
  }
}
function doRedo() {
  if(!redoStack.length) return;
  undoStack.push(captureState());
  const entry=redoStack.pop();
  playbookGrid=entry.grid.map(row=>[...row]);
  if(entry.gridData && entry.gridData.length) gridData=entry.gridData.map(row=>[...row]);
  if(entry.imgSrc) imageSrc=entry.imgSrc;
  if(entry.label) document.getElementById("upload-label").innerHTML=entry.label;
  const sizeChangedRedo = entry.res && (entry.cols !== gridCols || entry.rows !== gridRows);
  if(entry.res) { currentRes=entry.res; gridCols=entry.cols; gridRows=entry.rows; }
  if(entry.shape) currentShape=entry.shape;
  if(entry.baseplate) baseplateMode=entry.baseplate;
  if(entry.res) {
    document.querySelectorAll('.res-btn').forEach(b=>{
      b.classList.toggle('active', b.textContent===entry.res.label);
    });
  }
  updateBaseplateUI();
  updateUndoBtn();
  updateRedoBtn();
  restoreUndoUI(entry);
  if(sizeChangedRedo) {
    cellSize=Math.max(4,Math.floor(1024/Math.max(entry.cols,entry.rows)));
    const canvas=document.getElementById('mosaic-canvas');
    canvas.width=entry.cols*cellSize;
    canvas.height=entry.rows*cellSize;
    rendered=true;
    redrawGrid();
    updateStats();
  } else {
    redrawGrid();
  }
}
function updateUndoBtn() {
  const btn=document.getElementById("undo-btn");
  if(undoStack.length>0) btn.classList.add("enabled"); else btn.classList.remove("enabled");
}
function updateRedoBtn() {
  const btn=document.getElementById("redo-btn");
  if(redoStack.length>0) btn.classList.add("enabled"); else btn.classList.remove("enabled");
}

// Returns true if cell (x,y) is part of the 2-brick frame border
function isFrameCell(x, y) {
  if(baseplateMode !== 'framed') return false;
  return x < 2 || y < 2 || x >= gridCols-2 || y >= gridRows-2;
}

function paintCell(x,y) {
  if(isFrameCell(x,y)) return;
  if(!playbookGrid.length) playbookGrid=gridData.map(r=>[...r]);
  if(playbookGrid[y][x]===paintColor) return;
  // Auto-enable the colour if it's currently disabled
  if(disabledColors.has(paintColor)) {
    disabledColors.delete(paintColor);
    buildPaletteUI();
  }
  playbookGrid[y][x]=paintColor;
  drawCell(document.getElementById("mosaic-canvas").getContext("2d"),x,y,paintColor);
}
function brushAt(x,y) {
  const sz=parseInt(document.getElementById("brush-size").value);
  const r=Math.floor(sz/2);
  for(let dy=-r;dy<=r;dy++) for(let dx=-r;dx<=r;dx++){const nx=x+dx,ny=y+dy;if(nx>=0&&ny>=0&&nx<gridCols&&ny<gridRows) paintCell(nx,ny);}
}
function floodFill(startX,startY) {
  if(isFrameCell(startX,startY)) return;
  if(!playbookGrid.length) playbookGrid=gridData.map(r=>[...r]);
  const targetColor=playbookGrid[startY][startX];
  if(targetColor===paintColor) return;
  // Auto-enable the colour if it's currently disabled
  if(disabledColors.has(paintColor)) {
    disabledColors.delete(paintColor);
    buildPaletteUI();
  }
  saveUndo();
  const canvas=document.getElementById("mosaic-canvas");
  const ctx=canvas.getContext("2d");
  const stack=[[startX,startY]];
  const visited=new Set();
  while(stack.length){
    const [cx,cy]=stack.pop();
    const key=`${cx},${cy}`;
    if(visited.has(key)) continue;
    if(cx<0||cy<0||cx>=gridCols||cy>=gridRows) continue;
    if(isFrameCell(cx,cy)) continue;
    if(playbookGrid[cy][cx]!==targetColor) continue;
    visited.add(key);
    playbookGrid[cy][cx]=paintColor;
    drawCell(ctx,cx,cy,paintColor);
    stack.push([cx+1,cy],[cx-1,cy],[cx,cy+1],[cx,cy-1]);
  }
  updateStats();
}

const canvas=document.getElementById("mosaic-canvas");
canvas.addEventListener("mousedown",e=>{
  if(!activeTool||!rendered) return;
  e.preventDefault();
  const cell=canvasToCell(e);
  if(!cell) return;
  if(activeTool==="picker"){
    if(isFrameCell(cell.x,cell.y)) return;
    const display=playbookGrid.length?playbookGrid:gridData;
    setPaintColor(display[cell.y][cell.x]);setTool("brush");mobSyncTools();return;
  }
  if(activeTool==="bucket"){floodFill(cell.x,cell.y);updateStats();return;}
  if(activeTool==="brush"){isDrawing=true;saveUndo();brushAt(cell.x,cell.y);return;}
  if(activeTool==="mask"){maskClick(cell.x,cell.y,e);return;}
  if(activeTool==="smartsel"){smartSelectClick(cell.x,cell.y,e.ctrlKey||e.metaKey);return;}
  if(activeTool==="swap"){swapClick(cell.x,cell.y);return;}
  if(activeTool==="region"){
    regionDrag={x:cell.x,y:cell.y};
    drawSelectionRect(cell.x,cell.y,cell.x+1,cell.y+1);
  }
});
canvas.addEventListener("mousemove",e=>{
  if(activeTool==="brush"&&isDrawing){const cell=canvasToCell(e);if(cell) brushAt(cell.x,cell.y);return;}
  if(activeTool==="region"&&regionDrag){
    const cell=canvasToCell(e);
    if(cell){
      const s=normSel(regionDrag.x,regionDrag.y,cell.x,cell.y);
      drawSelectionRect(s.x0,s.y0,s.x1,s.y1);
    }
  }
});
canvas.addEventListener("mouseup",e=>{
  if(activeTool==="brush"&&isDrawing){isDrawing=false;updateStats();return;}
  if(activeTool==="region"&&regionDrag){
    const cell=canvasToCell(e);
    if(cell){
      const s=normSel(regionDrag.x,regionDrag.y,cell.x,cell.y);
      if(s.x1-s.x0>=1&&s.y1-s.y0>=1){
        openRegionOverlay(s);
      }
    }
    regionDrag=null;
  }
});
canvas.addEventListener("mouseleave",e=>{
  if(activeTool==="brush"&&isDrawing){isDrawing=false;updateStats();}
  if(activeTool==="region") regionDrag=null;
});
canvas.addEventListener("touchstart",e=>{
  if(!activeTool||!rendered) return;e.preventDefault();
  const touch=e.touches[0];const cell=canvasToCell(touch);if(!cell) return;
  if(activeTool==="picker"){
    if(isFrameCell(cell.x,cell.y)) return;
    const display=playbookGrid.length?playbookGrid:gridData;
    setPaintColor(display[cell.y][cell.x]);setTool("brush");mobSyncTools();return;
  }
  if(activeTool==="swap"){swapClick(cell.x,cell.y);return;}
  if(activeTool==="smartsel"){smartSelectClick(cell.x,cell.y,false);return;}
  if(activeTool==="mask"){maskClick(cell.x,cell.y,e);return;}
  if(activeTool==="bucket"){floodFill(cell.x,cell.y);updateStats();return;}
  if(activeTool==="brush"){isDrawing=true;saveUndo();brushAt(cell.x,cell.y);return;}
  if(activeTool==="region"){regionDrag={x:cell.x,y:cell.y};drawSelectionRect(cell.x,cell.y,cell.x+1,cell.y+1);}
},{passive:false});
canvas.addEventListener("touchmove",e=>{
  e.preventDefault();
  const touch=e.touches[0];const cell=canvasToCell(touch);if(!cell) return;
  if(activeTool==="brush"&&isDrawing){brushAt(cell.x,cell.y);return;}
  if(activeTool==="region"&&regionDrag){
    const s=normSel(regionDrag.x,regionDrag.y,cell.x,cell.y);
    drawSelectionRect(s.x0,s.y0,s.x1,s.y1);
  }
},{passive:false});
canvas.addEventListener("touchend",e=>{
  if(activeTool==="brush"&&isDrawing){isDrawing=false;updateStats();return;}
  if(activeTool==="region"&&regionDrag){
    const touch=e.changedTouches[0];const cell=canvasToCell(touch);
    if(cell){
      const s=normSel(regionDrag.x,regionDrag.y,cell.x,cell.y);
      if(s.x1-s.x0>=1&&s.y1-s.y0>=1) openRegionOverlay(s);
    }
    regionDrag=null;
  }
});

// ── PAINT COLOUR POPUP ───────────────────────────────────────────────────────
function setPaintColor(hex) {
  paintColor=hex;
  const found=LEGO_COLORS.find(c=>c.hex===hex);
  paintColorName=found?found.name:hex;
  document.getElementById("paint-color-swatch").style.background=hex;
  document.getElementById("paint-color-name").textContent=paintColorName;
  document.querySelectorAll(".picker-swatch").forEach(s=>s.classList.toggle("selected",s.dataset.hex===hex));
  updateMobActiveSwatch();
}
function buildPickerPopup() {
  const container=document.getElementById("picker-swatches");
  container.innerHTML="";
  LEGO_COLORS.forEach(c=>{
    const div=document.createElement("div");
    div.className="picker-swatch"+(c.hex===paintColor?" selected":"");
    div.style.background=c.hex;div.dataset.hex=c.hex;div.title=c.name;
    div.onclick=e=>{e.stopPropagation();setPaintColor(c.hex);closeColorPicker();};
    container.appendChild(div);
  });
}
function toggleColorPicker(e) {
  e.stopPropagation();
  const popup=document.getElementById("color-picker-popup");
  if(popup.classList.contains("show")){closeColorPicker();return;}
  buildPickerPopup();
  const swatch=document.getElementById("paint-color-swatch");
  const rect=swatch.getBoundingClientRect();
  popup.style.top=(rect.bottom+6)+"px";popup.style.left=rect.left+"px";
  popup.classList.add("show");
}
function closeColorPicker() {document.getElementById("color-picker-popup").classList.remove("show");}

// ── ZOOM ─────────────────────────────────────────────────────────────────────
function applyZoom() {
  const scale=ZOOM_STEPS[zoomLevel];
  const inner=document.getElementById("canvas-inner");
  const viewport=document.getElementById("canvas-viewport");
  const pct=Math.round(scale*100)+"%";
  const canvas=document.getElementById("mosaic-canvas");
  const scaledW=canvas.width*scale,scaledH=canvas.height*scale;
  inner.style.transform=`scale(${scale})`;
  inner.style.transformOrigin="top left";
  inner.style.width=scaledW+"px";inner.style.height=scaledH+"px";
  document.getElementById("zoom-label-tb").textContent=pct;
  document.getElementById("zoom-label").textContent=pct;
  const mobZoom = document.getElementById("mob-zoom-label");
  if(mobZoom) mobZoom.textContent=pct;
  const areaW=viewport.clientWidth,areaH=viewport.clientHeight;
  viewport.style.justifyContent=scaledW<=areaW?"center":"flex-start";
  viewport.style.alignItems=scaledH<=areaH?"center":"flex-start";
  // Show grab cursor on desktop when canvas is larger than viewport (pannable)
  const canPan = scaledW > areaW || scaledH > areaH;
  if(!activeTool && canPan) viewport.style.cursor = 'grab';
  else viewport.style.cursor = '';
}
function changeZoom(dir) {zoomLevel=Math.max(0,Math.min(ZOOM_STEPS.length-1,zoomLevel+dir));applyZoom();updateCanvasWheelListener();}
function resetZoom() {
  const viewport=document.getElementById("canvas-viewport");
  const canvas=document.getElementById("mosaic-canvas");
  if(!canvas.width) return;
  const fitScale=Math.min((viewport.clientWidth-32)/canvas.width,(viewport.clientHeight-32)/canvas.height);
  let best=ZOOM_DEFAULT,bestDiff=Infinity;
  ZOOM_STEPS.forEach((s,i)=>{const d=Math.abs(s-fitScale);if(d<bestDiff){bestDiff=d;best=i;}});
  zoomLevel=best;applyZoom();updateCanvasWheelListener();
}
function initZoom() {zoomLevel=ZOOM_DEFAULT;document.getElementById("zoom-controls").classList.add("show");setTimeout(resetZoom,80);}

// ── DESKTOP DRAG-TO-PAN ───────────────────────────────────────────────────────
(function() {
  const vp = document.getElementById('canvas-viewport');
  if(!vp) return;
  vp.addEventListener('mousedown', e => {
    if(!rendered) return;
    // Only pan when zoomed in (scrollable) and not using a drawing tool
    if(activeTool && activeTool !== 'pan') return;
    const scaledW = document.getElementById('canvas-inner').offsetWidth;
    const scaledH = document.getElementById('canvas-inner').offsetHeight;
    if(scaledW <= vp.clientWidth && scaledH <= vp.clientHeight) return; // not zoomed enough to pan
    isPanning = true;
    panStartX = e.clientX;
    panStartY = e.clientY;
    panScrollX = vp.scrollLeft;
    panScrollY = vp.scrollTop;
    vp.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mousemove', e => {
    if(!isPanning) return;
    vp.scrollLeft = panScrollX - (e.clientX - panStartX);
    vp.scrollTop  = panScrollY - (e.clientY - panStartY);
  });
  window.addEventListener('mouseup', () => {
    if(!isPanning) return;
    isPanning = false;
    vp.style.cursor = '';
  });
})();

// ── MOBILE PAN TOOL ───────────────────────────────────────────────────────────
(function() {
  const canvas = document.getElementById('mosaic-canvas');
  if(!canvas) return;
  // Track pinch distance
  var pinchStartDist = null;
  var pinchStartZoom = null;

  function getTouchDist(e) {
    var dx = e.touches[0].clientX - e.touches[1].clientX;
    var dy = e.touches[0].clientY - e.touches[1].clientY;
    return Math.sqrt(dx*dx + dy*dy);
  }

  canvas.addEventListener('touchstart', e => {
    if(e.touches.length === 2) {
      // Two fingers — start pinch
      pinchStartDist = getTouchDist(e);
      pinchStartZoom = zoomLevel;
      e.preventDefault();
      return;
    }
    if(activeTool !== 'pan') return;
    const t = e.touches[0];
    mobPanActive = true;
    mobPanLastX = t.clientX;
    mobPanLastY = t.clientY;
    e.preventDefault();
  }, {passive:false});

  canvas.addEventListener('touchmove', e => {
    if(e.touches.length === 2 && pinchStartDist !== null) {
      e.preventDefault();
      var dist = getTouchDist(e);
      var scale = dist / pinchStartDist;
      var newZoom = pinchStartZoom;
      if(scale > 1.15) newZoom = Math.min(ZOOM_STEPS.length - 1, pinchStartZoom + Math.floor((scale - 1) / 0.15));
      if(scale < 0.85) newZoom = Math.max(0, pinchStartZoom - Math.floor((1 - scale) / 0.15));

      if(newZoom !== zoomLevel) {
        var pvp = document.getElementById('canvas-viewport');

        // Pinch centre in viewport coordinates
        var pinchX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var pinchY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        var vpRect = pvp.getBoundingClientRect();
        var pinchVpX = pinchX - vpRect.left; // relative to viewport
        var pinchVpY = pinchY - vpRect.top;

        // Convert pinch point to canvas coordinates (before zoom)
        var oldScale = ZOOM_STEPS[zoomLevel];
        var canvasX = (pvp.scrollLeft + pinchVpX) / oldScale;
        var canvasY = (pvp.scrollTop  + pinchVpY) / oldScale;

        // Apply new zoom
        zoomLevel = newZoom;
        applyZoom();
        updateCanvasWheelListener();

        // Scroll so the same canvas point is under the pinch centre
        var newScale = ZOOM_STEPS[zoomLevel];
        pvp.scrollLeft = canvasX * newScale - pinchVpX;
        pvp.scrollTop  = canvasY * newScale - pinchVpY;
      }
      return;
    }
    if(!mobPanActive || activeTool !== 'pan') return;
    const t = e.touches[0];
    const vp = document.getElementById('canvas-viewport');
    if(!vp) return;
    vp.scrollLeft -= (t.clientX - mobPanLastX);
    vp.scrollTop  -= (t.clientY - mobPanLastY);
    mobPanLastX = t.clientX;
    mobPanLastY = t.clientY;
    e.preventDefault();
  }, {passive:false});

  canvas.addEventListener('touchend', e => {
    if(e.touches.length < 2) pinchStartDist = null;
    mobPanActive = false;
  });
})();

// Canvas scroll: pan when zoomed, nothing when not zoomed
// Listener is added/removed by updateCanvasWheelListener() called from changeZoom
var _canvasWheelActive = false;
function _canvasIsScrollable() {
  const vp = document.getElementById("canvas-viewport");
  if(!vp) return false;
  return vp.scrollHeight > vp.clientHeight + 2 || vp.scrollWidth > vp.clientWidth + 2;
}
function _canvasPanWheel(e) {
  if(!_canvasIsScrollable()) { updateCanvasWheelListener(); return; }
  e.preventDefault();
  const vp = document.getElementById("canvas-viewport");
  if(vp) { vp.scrollTop += e.deltaY; vp.scrollLeft += e.deltaX; }
}
function updateCanvasWheelListener() {
  const ca = document.getElementById("canvas-area");
  if(!ca) return;
  const scrollable = _canvasIsScrollable();
  if(scrollable && !_canvasWheelActive) {
    ca.addEventListener('wheel', _canvasPanWheel, {passive:false});
    _canvasWheelActive = true;
  } else if(!scrollable && _canvasWheelActive) {
    ca.removeEventListener('wheel', _canvasPanWheel);
    _canvasWheelActive = false;
  }
}

// ── CUSTOM PALETTE ────────────────────────────────────────────────────────────
function openPaletteModal() {modalTempColors=new Set(customPaletteColors);buildModalSwatches();document.getElementById("palette-modal-overlay").classList.add("show");}
function closePaletteModal(e) {if(e&&e.target!==document.getElementById("palette-modal-overlay")) return;document.getElementById("palette-modal-overlay").classList.remove("show");}
function buildModalSwatches() {
  const container=document.getElementById("all-lego-swatches");
  container.innerHTML="";
  LEGO_COLORS.forEach(c=>{
    const div=document.createElement("div");
    div.className="modal-swatch"+(modalTempColors.has(c.hex)?" in-custom":"");
    div.style.background=c.hex;div.title=c.name;
    div.onclick=()=>{if(modalTempColors.has(c.hex))modalTempColors.delete(c.hex);else modalTempColors.add(c.hex);div.classList.toggle("in-custom");updateModalPreview();};
    container.appendChild(div);
  });
  updateModalPreview();
}
function updateModalPreview() {
  const preview=document.getElementById("custom-palette-preview");
  document.getElementById("modal-count").textContent=modalTempColors.size;
  preview.innerHTML="";
  if(modalTempColors.size===0){preview.innerHTML='<span style="font-size:10px;color:var(--muted2);align-self:center;">No colours selected yet</span>';return;}
  LEGO_COLORS.filter(c=>modalTempColors.has(c.hex)).forEach(c=>{
    const div=document.createElement("div");
    div.className="custom-preview-swatch";div.style.background=c.hex;div.title=c.name+" — click to remove";
    div.onclick=()=>{modalTempColors.delete(c.hex);buildModalSwatches();};
    preview.appendChild(div);
  });
}
function modalSelectAll() {modalTempColors=new Set(LEGO_COLORS.map(c=>c.hex));buildModalSwatches();}
function applyCustomPalette() {
  if(modalTempColors.size===0){alert("Please select at least one colour.");return;}
  customPaletteColors=new Set(modalTempColors);
  disabledColors=new Set(LEGO_COLORS.map(c=>c.hex).filter(h=>!customPaletteColors.has(h)));
  buildPaletteUI();
  document.getElementById("custom-palette-indicator").style.display="block";
  document.getElementById("custom-palette-count").textContent=customPaletteColors.size;
  document.getElementById("palette-modal-overlay").classList.remove("show");
  if(rendered) doRender();
}
function clearCustomPalette() {
  customPaletteColors=new Set();disabledColors=new Set();buildPaletteUI();
  document.getElementById("custom-palette-indicator").style.display="none";
  if(rendered) doRender();
}

// ── KEYBOARD ─────────────────────────────────────────────────────────────────
document.addEventListener("keydown",e=>{
  if(e.key==="Escape"){
    closeColorPicker();
    document.getElementById("palette-modal-overlay").classList.remove("show");
    closeSmartDesign();
    closeRegionOverlay();
    if(activeTool==="mask"||activeTool==="smartsel"){ setTool(null); mobSyncTools(); closeMaskPanel(); }
    if(activeTool==="swap") closeSwapTool();
  }
  if((e.ctrlKey||e.metaKey)&&e.key==="z"){e.preventDefault();doUndo();}
  if((e.ctrlKey||e.metaKey)&&(e.key==="y"||(e.shiftKey&&e.key==="z"))){e.preventDefault();doRedo();}
  if(!rendered) return;
  if(e.key==="b"||e.key==="B") setTool("brush");
  if(e.key==="g"||e.key==="G") setTool("bucket");
  if(e.key==="i"||e.key==="I") setTool("picker");
  if(e.key==="m"||e.key==="M") setTool("mask");
  if(e.key==="s"||e.key==="S") setTool("smartsel");
  if(e.key==="w"||e.key==="W") setTool("swap");
  if(e.key==="Enter"&&activeTool==="mask") closeMaskPolygon();
  if(e.key==="Escape"&&activeTool==="mask"){cancelMask();setTool(null);}
  if(e.key==="+"||e.key==="=") changeZoom(1);
  if(e.key==="-") changeZoom(-1);
  if(e.key==="0") resetZoom();
});

// ── DOWNLOAD ─────────────────────────────────────────────────────────────────
function downloadPNG() {
  if(!rendered) return;
  const canvas = document.getElementById("mosaic-canvas");
  const dataURL = canvas.toDataURL("image/png");
  // iOS Safari doesn't support programmatic a.click() downloads
  // Use a visible link approach that works cross-platform
  const a = document.createElement("a");
  a.download = "mosaic.png";
  a.href = dataURL;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(()=>{ document.body.removeChild(a); }, 100);
}

// ── INIT ─────────────────────────────────────────────────────────────────────
buildResGrid();
buildFilters();
buildAdvancedFilters();
buildPaletteUI();
updateAdj(true);
updateBaseplateUI();
setPaintColor(LEGO_COLORS[0].hex);
initImageSelCanvas();
updateUndoBtn();
updateRedoBtn();
// Show tips on first load after layout settles
setTimeout(()=>{ buildTips(); initMobile(); }, 100);
